{
  "contractName": "ClavesAngelicae",
  "abi": [
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "name_",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "symbol_",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "baseURI_",
          "type": "string"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "approved",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "ApprovalForAll",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "spell",
          "type": "string"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "to",
          "type": "address"
        }
      ],
      "name": "Mint",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "MAX_SUPPLY",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "PRICE",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getApproved",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        }
      ],
      "name": "isApprovedForAll",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "ownerOf",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "safeTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "_data",
          "type": "bytes"
        }
      ],
      "name": "safeTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "setApprovalForAll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "tokenIdToSpell",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "tokenURI",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "spell_",
          "type": "string"
        },
        {
          "internalType": "uint256",
          "name": "tokenId_",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "to_",
          "type": "address"
        }
      ],
      "name": "mintReserved",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "spell_",
          "type": "string"
        }
      ],
      "name": "mint",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function",
      "payable": true
    },
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "str_",
          "type": "string"
        }
      ],
      "name": "verifySpell",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "pure",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "salePrice_",
          "type": "uint256"
        }
      ],
      "name": "royaltyInfo",
      "outputs": [
        {
          "internalType": "address",
          "name": "receiver",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "donationAmount",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to_",
          "type": "address"
        }
      ],
      "name": "setDonationAddress",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "percent_",
          "type": "uint256"
        }
      ],
      "name": "setDonationPercent",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    }
  ],
  "metadata": "{\"compiler\":{\"version\":\"0.8.10+commit.fc410830\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[{\"internalType\":\"string\",\"name\":\"name_\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"symbol_\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"baseURI_\",\"type\":\"string\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"approved\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"Approval\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"operator\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"bool\",\"name\":\"approved\",\"type\":\"bool\"}],\"name\":\"ApprovalForAll\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"string\",\"name\":\"spell\",\"type\":\"string\"},{\"indexed\":false,\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"}],\"name\":\"Mint\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"previousOwner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"OwnershipTransferred\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"Transfer\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"MAX_SUPPLY\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"PRICE\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"approve\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"}],\"name\":\"balanceOf\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"getApproved\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"operator\",\"type\":\"address\"}],\"name\":\"isApprovedForAll\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"string\",\"name\":\"spell_\",\"type\":\"string\"}],\"name\":\"mint\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"string\",\"name\":\"spell_\",\"type\":\"string\"},{\"internalType\":\"uint256\",\"name\":\"tokenId_\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"to_\",\"type\":\"address\"}],\"name\":\"mintReserved\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"name\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"ownerOf\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"renounceOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId_\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"salePrice_\",\"type\":\"uint256\"}],\"name\":\"royaltyInfo\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"receiver\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"donationAmount\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"safeTransferFrom\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"},{\"internalType\":\"bytes\",\"name\":\"_data\",\"type\":\"bytes\"}],\"name\":\"safeTransferFrom\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"operator\",\"type\":\"address\"},{\"internalType\":\"bool\",\"name\":\"approved\",\"type\":\"bool\"}],\"name\":\"setApprovalForAll\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"to_\",\"type\":\"address\"}],\"name\":\"setDonationAddress\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"percent_\",\"type\":\"uint256\"}],\"name\":\"setDonationPercent\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes4\",\"name\":\"interfaceId\",\"type\":\"bytes4\"}],\"name\":\"supportsInterface\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"symbol\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"name\":\"tokenIdToSpell\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"tokenURI\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"totalSupply\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"transferFrom\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"transferOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"string\",\"name\":\"str_\",\"type\":\"string\"}],\"name\":\"verifySpell\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"pure\",\"type\":\"function\"}],\"devdoc\":{\"kind\":\"dev\",\"methods\":{\"approve(address,uint256)\":{\"details\":\"See {IERC721-approve}.\"},\"balanceOf(address)\":{\"details\":\"See {IERC721-balanceOf}.\"},\"getApproved(uint256)\":{\"details\":\"See {IERC721-getApproved}.\"},\"isApprovedForAll(address,address)\":{\"details\":\"See {IERC721-isApprovedForAll}.\"},\"name()\":{\"details\":\"See {IERC721Metadata-name}.\"},\"owner()\":{\"details\":\"Returns the address of the current owner.\"},\"ownerOf(uint256)\":{\"details\":\"See {IERC721-ownerOf}.\"},\"renounceOwnership()\":{\"details\":\"Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner.\"},\"royaltyInfo(uint256,uint256)\":{\"details\":\"Called with the sale price to determine how much royalty is owed and to whom.\",\"params\":{\"salePrice_\":\"- the sale price of the NFT asset specified by `tokenId`\",\"tokenId_\":\"- the NFT asset queried for royalty information\"},\"returns\":{\"donationAmount\":\"- the royalty payment amount for `salePrice`\",\"receiver\":\"- address of who should be sent the royalty payment\"}},\"safeTransferFrom(address,address,uint256)\":{\"details\":\"See {IERC721-safeTransferFrom}.\"},\"safeTransferFrom(address,address,uint256,bytes)\":{\"details\":\"See {IERC721-safeTransferFrom}.\"},\"setApprovalForAll(address,bool)\":{\"details\":\"See {IERC721-setApprovalForAll}.\"},\"symbol()\":{\"details\":\"See {IERC721Metadata-symbol}.\"},\"tokenURI(uint256)\":{\"details\":\"See {IERC721Metadata-tokenURI}.\"},\"transferFrom(address,address,uint256)\":{\"details\":\"See {IERC721-transferFrom}.\"},\"transferOwnership(address)\":{\"details\":\"Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner.\"}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{},\"version\":1}},\"settings\":{\"compilationTarget\":{\"project:/contracts/ClavesAngelicae.sol\":\"ClavesAngelicae\"},\"evmVersion\":\"london\",\"libraries\":{},\"metadata\":{\"bytecodeHash\":\"ipfs\"},\"optimizer\":{\"enabled\":true,\"runs\":200},\"remappings\":[]},\"sources\":{\"@openzeppelin/contracts/access/Ownable.sol\":{\"keccak256\":\"0xa1b27b3f44ff825974e5268e8f63ad3b03add5b464880d860fbb8cae043e17f7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://ad0fb4425453220f15bdb8c4e009052839804bb725797b6d8c02ee2271bc3c23\",\"dweb:/ipfs/QmPtjdMxzEifPUEUa6cKX1yfTWjaZV6QtdwMdN6bEL9FBM\"]},\"@openzeppelin/contracts/interfaces/IERC165.sol\":{\"keccak256\":\"0x1c03990345fa1982a0bfb5b222cf14fcd2b7a1a396144e0856c84474031a0138\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://0b57b859bcff05010c78dafa106aca4901d3529bc7fb6e36a1bd11afff1110a0\",\"dweb:/ipfs/QmYUPuLQnm3WZ3JfnUsSi79RFo5axTsCJG3aaz8XcuyBu7\"]},\"@openzeppelin/contracts/interfaces/IERC2981.sol\":{\"keccak256\":\"0x489f804c99422bdff8cd95fa233b04393aa93663c119886c76af94f234f6085c\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://69b20e14c6cab9b6a385e687da88d2bd22b8b15c2e14fb49935f4feec0ddf11e\",\"dweb:/ipfs/QmdgSexp4qiwZgjH5CKoMkJUVmDHhbWF1hzA172SVK9Ecs\"]},\"@openzeppelin/contracts/token/ERC721/ERC721.sol\":{\"keccak256\":\"0x1ba5cf152c15dc0c785310feeb61e1f74387fc7bdc2aba5d90733f791606d4bf\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://38db14c62d6431df042a7ca07fd021ea52ccdbd03f0be2b5c4ab034a56126d38\",\"dweb:/ipfs/QmbCHTCLP6bz8omQXrP8VuxFGdK9Hh3jqfrSTr38WNpTk4\"]},\"@openzeppelin/contracts/token/ERC721/IERC721.sol\":{\"keccak256\":\"0x872ba21af7c1f0ae04a715beca31e8fcac764d6c8762940b0fe1bfb6ed8e86f4\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://497017741d74878b56a67ad51e98061bd9ec0e6e4fdbfef0e2ab51523f4c16de\",\"dweb:/ipfs/QmWfkpRHksy8jFywqYxdmMqdkQ1hxrGTPoNBXbZ48zTvyv\"]},\"@openzeppelin/contracts/token/ERC721/IERC721Receiver.sol\":{\"keccak256\":\"0x483b106386dd309f168672928252a19f30c30efb4d17d4b8e2b0f587ca784a11\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://189a39d066c6886ddbe86c79bb36d6cbe66e98bc6a94956e28f5503dae4ad406\",\"dweb:/ipfs/QmT3s3PwCdXqHLJk26kcnedrRGTC9T18z52i9Be7PV9ppc\"]},\"@openzeppelin/contracts/token/ERC721/extensions/IERC721Metadata.sol\":{\"keccak256\":\"0x6052c25b1021f2b0e733fb52ca11948cb2f08cb66076397507243a6e8a8d7776\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://32ac4547a76b28021a007853958284aa8a15a64f1aeec83cb797b7fd60a46b56\",\"dweb:/ipfs/QmTJWQF8j586oaYNpdZv55xnzyHVQc68XN4eBNeiLbKX8d\"]},\"@openzeppelin/contracts/utils/Address.sol\":{\"keccak256\":\"0x9944d1038f27dcebff810d7ba16b3b8058b967173d76874fb72dd7cd84129656\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://7c455cda07c5f8978c57e545ddde382552d3a55b6e3682e0f809ed07ec7defbe\",\"dweb:/ipfs/QmXkoKbxyMcMzjYdkXi5t4t3ZjBQ81pj7AaanS9jhePxyt\"]},\"@openzeppelin/contracts/utils/Context.sol\":{\"keccak256\":\"0x7736c187e6f1358c1ea9350a2a21aa8528dec1c2f43b374a9067465a3a51f5d3\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://4fd625dca17657403af518cc6c8ab5c54c58898cf6e912ca2e1b0f3194ad0405\",\"dweb:/ipfs/QmQVv7YeeKmaS11bg7YDTeeGDk6i7sV8LMMfohaLM4SiRu\"]},\"@openzeppelin/contracts/utils/Counters.sol\":{\"keccak256\":\"0x74f630d2664c1581a1cbd0730d4ba119b3a184ef90c65f3a934be4d16d0e58a1\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://cadad0b133129f946a53e0f61fa387803ccdc010d9c794da0738bb7fc5001b66\",\"dweb:/ipfs/QmQdTBpUT9WgDuCm7womDFiAnksepw6Fmi5Z5vv1H17Qr1\"]},\"@openzeppelin/contracts/utils/Strings.sol\":{\"keccak256\":\"0x5fa25f305839292fab713256214f2868e0257d29826b14282bbd7f1e34f5af38\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://b3de4074848249e00e1336db857e3fa8f78b4fe11d4a887f71050c22023b2132\",\"dweb:/ipfs/QmbL6k2zFGndQPNPG7vCDivtjKam3quJSrEbRuVsNo4hBw\"]},\"@openzeppelin/contracts/utils/introspection/ERC165.sol\":{\"keccak256\":\"0x905cd0ecd91d1de79a4679d745b79cf852ca8ccda5d25d1c49c6bd17a5edc0cf\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://8dd1601fcd370546d8c06ea1902d7e7364fc490fbf0ebc3004230ef1f5db473c\",\"dweb:/ipfs/Qmb8zbC3TjWFtcuyP3KEEaegMkPcfeKAcPrwzvkAoMR3cZ\"]},\"@openzeppelin/contracts/utils/introspection/ERC165Storage.sol\":{\"keccak256\":\"0xebc916c550fdcdf8c5f43c4a5a1ddcc31561c9075dab2e0d11189c9ac694e2c2\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://4bb2cb16ef3d135c1f6c98bb31b062d3dcd7307d6a7d205e97b22b2f0f0178d3\",\"dweb:/ipfs/QmPJVB5EQogNNBhwRgTshEbhCewyHRvGJJbj9ERMMLhAsk\"]},\"@openzeppelin/contracts/utils/introspection/IERC165.sol\":{\"keccak256\":\"0x6aa521718bf139b44ce56f194f6aea1d590cacef995b5a84703fb1579fa49be9\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://100f8d367b5e94eb9cb991914f1de133cf272654c0708faa893bbc17a5b35b93\",\"dweb:/ipfs/QmZeBojmgXq821dL1TJKFb58B1FogM9jL3u7hXQ8hTEBKT\"]},\"project:/contracts/ClavesAngelicae.sol\":{\"keccak256\":\"0x2dafdd3d9a5234a7e5c619d6d0997f9ab137f7b6af4c2e64ee6478af42342f8a\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://b6564fe86074d1e1523622c788aaaa6b90ad7577e2220fd709004bc9d1e132bd\",\"dweb:/ipfs/QmUxiw74cBncrPigFB8VWxWSGmbBc84nNFnZJ2sEk63e37\"]}},\"version\":1}",
  "bytecode": "0x61030960088190556602c2ad68fd900060095561044060405260016080908152600260a052600360c052600760e052600b610100819052600c61012052600d61014052600e6101605260116101805260136101a05260156101c05260176101e052601b61020052601d61022052601f61024052602561026052602961028052602f6102a05260436102c05260476102e052605361030052605d61032052606f6103405260de6103605261014d610380526101a26103a0526101bc6103c05261022b6103e05261029a6104005261042092909252620000e09190601e62000325565b50602c80546001600160a01b031916737cf2ebb5ca55a8bd671a020f8bdbaf07f60f26c11790556001602d553480156200011957600080fd5b50604051620025aa380380620025aa8339810160408190526200013c91620004cf565b825183908390620001559060009060208501906200036e565b5080516200016b9060019060208401906200036e565b50505062000188620001826200024260201b60201c565b62000246565b80516200019d90602b9060208401906200036e565b50620001b06380ac58cd60e01b62000298565b620001c263152a902d60e11b62000298565b60005b601e8110156200022157600160296000600b84601e8110620001eb57620001eb62000560565b015481526020810191909152604001600020805460ff191691151591909117905580620002188162000576565b915050620001c5565b5062000239600a6200031c60201b62000f941760201c565b505050620005dd565b3390565b600680546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6001600160e01b03198082161415620002f75760405162461bcd60e51b815260206004820152601c60248201527f4552433136353a20696e76616c696420696e7465726661636520696400000000604482015260640160405180910390fd5b6001600160e01b0319166000908152600760205260409020805460ff19166001179055565b80546001019055565b82601e81019282156200035c579160200282015b828111156200035c578251829061ffff1690559160200191906001019062000339565b506200036a929150620003eb565b5090565b8280546200037c90620005a0565b90600052602060002090601f016020900481019282620003a057600085556200035c565b82601f10620003bb57805160ff19168380011785556200035c565b828001600101855582156200035c579182015b828111156200035c578251825591602001919060010190620003ce565b5b808211156200036a5760008155600101620003ec565b634e487b7160e01b600052604160045260246000fd5b600082601f8301126200042a57600080fd5b81516001600160401b038082111562000447576200044762000402565b604051601f8301601f19908116603f0116810190828211818310171562000472576200047262000402565b816040528381526020925086838588010111156200048f57600080fd5b600091505b83821015620004b3578582018301518183018401529082019062000494565b83821115620004c55760008385830101525b9695505050505050565b600080600060608486031215620004e557600080fd5b83516001600160401b0380821115620004fd57600080fd5b6200050b8783880162000418565b945060208601519150808211156200052257600080fd5b620005308783880162000418565b935060408601519150808211156200054757600080fd5b50620005568682870162000418565b9150509250925092565b634e487b7160e01b600052603260045260246000fd5b60006000198214156200059957634e487b7160e01b600052601160045260246000fd5b5060010190565b600181811c90821680620005b557607f821691505b60208210811415620005d757634e487b7160e01b600052602260045260246000fd5b50919050565b611fbd80620005ed6000396000f3fe6080604052600436106101815760003560e01c8063715018a6116100d157806395d89b411161008a578063c87b56dd11610064578063c87b56dd1461046d578063d85d3d271461048d578063e985e9c5146104a0578063f2fde38b146104e957600080fd5b806395d89b4114610418578063a22cb4651461042d578063b88d4fde1461044d57600080fd5b8063715018a61461036f5780637649d3cb1461038457806387a89091146103a45780638d859f3e146103c45780638da5cb5b146103da5780638e67b39a146103f857600080fd5b806323b872dd1161013e57806342842e0e1161011857806342842e0e146102ef5780636352211e1461030f5780636f48e79b1461032f57806370a082311461034f57600080fd5b806323b872dd1461027a5780632a55205a1461029a57806332cb6b0c146102d957600080fd5b806301ffc9a71461018657806306fdde03146101bb578063081812fc146101dd578063095ea7b31461021557806318160ddd146102375780631aae9e031461025a575b600080fd5b34801561019257600080fd5b506101a66101a1366004611974565b610509565b60405190151581526020015b60405180910390f35b3480156101c757600080fd5b506101d0610534565b6040516101b291906119e9565b3480156101e957600080fd5b506101fd6101f83660046119fc565b6105c6565b6040516001600160a01b0390911681526020016101b2565b34801561022157600080fd5b50610235610230366004611a31565b610653565b005b34801561024357600080fd5b5061024c610769565b6040519081526020016101b2565b34801561026657600080fd5b506101d06102753660046119fc565b610779565b34801561028657600080fd5b50610235610295366004611a5b565b610813565b3480156102a657600080fd5b506102ba6102b5366004611a97565b610844565b604080516001600160a01b0390931683526020830191909152016101b2565b3480156102e557600080fd5b5061024c60085481565b3480156102fb57600080fd5b5061023561030a366004611a5b565b6108cf565b34801561031b57600080fd5b506101fd61032a3660046119fc565b6108ea565b34801561033b57600080fd5b5061023561034a366004611ab9565b610961565b34801561035b57600080fd5b5061024c61036a366004611ab9565b6109ad565b34801561037b57600080fd5b50610235610a34565b34801561039057600080fd5b506101a661039f366004611b80565b610a6a565b3480156103b057600080fd5b506102356103bf3660046119fc565b610b3a565b3480156103d057600080fd5b5061024c60095481565b3480156103e657600080fd5b506006546001600160a01b03166101fd565b34801561040457600080fd5b50610235610413366004611bb5565b610b69565b34801561042457600080fd5b506101d0610c52565b34801561043957600080fd5b50610235610448366004611c0c565b610c61565b34801561045957600080fd5b50610235610468366004611c48565b610c70565b34801561047957600080fd5b506101d06104883660046119fc565b610ca8565b61023561049b366004611b80565b610d73565b3480156104ac57600080fd5b506101a66104bb366004611cc4565b6001600160a01b03918216600090815260056020908152604080832093909416825291909152205460ff1690565b3480156104f557600080fd5b50610235610504366004611ab9565b610ef9565b60006001600160e01b0319821663152a902d60e11b148061052e575061052e82610f9d565b92915050565b60606000805461054390611cee565b80601f016020809104026020016040519081016040528092919081815260200182805461056f90611cee565b80156105bc5780601f10610591576101008083540402835291602001916105bc565b820191906000526020600020905b81548152906001019060200180831161059f57829003601f168201915b5050505050905090565b60006105d182610fce565b6106375760405162461bcd60e51b815260206004820152602c60248201527f4552433732313a20617070726f76656420717565727920666f72206e6f6e657860448201526b34b9ba32b73a103a37b5b2b760a11b60648201526084015b60405180910390fd5b506000908152600460205260409020546001600160a01b031690565b600061065e826108ea565b9050806001600160a01b0316836001600160a01b031614156106cc5760405162461bcd60e51b815260206004820152602160248201527f4552433732313a20617070726f76616c20746f2063757272656e74206f776e656044820152603960f91b606482015260840161062e565b336001600160a01b03821614806106e857506106e881336104bb565b61075a5760405162461bcd60e51b815260206004820152603860248201527f4552433732313a20617070726f76652063616c6c6572206973206e6f74206f7760448201527f6e6572206e6f7220617070726f76656420666f7220616c6c0000000000000000606482015260840161062e565b6107648383610feb565b505050565b6000610774600a5490565b905090565b602a602052600090815260409020805461079290611cee565b80601f01602080910402602001604051908101604052809291908181526020018280546107be90611cee565b801561080b5780601f106107e05761010080835404028352916020019161080b565b820191906000526020600020905b8154815290600101906020018083116107ee57829003601f168201915b505050505081565b61081d3382611059565b6108395760405162461bcd60e51b815260040161062e90611d29565b610764838383611143565b60008061085084610fce565b61089c5760405162461bcd60e51b815260206004820152601c60248201527f4552433732313a204e6f6e6578697374656e7420546f6b656e20494400000000604482015260640161062e565b602c54602d546001600160a01b0390911692506064906108bc9085611d90565b6108c69190611dc5565b90509250929050565b61076483838360405180602001604052806000815250610c70565b6000818152600260205260408120546001600160a01b03168061052e5760405162461bcd60e51b815260206004820152602960248201527f4552433732313a206f776e657220717565727920666f72206e6f6e657869737460448201526832b73a103a37b5b2b760b91b606482015260840161062e565b6006546001600160a01b0316331461098b5760405162461bcd60e51b815260040161062e90611dd9565b602c80546001600160a01b0319166001600160a01b0392909216919091179055565b60006001600160a01b038216610a185760405162461bcd60e51b815260206004820152602a60248201527f4552433732313a2062616c616e636520717565727920666f7220746865207a65604482015269726f206164647265737360b01b606482015260840161062e565b506001600160a01b031660009081526003602052604090205490565b6006546001600160a01b03163314610a5e5760405162461bcd60e51b815260040161062e90611dd9565b610a6860006112e3565b565b80516000908290600a8114610a83575060009392505050565b60005b81811015610b2f576000838281518110610aa257610aa2611e0e565b01602001516001600160f81b0319169050606160f81b8110801590610ad55750603d60f91b6001600160f81b0319821611155b158015610b0b5750600360fc1b6001600160f81b0319821610801590610b095750603960f81b6001600160f81b0319821611155b155b15610b1c5750600095945050505050565b5080610b2781611e24565b915050610a86565b506001949350505050565b6006546001600160a01b03163314610b645760405162461bcd60e51b815260040161062e90611dd9565b602d55565b6006546001600160a01b03163314610b935760405162461bcd60e51b815260040161062e90611dd9565b610b9c82610fce565b15610be95760405162461bcd60e51b815260206004820152601f60248201527f4552433732313a20546f6b656e20494420616c7265616479206d696e74656400604482015260640161062e565b60008281526029602052604090205460ff16610c475760405162461bcd60e51b815260206004820152601d60248201527f4552433732313a20546f6b656e204944206e6f74207265736572766564000000604482015260640161062e565b610764838383611335565b60606001805461054390611cee565b610c6c3383836113f3565b5050565b610c7a3383611059565b610c965760405162461bcd60e51b815260040161062e90611d29565b610ca2848484846114c2565b50505050565b6060610cb382610fce565b610d175760405162461bcd60e51b815260206004820152602f60248201527f4552433732314d657461646174613a2055524920717565727920666f72206e6f60448201526e3732bc34b9ba32b73a103a37b5b2b760891b606482015260840161062e565b6000610d216114f5565b90506000815111610d415760405180602001604052806000815250610d6c565b80610d4b84611504565b604051602001610d5c929190611e3f565b6040516020818303038152906040525b9392505050565b600954341015610dbc5760405162461bcd60e51b81526020600482015260146024820152734d7573742070617920666f72206d696e74696e6760601b604482015260640161062e565b60005b50600a5460008181526029602052604090205460ff1680610de45750610de481610fce565b15610e4857610df7600a80546001019055565b600854600a541115610e435760405162461bcd60e51b8152602060048201526015602482015274151bdad95b8814dd5c1c1b1e4811195c1b195d1959605a1b604482015260640161062e565b610dbf565b6000610e5c6006546001600160a01b031690565b6001600160a01b03163460405160006040518083038185875af1925050503d8060008114610ea6576040519150601f19603f3d011682016040523d82523d6000602084013e610eab565b606091505b5050905080610eee5760405162461bcd60e51b815260206004820152600f60248201526e151c985b9cd9995c8811985a5b1959608a1b604482015260640161062e565b610764838333611335565b6006546001600160a01b03163314610f235760405162461bcd60e51b815260040161062e90611dd9565b6001600160a01b038116610f885760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b606482015260840161062e565b610f91816112e3565b50565b80546001019055565b6000610fa882611602565b8061052e5750506001600160e01b03191660009081526007602052604090205460ff1690565b6000908152600260205260409020546001600160a01b0316151590565b600081815260046020526040902080546001600160a01b0319166001600160a01b0384169081179091558190611020826108ea565b6001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b600061106482610fce565b6110c55760405162461bcd60e51b815260206004820152602c60248201527f4552433732313a206f70657261746f7220717565727920666f72206e6f6e657860448201526b34b9ba32b73a103a37b5b2b760a11b606482015260840161062e565b60006110d0836108ea565b9050806001600160a01b0316846001600160a01b0316148061110b5750836001600160a01b0316611100846105c6565b6001600160a01b0316145b8061113b57506001600160a01b0380821660009081526005602090815260408083209388168352929052205460ff165b949350505050565b826001600160a01b0316611156826108ea565b6001600160a01b0316146111be5760405162461bcd60e51b815260206004820152602960248201527f4552433732313a207472616e73666572206f6620746f6b656e2074686174206960448201526839903737ba1037bbb760b91b606482015260840161062e565b6001600160a01b0382166112205760405162461bcd60e51b8152602060048201526024808201527f4552433732313a207472616e7366657220746f20746865207a65726f206164646044820152637265737360e01b606482015260840161062e565b61122b600082610feb565b6001600160a01b0383166000908152600360205260408120805460019290611254908490611e6e565b90915550506001600160a01b0382166000908152600360205260408120805460019290611282908490611e85565b909155505060008181526002602052604080822080546001600160a01b0319166001600160a01b0386811691821790925591518493918716917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef91a4505050565b600680546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b61133e83610a6a565b61138a5760405162461bcd60e51b815260206004820152601c60248201527f5370656c6c206d757374206265202f5b612d7a302d395d7b31307d2f00000000604482015260640161062e565b6000828152602a6020908152604090912084516113a9928601906118c5565b506113b48183611652565b817f983d37d8751fcfa80e95e5fe2c0f46fb7b541b280961dc7ac00aa2670e2edd8784836040516113e6929190611e9d565b60405180910390a2505050565b816001600160a01b0316836001600160a01b031614156114555760405162461bcd60e51b815260206004820152601960248201527f4552433732313a20617070726f766520746f2063616c6c657200000000000000604482015260640161062e565b6001600160a01b03838116600081815260056020908152604080832094871680845294825291829020805460ff191686151590811790915591519182527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a3505050565b6114cd848484611143565b6114d98484848461166c565b610ca25760405162461bcd60e51b815260040161062e90611ec7565b6060602b805461054390611cee565b6060816115285750506040805180820190915260018152600360fc1b602082015290565b8160005b8115611552578061153c81611e24565b915061154b9050600a83611dc5565b915061152c565b60008167ffffffffffffffff81111561156d5761156d611ad4565b6040519080825280601f01601f191660200182016040528015611597576020820181803683370190505b5090505b841561113b576115ac600183611e6e565b91506115b9600a86611f19565b6115c4906030611e85565b60f81b8183815181106115d9576115d9611e0e565b60200101906001600160f81b031916908160001a9053506115fb600a86611dc5565b945061159b565b60006001600160e01b031982166380ac58cd60e01b148061163357506001600160e01b03198216635b5e139f60e01b145b8061052e57506301ffc9a760e01b6001600160e01b031983161461052e565b610c6c82826040518060200160405280600081525061175f565b60006001600160a01b0384163b15610b2f57604051630a85bd0160e11b81526001600160a01b0385169063150b7a02906116b0903390899088908890600401611f2d565b6020604051808303816000875af19250505080156116eb575060408051601f3d908101601f191682019092526116e891810190611f6a565b60015b611745573d808015611719576040519150601f19603f3d011682016040523d82523d6000602084013e61171e565b606091505b50805161173d5760405162461bcd60e51b815260040161062e90611ec7565b805181602001fd5b6001600160e01b031916630a85bd0160e11b14905061113b565b6117698383611792565b611776600084848461166c565b6107645760405162461bcd60e51b815260040161062e90611ec7565b6001600160a01b0382166117e85760405162461bcd60e51b815260206004820181905260248201527f4552433732313a206d696e7420746f20746865207a65726f2061646472657373604482015260640161062e565b6117f181610fce565b1561183e5760405162461bcd60e51b815260206004820152601c60248201527f4552433732313a20746f6b656e20616c7265616479206d696e74656400000000604482015260640161062e565b6001600160a01b0382166000908152600360205260408120805460019290611867908490611e85565b909155505060008181526002602052604080822080546001600160a01b0319166001600160a01b03861690811790915590518392907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050565b8280546118d190611cee565b90600052602060002090601f0160209004810192826118f35760008555611939565b82601f1061190c57805160ff1916838001178555611939565b82800160010185558215611939579182015b8281111561193957825182559160200191906001019061191e565b50611945929150611949565b5090565b5b80821115611945576000815560010161194a565b6001600160e01b031981168114610f9157600080fd5b60006020828403121561198657600080fd5b8135610d6c8161195e565b60005b838110156119ac578181015183820152602001611994565b83811115610ca25750506000910152565b600081518084526119d5816020860160208601611991565b601f01601f19169290920160200192915050565b602081526000610d6c60208301846119bd565b600060208284031215611a0e57600080fd5b5035919050565b80356001600160a01b0381168114611a2c57600080fd5b919050565b60008060408385031215611a4457600080fd5b611a4d83611a15565b946020939093013593505050565b600080600060608486031215611a7057600080fd5b611a7984611a15565b9250611a8760208501611a15565b9150604084013590509250925092565b60008060408385031215611aaa57600080fd5b50508035926020909101359150565b600060208284031215611acb57600080fd5b610d6c82611a15565b634e487b7160e01b600052604160045260246000fd5b600067ffffffffffffffff80841115611b0557611b05611ad4565b604051601f8501601f19908116603f01168101908282118183101715611b2d57611b2d611ad4565b81604052809350858152868686011115611b4657600080fd5b858560208301376000602087830101525050509392505050565b600082601f830112611b7157600080fd5b610d6c83833560208501611aea565b600060208284031215611b9257600080fd5b813567ffffffffffffffff811115611ba957600080fd5b61113b84828501611b60565b600080600060608486031215611bca57600080fd5b833567ffffffffffffffff811115611be157600080fd5b611bed86828701611b60565b93505060208401359150611c0360408501611a15565b90509250925092565b60008060408385031215611c1f57600080fd5b611c2883611a15565b915060208301358015158114611c3d57600080fd5b809150509250929050565b60008060008060808587031215611c5e57600080fd5b611c6785611a15565b9350611c7560208601611a15565b925060408501359150606085013567ffffffffffffffff811115611c9857600080fd5b8501601f81018713611ca957600080fd5b611cb887823560208401611aea565b91505092959194509250565b60008060408385031215611cd757600080fd5b611ce083611a15565b91506108c660208401611a15565b600181811c90821680611d0257607f821691505b60208210811415611d2357634e487b7160e01b600052602260045260246000fd5b50919050565b60208082526031908201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f6040820152701ddb995c881b9bdc88185c1c1c9bdd9959607a1b606082015260800190565b634e487b7160e01b600052601160045260246000fd5b6000816000190483118215151615611daa57611daa611d7a565b500290565b634e487b7160e01b600052601260045260246000fd5b600082611dd457611dd4611daf565b500490565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b634e487b7160e01b600052603260045260246000fd5b6000600019821415611e3857611e38611d7a565b5060010190565b60008351611e51818460208801611991565b835190830190611e65818360208801611991565b01949350505050565b600082821015611e8057611e80611d7a565b500390565b60008219821115611e9857611e98611d7a565b500190565b604081526000611eb060408301856119bd565b905060018060a01b03831660208301529392505050565b60208082526032908201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560408201527131b2b4bb32b91034b6b83632b6b2b73a32b960711b606082015260800190565b600082611f2857611f28611daf565b500690565b6001600160a01b0385811682528416602082015260408101839052608060608201819052600090611f60908301846119bd565b9695505050505050565b600060208284031215611f7c57600080fd5b8151610d6c8161195e56fea2646970667358221220512a1d37166ceec9defcade84cd4efdfbcc4a909b2ac14e39b94b73ce7ecf88e64736f6c634300080a0033",
  "deployedBytecode": "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",
  "immutableReferences": {},
  "generatedSources": [
    {
      "ast": {
        "nodeType": "YulBlock",
        "src": "0:2915:17",
        "statements": [
          {
            "nodeType": "YulBlock",
            "src": "6:3:17",
            "statements": []
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "46:95:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "63:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "70:3:17",
                            "type": "",
                            "value": "224"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "75:10:17",
                            "type": "",
                            "value": "0x4e487b71"
                          }
                        ],
                        "functionName": {
                          "name": "shl",
                          "nodeType": "YulIdentifier",
                          "src": "66:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "66:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "56:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "56:31:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "56:31:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "103:1:17",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "106:4:17",
                        "type": "",
                        "value": "0x41"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "96:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "96:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "96:15:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "127:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "130:4:17",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "120:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "120:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "120:15:17"
                }
              ]
            },
            "name": "panic_error_0x41",
            "nodeType": "YulFunctionDefinition",
            "src": "14:127:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "210:821:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "259:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "268:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "271:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "261:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "261:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "261:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "238:6:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "246:4:17",
                                "type": "",
                                "value": "0x1f"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "234:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "234:17:17"
                          },
                          {
                            "name": "end",
                            "nodeType": "YulIdentifier",
                            "src": "253:3:17"
                          }
                        ],
                        "functionName": {
                          "name": "slt",
                          "nodeType": "YulIdentifier",
                          "src": "230:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "230:27:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "223:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "223:35:17"
                  },
                  "nodeType": "YulIf",
                  "src": "220:55:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "284:23:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "300:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "294:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "294:13:17"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "288:2:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "316:28:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "334:2:17",
                            "type": "",
                            "value": "64"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "338:1:17",
                            "type": "",
                            "value": "1"
                          }
                        ],
                        "functionName": {
                          "name": "shl",
                          "nodeType": "YulIdentifier",
                          "src": "330:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "330:10:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "342:1:17",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "sub",
                      "nodeType": "YulIdentifier",
                      "src": "326:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "326:18:17"
                  },
                  "variables": [
                    {
                      "name": "_2",
                      "nodeType": "YulTypedName",
                      "src": "320:2:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "367:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x41",
                            "nodeType": "YulIdentifier",
                            "src": "369:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "369:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "369:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "359:2:17"
                      },
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "363:2:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "356:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "356:10:17"
                  },
                  "nodeType": "YulIf",
                  "src": "353:36:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "398:17:17",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "412:2:17",
                        "type": "",
                        "value": "31"
                      }
                    ],
                    "functionName": {
                      "name": "not",
                      "nodeType": "YulIdentifier",
                      "src": "408:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "408:7:17"
                  },
                  "variables": [
                    {
                      "name": "_3",
                      "nodeType": "YulTypedName",
                      "src": "402:2:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "424:23:17",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "444:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "438:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "438:9:17"
                  },
                  "variables": [
                    {
                      "name": "memPtr",
                      "nodeType": "YulTypedName",
                      "src": "428:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "456:71:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "memPtr",
                        "nodeType": "YulIdentifier",
                        "src": "478:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "arguments": [
                                      {
                                        "name": "_1",
                                        "nodeType": "YulIdentifier",
                                        "src": "502:2:17"
                                      },
                                      {
                                        "kind": "number",
                                        "nodeType": "YulLiteral",
                                        "src": "506:4:17",
                                        "type": "",
                                        "value": "0x1f"
                                      }
                                    ],
                                    "functionName": {
                                      "name": "add",
                                      "nodeType": "YulIdentifier",
                                      "src": "498:3:17"
                                    },
                                    "nodeType": "YulFunctionCall",
                                    "src": "498:13:17"
                                  },
                                  {
                                    "name": "_3",
                                    "nodeType": "YulIdentifier",
                                    "src": "513:2:17"
                                  }
                                ],
                                "functionName": {
                                  "name": "and",
                                  "nodeType": "YulIdentifier",
                                  "src": "494:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "494:22:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "518:2:17",
                                "type": "",
                                "value": "63"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "490:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "490:31:17"
                          },
                          {
                            "name": "_3",
                            "nodeType": "YulIdentifier",
                            "src": "523:2:17"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "486:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "486:40:17"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "474:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "474:53:17"
                  },
                  "variables": [
                    {
                      "name": "newFreePtr",
                      "nodeType": "YulTypedName",
                      "src": "460:10:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "586:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x41",
                            "nodeType": "YulIdentifier",
                            "src": "588:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "588:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "588:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "newFreePtr",
                            "nodeType": "YulIdentifier",
                            "src": "545:10:17"
                          },
                          {
                            "name": "_2",
                            "nodeType": "YulIdentifier",
                            "src": "557:2:17"
                          }
                        ],
                        "functionName": {
                          "name": "gt",
                          "nodeType": "YulIdentifier",
                          "src": "542:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "542:18:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "newFreePtr",
                            "nodeType": "YulIdentifier",
                            "src": "565:10:17"
                          },
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "577:6:17"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "562:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "562:22:17"
                      }
                    ],
                    "functionName": {
                      "name": "or",
                      "nodeType": "YulIdentifier",
                      "src": "539:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "539:46:17"
                  },
                  "nodeType": "YulIf",
                  "src": "536:72:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "624:2:17",
                        "type": "",
                        "value": "64"
                      },
                      {
                        "name": "newFreePtr",
                        "nodeType": "YulIdentifier",
                        "src": "628:10:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "617:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "617:22:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "617:22:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "memPtr",
                        "nodeType": "YulIdentifier",
                        "src": "655:6:17"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "663:2:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "648:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "648:18:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "648:18:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "675:14:17",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "685:4:17",
                    "type": "",
                    "value": "0x20"
                  },
                  "variables": [
                    {
                      "name": "_4",
                      "nodeType": "YulTypedName",
                      "src": "679:2:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "735:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "744:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "747:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "737:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "737:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "737:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "712:6:17"
                              },
                              {
                                "name": "_1",
                                "nodeType": "YulIdentifier",
                                "src": "720:2:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "708:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "708:15:17"
                          },
                          {
                            "name": "_4",
                            "nodeType": "YulIdentifier",
                            "src": "725:2:17"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "704:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "704:24:17"
                      },
                      {
                        "name": "end",
                        "nodeType": "YulIdentifier",
                        "src": "730:3:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "701:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "701:33:17"
                  },
                  "nodeType": "YulIf",
                  "src": "698:53:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "760:10:17",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "769:1:17",
                    "type": "",
                    "value": "0"
                  },
                  "variables": [
                    {
                      "name": "i",
                      "nodeType": "YulTypedName",
                      "src": "764:1:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "825:87:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "memPtr",
                                      "nodeType": "YulIdentifier",
                                      "src": "854:6:17"
                                    },
                                    {
                                      "name": "i",
                                      "nodeType": "YulIdentifier",
                                      "src": "862:1:17"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "850:3:17"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "850:14:17"
                                },
                                {
                                  "name": "_4",
                                  "nodeType": "YulIdentifier",
                                  "src": "866:2:17"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "846:3:17"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "846:23:17"
                            },
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "arguments": [
                                        {
                                          "name": "offset",
                                          "nodeType": "YulIdentifier",
                                          "src": "885:6:17"
                                        },
                                        {
                                          "name": "i",
                                          "nodeType": "YulIdentifier",
                                          "src": "893:1:17"
                                        }
                                      ],
                                      "functionName": {
                                        "name": "add",
                                        "nodeType": "YulIdentifier",
                                        "src": "881:3:17"
                                      },
                                      "nodeType": "YulFunctionCall",
                                      "src": "881:14:17"
                                    },
                                    {
                                      "name": "_4",
                                      "nodeType": "YulIdentifier",
                                      "src": "897:2:17"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "877:3:17"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "877:23:17"
                                }
                              ],
                              "functionName": {
                                "name": "mload",
                                "nodeType": "YulIdentifier",
                                "src": "871:5:17"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "871:30:17"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "839:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "839:63:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "839:63:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "790:1:17"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "793:2:17"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "787:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "787:9:17"
                  },
                  "nodeType": "YulForLoop",
                  "post": {
                    "nodeType": "YulBlock",
                    "src": "797:19:17",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "799:15:17",
                        "value": {
                          "arguments": [
                            {
                              "name": "i",
                              "nodeType": "YulIdentifier",
                              "src": "808:1:17"
                            },
                            {
                              "name": "_4",
                              "nodeType": "YulIdentifier",
                              "src": "811:2:17"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "804:3:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "804:10:17"
                        },
                        "variableNames": [
                          {
                            "name": "i",
                            "nodeType": "YulIdentifier",
                            "src": "799:1:17"
                          }
                        ]
                      }
                    ]
                  },
                  "pre": {
                    "nodeType": "YulBlock",
                    "src": "783:3:17",
                    "statements": []
                  },
                  "src": "779:133:17"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "942:59:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "memPtr",
                                      "nodeType": "YulIdentifier",
                                      "src": "971:6:17"
                                    },
                                    {
                                      "name": "_1",
                                      "nodeType": "YulIdentifier",
                                      "src": "979:2:17"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "967:3:17"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "967:15:17"
                                },
                                {
                                  "name": "_4",
                                  "nodeType": "YulIdentifier",
                                  "src": "984:2:17"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "963:3:17"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "963:24:17"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "989:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "956:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "956:35:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "956:35:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "927:1:17"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "930:2:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "924:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "924:9:17"
                  },
                  "nodeType": "YulIf",
                  "src": "921:80:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1010:15:17",
                  "value": {
                    "name": "memPtr",
                    "nodeType": "YulIdentifier",
                    "src": "1019:6:17"
                  },
                  "variableNames": [
                    {
                      "name": "array",
                      "nodeType": "YulIdentifier",
                      "src": "1010:5:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_string_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "184:6:17",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "192:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "array",
                "nodeType": "YulTypedName",
                "src": "200:5:17",
                "type": ""
              }
            ],
            "src": "146:885:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1181:621:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1227:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1236:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1239:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1229:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1229:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1229:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1202:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1211:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "1198:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1198:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1223:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "1194:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1194:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1191:52:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1252:30:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "1272:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "1266:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1266:16:17"
                  },
                  "variables": [
                    {
                      "name": "offset",
                      "nodeType": "YulTypedName",
                      "src": "1256:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1291:28:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1309:2:17",
                            "type": "",
                            "value": "64"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1313:1:17",
                            "type": "",
                            "value": "1"
                          }
                        ],
                        "functionName": {
                          "name": "shl",
                          "nodeType": "YulIdentifier",
                          "src": "1305:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1305:10:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1317:1:17",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "sub",
                      "nodeType": "YulIdentifier",
                      "src": "1301:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1301:18:17"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "1295:2:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1346:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1355:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1358:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1348:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1348:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1348:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "1334:6:17"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "1342:2:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "1331:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1331:14:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1328:34:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1371:71:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1414:9:17"
                          },
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "1425:6:17"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1410:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1410:22:17"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "1434:7:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string_fromMemory",
                      "nodeType": "YulIdentifier",
                      "src": "1381:28:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1381:61:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "1371:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1451:41:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1477:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1488:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1473:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1473:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "1467:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1467:25:17"
                  },
                  "variables": [
                    {
                      "name": "offset_1",
                      "nodeType": "YulTypedName",
                      "src": "1455:8:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1521:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1530:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1533:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1523:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1523:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1523:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset_1",
                        "nodeType": "YulIdentifier",
                        "src": "1507:8:17"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "1517:2:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "1504:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1504:16:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1501:36:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1546:73:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1589:9:17"
                          },
                          {
                            "name": "offset_1",
                            "nodeType": "YulIdentifier",
                            "src": "1600:8:17"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1585:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1585:24:17"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "1611:7:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string_fromMemory",
                      "nodeType": "YulIdentifier",
                      "src": "1556:28:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1556:63:17"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "1546:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1628:41:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1654:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1665:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1650:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1650:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "1644:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1644:25:17"
                  },
                  "variables": [
                    {
                      "name": "offset_2",
                      "nodeType": "YulTypedName",
                      "src": "1632:8:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1698:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1707:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1710:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1700:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1700:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1700:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset_2",
                        "nodeType": "YulIdentifier",
                        "src": "1684:8:17"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "1694:2:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "1681:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1681:16:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1678:36:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1723:73:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1766:9:17"
                          },
                          {
                            "name": "offset_2",
                            "nodeType": "YulIdentifier",
                            "src": "1777:8:17"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1762:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1762:24:17"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "1788:7:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string_fromMemory",
                      "nodeType": "YulIdentifier",
                      "src": "1733:28:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1733:63:17"
                  },
                  "variableNames": [
                    {
                      "name": "value2",
                      "nodeType": "YulIdentifier",
                      "src": "1723:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_string_memory_ptrt_string_memory_ptrt_string_memory_ptr_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1131:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "1142:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1154:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "1162:6:17",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "1170:6:17",
                "type": ""
              }
            ],
            "src": "1036:766:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1839:95:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1856:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1863:3:17",
                            "type": "",
                            "value": "224"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1868:10:17",
                            "type": "",
                            "value": "0x4e487b71"
                          }
                        ],
                        "functionName": {
                          "name": "shl",
                          "nodeType": "YulIdentifier",
                          "src": "1859:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1859:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "1849:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1849:31:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1849:31:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1896:1:17",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1899:4:17",
                        "type": "",
                        "value": "0x32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "1889:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1889:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1889:15:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1920:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1923:4:17",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "1913:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1913:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1913:15:17"
                }
              ]
            },
            "name": "panic_error_0x32",
            "nodeType": "YulFunctionDefinition",
            "src": "1807:127:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1986:185:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2025:111:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2046:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "arguments": [
                                {
                                  "kind": "number",
                                  "nodeType": "YulLiteral",
                                  "src": "2053:3:17",
                                  "type": "",
                                  "value": "224"
                                },
                                {
                                  "kind": "number",
                                  "nodeType": "YulLiteral",
                                  "src": "2058:10:17",
                                  "type": "",
                                  "value": "0x4e487b71"
                                }
                              ],
                              "functionName": {
                                "name": "shl",
                                "nodeType": "YulIdentifier",
                                "src": "2049:3:17"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "2049:20:17"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "2039:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2039:31:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2039:31:17"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2090:1:17",
                              "type": "",
                              "value": "4"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2093:4:17",
                              "type": "",
                              "value": "0x11"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "2083:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2083:15:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2083:15:17"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2118:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2121:4:17",
                              "type": "",
                              "value": "0x24"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "2111:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2111:15:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2111:15:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "2002:5:17"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2013:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "not",
                          "nodeType": "YulIdentifier",
                          "src": "2009:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2009:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "eq",
                      "nodeType": "YulIdentifier",
                      "src": "1999:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1999:17:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1996:140:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2145:20:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "2156:5:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2163:1:17",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "2152:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2152:13:17"
                  },
                  "variableNames": [
                    {
                      "name": "ret",
                      "nodeType": "YulIdentifier",
                      "src": "2145:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "increment_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "1968:5:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "ret",
                "nodeType": "YulTypedName",
                "src": "1978:3:17",
                "type": ""
              }
            ],
            "src": "1939:232:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2350:178:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2367:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2378:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "2360:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2360:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2360:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2401:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2412:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2397:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2397:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2417:2:17",
                        "type": "",
                        "value": "28"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "2390:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2390:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2390:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2440:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2451:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2436:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2436:18:17"
                      },
                      {
                        "hexValue": "4552433136353a20696e76616c696420696e74657266616365206964",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "2456:30:17",
                        "type": "",
                        "value": "ERC165: invalid interface id"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "2429:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2429:58:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2429:58:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2496:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2508:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2519:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "2504:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2504:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "2496:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_282912c0dfceceb28d77d0333f496b83948f9ba5b3154358a8b140b849289dee__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2327:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "2341:4:17",
                "type": ""
              }
            ],
            "src": "2176:352:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2588:325:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "2598:22:17",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2612:1:17",
                        "type": "",
                        "value": "1"
                      },
                      {
                        "name": "data",
                        "nodeType": "YulIdentifier",
                        "src": "2615:4:17"
                      }
                    ],
                    "functionName": {
                      "name": "shr",
                      "nodeType": "YulIdentifier",
                      "src": "2608:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2608:12:17"
                  },
                  "variableNames": [
                    {
                      "name": "length",
                      "nodeType": "YulIdentifier",
                      "src": "2598:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "2629:38:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "data",
                        "nodeType": "YulIdentifier",
                        "src": "2659:4:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2665:1:17",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "and",
                      "nodeType": "YulIdentifier",
                      "src": "2655:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2655:12:17"
                  },
                  "variables": [
                    {
                      "name": "outOfPlaceEncoding",
                      "nodeType": "YulTypedName",
                      "src": "2633:18:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2706:31:17",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "2708:27:17",
                        "value": {
                          "arguments": [
                            {
                              "name": "length",
                              "nodeType": "YulIdentifier",
                              "src": "2722:6:17"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2730:4:17",
                              "type": "",
                              "value": "0x7f"
                            }
                          ],
                          "functionName": {
                            "name": "and",
                            "nodeType": "YulIdentifier",
                            "src": "2718:3:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2718:17:17"
                        },
                        "variableNames": [
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "2708:6:17"
                          }
                        ]
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "outOfPlaceEncoding",
                        "nodeType": "YulIdentifier",
                        "src": "2686:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "2679:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2679:26:17"
                  },
                  "nodeType": "YulIf",
                  "src": "2676:61:17"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2796:111:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2817:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "arguments": [
                                {
                                  "kind": "number",
                                  "nodeType": "YulLiteral",
                                  "src": "2824:3:17",
                                  "type": "",
                                  "value": "224"
                                },
                                {
                                  "kind": "number",
                                  "nodeType": "YulLiteral",
                                  "src": "2829:10:17",
                                  "type": "",
                                  "value": "0x4e487b71"
                                }
                              ],
                              "functionName": {
                                "name": "shl",
                                "nodeType": "YulIdentifier",
                                "src": "2820:3:17"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "2820:20:17"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "2810:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2810:31:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2810:31:17"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2861:1:17",
                              "type": "",
                              "value": "4"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2864:4:17",
                              "type": "",
                              "value": "0x22"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "2854:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2854:15:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2854:15:17"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2889:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2892:4:17",
                              "type": "",
                              "value": "0x24"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "2882:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2882:15:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2882:15:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "outOfPlaceEncoding",
                        "nodeType": "YulIdentifier",
                        "src": "2752:18:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "2775:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2783:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "2772:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2772:14:17"
                      }
                    ],
                    "functionName": {
                      "name": "eq",
                      "nodeType": "YulIdentifier",
                      "src": "2749:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2749:38:17"
                  },
                  "nodeType": "YulIf",
                  "src": "2746:161:17"
                }
              ]
            },
            "name": "extract_byte_array_length",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "data",
                "nodeType": "YulTypedName",
                "src": "2568:4:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "2577:6:17",
                "type": ""
              }
            ],
            "src": "2533:380:17"
          }
        ]
      },
      "contents": "{\n    { }\n    function panic_error_0x41()\n    {\n        mstore(0, shl(224, 0x4e487b71))\n        mstore(4, 0x41)\n        revert(0, 0x24)\n    }\n    function abi_decode_string_fromMemory(offset, end) -> array\n    {\n        if iszero(slt(add(offset, 0x1f), end)) { revert(0, 0) }\n        let _1 := mload(offset)\n        let _2 := sub(shl(64, 1), 1)\n        if gt(_1, _2) { panic_error_0x41() }\n        let _3 := not(31)\n        let memPtr := mload(64)\n        let newFreePtr := add(memPtr, and(add(and(add(_1, 0x1f), _3), 63), _3))\n        if or(gt(newFreePtr, _2), lt(newFreePtr, memPtr)) { panic_error_0x41() }\n        mstore(64, newFreePtr)\n        mstore(memPtr, _1)\n        let _4 := 0x20\n        if gt(add(add(offset, _1), _4), end) { revert(0, 0) }\n        let i := 0\n        for { } lt(i, _1) { i := add(i, _4) }\n        {\n            mstore(add(add(memPtr, i), _4), mload(add(add(offset, i), _4)))\n        }\n        if gt(i, _1)\n        {\n            mstore(add(add(memPtr, _1), _4), 0)\n        }\n        array := memPtr\n    }\n    function abi_decode_tuple_t_string_memory_ptrt_string_memory_ptrt_string_memory_ptr_fromMemory(headStart, dataEnd) -> value0, value1, value2\n    {\n        if slt(sub(dataEnd, headStart), 96) { revert(0, 0) }\n        let offset := mload(headStart)\n        let _1 := sub(shl(64, 1), 1)\n        if gt(offset, _1) { revert(0, 0) }\n        value0 := abi_decode_string_fromMemory(add(headStart, offset), dataEnd)\n        let offset_1 := mload(add(headStart, 32))\n        if gt(offset_1, _1) { revert(0, 0) }\n        value1 := abi_decode_string_fromMemory(add(headStart, offset_1), dataEnd)\n        let offset_2 := mload(add(headStart, 64))\n        if gt(offset_2, _1) { revert(0, 0) }\n        value2 := abi_decode_string_fromMemory(add(headStart, offset_2), dataEnd)\n    }\n    function panic_error_0x32()\n    {\n        mstore(0, shl(224, 0x4e487b71))\n        mstore(4, 0x32)\n        revert(0, 0x24)\n    }\n    function increment_t_uint256(value) -> ret\n    {\n        if eq(value, not(0))\n        {\n            mstore(0, shl(224, 0x4e487b71))\n            mstore(4, 0x11)\n            revert(0, 0x24)\n        }\n        ret := add(value, 1)\n    }\n    function abi_encode_tuple_t_stringliteral_282912c0dfceceb28d77d0333f496b83948f9ba5b3154358a8b140b849289dee__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 28)\n        mstore(add(headStart, 64), \"ERC165: invalid interface id\")\n        tail := add(headStart, 96)\n    }\n    function extract_byte_array_length(data) -> length\n    {\n        length := shr(1, data)\n        let outOfPlaceEncoding := and(data, 1)\n        if iszero(outOfPlaceEncoding) { length := and(length, 0x7f) }\n        if eq(outOfPlaceEncoding, lt(length, 32))\n        {\n            mstore(0, shl(224, 0x4e487b71))\n            mstore(4, 0x22)\n            revert(0, 0x24)\n        }\n    }\n}",
      "id": 17,
      "language": "Yul",
      "name": "#utility.yul"
    }
  ],
  "deployedGeneratedSources": [
    {
      "ast": {
        "nodeType": "YulBlock",
        "src": "0:18700:17",
        "statements": [
          {
            "nodeType": "YulBlock",
            "src": "6:3:17",
            "statements": []
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "58:87:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "123:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "132:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "135:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "125:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "125:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "125:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "81:5:17"
                          },
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "92:5:17"
                              },
                              {
                                "arguments": [
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "103:3:17",
                                    "type": "",
                                    "value": "224"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "108:10:17",
                                    "type": "",
                                    "value": "0xffffffff"
                                  }
                                ],
                                "functionName": {
                                  "name": "shl",
                                  "nodeType": "YulIdentifier",
                                  "src": "99:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "99:20:17"
                              }
                            ],
                            "functionName": {
                              "name": "and",
                              "nodeType": "YulIdentifier",
                              "src": "88:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "88:32:17"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "78:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "78:43:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "71:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "71:51:17"
                  },
                  "nodeType": "YulIf",
                  "src": "68:71:17"
                }
              ]
            },
            "name": "validator_revert_bytes4",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "47:5:17",
                "type": ""
              }
            ],
            "src": "14:131:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "219:176:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "265:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "274:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "277:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "267:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "267:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "267:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "240:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "249:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "236:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "236:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "261:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "232:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "232:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "229:52:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "290:36:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "316:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "303:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "303:23:17"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "294:5:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "359:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_bytes4",
                      "nodeType": "YulIdentifier",
                      "src": "335:23:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "335:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "335:30:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "374:15:17",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "384:5:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "374:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_bytes4",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "185:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "196:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "208:6:17",
                "type": ""
              }
            ],
            "src": "150:245:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "495:92:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "505:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "517:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "528:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "513:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "513:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "505:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "547:9:17"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value0",
                                "nodeType": "YulIdentifier",
                                "src": "572:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "iszero",
                              "nodeType": "YulIdentifier",
                              "src": "565:6:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "565:14:17"
                          }
                        ],
                        "functionName": {
                          "name": "iszero",
                          "nodeType": "YulIdentifier",
                          "src": "558:6:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "558:22:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "540:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "540:41:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "540:41:17"
                }
              ]
            },
            "name": "abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "464:9:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "475:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "486:4:17",
                "type": ""
              }
            ],
            "src": "400:187:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "645:205:17",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "655:10:17",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "664:1:17",
                    "type": "",
                    "value": "0"
                  },
                  "variables": [
                    {
                      "name": "i",
                      "nodeType": "YulTypedName",
                      "src": "659:1:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "724:63:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "dst",
                                  "nodeType": "YulIdentifier",
                                  "src": "749:3:17"
                                },
                                {
                                  "name": "i",
                                  "nodeType": "YulIdentifier",
                                  "src": "754:1:17"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "745:3:17"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "745:11:17"
                            },
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "src",
                                      "nodeType": "YulIdentifier",
                                      "src": "768:3:17"
                                    },
                                    {
                                      "name": "i",
                                      "nodeType": "YulIdentifier",
                                      "src": "773:1:17"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "764:3:17"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "764:11:17"
                                }
                              ],
                              "functionName": {
                                "name": "mload",
                                "nodeType": "YulIdentifier",
                                "src": "758:5:17"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "758:18:17"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "738:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "738:39:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "738:39:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "685:1:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "688:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "682:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "682:13:17"
                  },
                  "nodeType": "YulForLoop",
                  "post": {
                    "nodeType": "YulBlock",
                    "src": "696:19:17",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "698:15:17",
                        "value": {
                          "arguments": [
                            {
                              "name": "i",
                              "nodeType": "YulIdentifier",
                              "src": "707:1:17"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "710:2:17",
                              "type": "",
                              "value": "32"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "703:3:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "703:10:17"
                        },
                        "variableNames": [
                          {
                            "name": "i",
                            "nodeType": "YulIdentifier",
                            "src": "698:1:17"
                          }
                        ]
                      }
                    ]
                  },
                  "pre": {
                    "nodeType": "YulBlock",
                    "src": "678:3:17",
                    "statements": []
                  },
                  "src": "674:113:17"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "813:31:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "dst",
                                  "nodeType": "YulIdentifier",
                                  "src": "826:3:17"
                                },
                                {
                                  "name": "length",
                                  "nodeType": "YulIdentifier",
                                  "src": "831:6:17"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "822:3:17"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "822:16:17"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "840:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "815:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "815:27:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "815:27:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "802:1:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "805:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "799:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "799:13:17"
                  },
                  "nodeType": "YulIf",
                  "src": "796:48:17"
                }
              ]
            },
            "name": "copy_memory_to_memory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "src",
                "nodeType": "YulTypedName",
                "src": "623:3:17",
                "type": ""
              },
              {
                "name": "dst",
                "nodeType": "YulTypedName",
                "src": "628:3:17",
                "type": ""
              },
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "633:6:17",
                "type": ""
              }
            ],
            "src": "592:258:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "905:208:17",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "915:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "935:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "929:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "929:12:17"
                  },
                  "variables": [
                    {
                      "name": "length",
                      "nodeType": "YulTypedName",
                      "src": "919:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "957:3:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "962:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "950:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "950:19:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "950:19:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "1004:5:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1011:4:17",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1000:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1000:16:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "1022:3:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1027:4:17",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1018:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1018:14:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "1034:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "copy_memory_to_memory",
                      "nodeType": "YulIdentifier",
                      "src": "978:21:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "978:63:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "978:63:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1050:57:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "1065:3:17"
                          },
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "name": "length",
                                    "nodeType": "YulIdentifier",
                                    "src": "1078:6:17"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "1086:2:17",
                                    "type": "",
                                    "value": "31"
                                  }
                                ],
                                "functionName": {
                                  "name": "add",
                                  "nodeType": "YulIdentifier",
                                  "src": "1074:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "1074:15:17"
                              },
                              {
                                "arguments": [
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "1095:2:17",
                                    "type": "",
                                    "value": "31"
                                  }
                                ],
                                "functionName": {
                                  "name": "not",
                                  "nodeType": "YulIdentifier",
                                  "src": "1091:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "1091:7:17"
                              }
                            ],
                            "functionName": {
                              "name": "and",
                              "nodeType": "YulIdentifier",
                              "src": "1070:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1070:29:17"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1061:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1061:39:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1102:4:17",
                        "type": "",
                        "value": "0x20"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "1057:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1057:50:17"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "1050:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_string",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "882:5:17",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "889:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "897:3:17",
                "type": ""
              }
            ],
            "src": "855:258:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1239:99:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "1256:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1267:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "1249:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1249:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1249:21:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1279:53:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "1305:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1317:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1328:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1313:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1313:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "1287:17:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1287:45:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "1279:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1208:9:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1219:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "1230:4:17",
                "type": ""
              }
            ],
            "src": "1118:220:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1413:110:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1459:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1468:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1471:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1461:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1461:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1461:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1434:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1443:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "1430:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1430:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1455:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "1426:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1426:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1423:52:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1484:33:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "1507:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "1494:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1494:23:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "1484:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1379:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "1390:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1402:6:17",
                "type": ""
              }
            ],
            "src": "1343:180:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1629:102:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "1639:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "1651:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1662:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "1647:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1647:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "1639:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "1681:9:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "1696:6:17"
                          },
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "1712:3:17",
                                    "type": "",
                                    "value": "160"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "1717:1:17",
                                    "type": "",
                                    "value": "1"
                                  }
                                ],
                                "functionName": {
                                  "name": "shl",
                                  "nodeType": "YulIdentifier",
                                  "src": "1708:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "1708:11:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "1721:1:17",
                                "type": "",
                                "value": "1"
                              }
                            ],
                            "functionName": {
                              "name": "sub",
                              "nodeType": "YulIdentifier",
                              "src": "1704:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1704:19:17"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "1692:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1692:32:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "1674:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1674:51:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1674:51:17"
                }
              ]
            },
            "name": "abi_encode_tuple_t_address__to_t_address__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1598:9:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1609:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "1620:4:17",
                "type": ""
              }
            ],
            "src": "1528:203:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1785:124:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "1795:29:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "1817:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "1804:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1804:20:17"
                  },
                  "variableNames": [
                    {
                      "name": "value",
                      "nodeType": "YulIdentifier",
                      "src": "1795:5:17"
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1887:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1896:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1899:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1889:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1889:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1889:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "1846:5:17"
                          },
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "1857:5:17"
                              },
                              {
                                "arguments": [
                                  {
                                    "arguments": [
                                      {
                                        "kind": "number",
                                        "nodeType": "YulLiteral",
                                        "src": "1872:3:17",
                                        "type": "",
                                        "value": "160"
                                      },
                                      {
                                        "kind": "number",
                                        "nodeType": "YulLiteral",
                                        "src": "1877:1:17",
                                        "type": "",
                                        "value": "1"
                                      }
                                    ],
                                    "functionName": {
                                      "name": "shl",
                                      "nodeType": "YulIdentifier",
                                      "src": "1868:3:17"
                                    },
                                    "nodeType": "YulFunctionCall",
                                    "src": "1868:11:17"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "1881:1:17",
                                    "type": "",
                                    "value": "1"
                                  }
                                ],
                                "functionName": {
                                  "name": "sub",
                                  "nodeType": "YulIdentifier",
                                  "src": "1864:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "1864:19:17"
                              }
                            ],
                            "functionName": {
                              "name": "and",
                              "nodeType": "YulIdentifier",
                              "src": "1853:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1853:31:17"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "1843:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1843:42:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "1836:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1836:50:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1833:70:17"
                }
              ]
            },
            "name": "abi_decode_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "1764:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "1775:5:17",
                "type": ""
              }
            ],
            "src": "1736:173:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2001:167:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2047:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2056:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2059:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "2049:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2049:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2049:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2022:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2031:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "2018:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2018:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2043:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "2014:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2014:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "2011:52:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2072:39:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2101:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "2082:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2082:29:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "2072:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2120:42:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2147:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2158:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2143:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2143:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2130:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2130:32:17"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "2120:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_addresst_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1959:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "1970:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1982:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "1990:6:17",
                "type": ""
              }
            ],
            "src": "1914:254:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2274:76:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "2284:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2296:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2307:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "2292:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2292:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "2284:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2326:9:17"
                      },
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "2337:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "2319:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2319:25:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2319:25:17"
                }
              ]
            },
            "name": "abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2243:9:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "2254:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "2265:4:17",
                "type": ""
              }
            ],
            "src": "2173:177:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2459:224:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2505:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2514:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2517:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "2507:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2507:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2507:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2480:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2489:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "2476:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2476:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2501:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "2472:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2472:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "2469:52:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2530:39:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2559:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "2540:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2540:29:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "2530:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2578:48:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2611:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2622:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2607:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2607:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "2588:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2588:38:17"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "2578:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2635:42:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2662:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2673:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2658:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2658:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2645:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2645:32:17"
                  },
                  "variableNames": [
                    {
                      "name": "value2",
                      "nodeType": "YulIdentifier",
                      "src": "2635:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_addresst_addresst_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2409:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "2420:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "2432:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "2440:6:17",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "2448:6:17",
                "type": ""
              }
            ],
            "src": "2355:328:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2775:161:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2821:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2830:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2833:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "2823:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2823:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2823:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2796:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2805:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "2792:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2792:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2817:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "2788:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2788:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "2785:52:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2846:33:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2869:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2856:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2856:23:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "2846:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2888:42:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2915:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2926:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2911:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2911:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2898:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2898:32:17"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "2888:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint256t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2733:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "2744:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "2756:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "2764:6:17",
                "type": ""
              }
            ],
            "src": "2688:248:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3070:145:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "3080:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "3092:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3103:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "3088:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3088:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "3080:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "3122:9:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "3137:6:17"
                          },
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "3153:3:17",
                                    "type": "",
                                    "value": "160"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "3158:1:17",
                                    "type": "",
                                    "value": "1"
                                  }
                                ],
                                "functionName": {
                                  "name": "shl",
                                  "nodeType": "YulIdentifier",
                                  "src": "3149:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "3149:11:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "3162:1:17",
                                "type": "",
                                "value": "1"
                              }
                            ],
                            "functionName": {
                              "name": "sub",
                              "nodeType": "YulIdentifier",
                              "src": "3145:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "3145:19:17"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "3133:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3133:32:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3115:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3115:51:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3115:51:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3186:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "3197:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "3182:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3182:18:17"
                      },
                      {
                        "name": "value1",
                        "nodeType": "YulIdentifier",
                        "src": "3202:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3175:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3175:34:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3175:34:17"
                }
              ]
            },
            "name": "abi_encode_tuple_t_address_t_uint256__to_t_address_t_uint256__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "3031:9:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "3042:6:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "3050:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "3061:4:17",
                "type": ""
              }
            ],
            "src": "2941:274:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3290:116:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "3336:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3345:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3348:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "3338:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "3338:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "3338:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "3311:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3320:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "3307:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3307:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3332:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "3303:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3303:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "3300:52:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3361:39:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "3390:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "3371:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3371:29:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "3361:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "3256:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "3267:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "3279:6:17",
                "type": ""
              }
            ],
            "src": "3220:186:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3443:95:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3460:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "3467:3:17",
                            "type": "",
                            "value": "224"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "3472:10:17",
                            "type": "",
                            "value": "0x4e487b71"
                          }
                        ],
                        "functionName": {
                          "name": "shl",
                          "nodeType": "YulIdentifier",
                          "src": "3463:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3463:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3453:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3453:31:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3453:31:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3500:1:17",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3503:4:17",
                        "type": "",
                        "value": "0x41"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3493:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3493:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3493:15:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3524:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3527:4:17",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "3517:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3517:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3517:15:17"
                }
              ]
            },
            "name": "panic_error_0x41",
            "nodeType": "YulFunctionDefinition",
            "src": "3411:127:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3618:557:17",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3628:28:17",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "3638:18:17",
                    "type": "",
                    "value": "0xffffffffffffffff"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "3632:2:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "3683:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x41",
                            "nodeType": "YulIdentifier",
                            "src": "3685:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "3685:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "3685:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "3671:6:17"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "3679:2:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "3668:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3668:14:17"
                  },
                  "nodeType": "YulIf",
                  "src": "3665:40:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3714:17:17",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3728:2:17",
                        "type": "",
                        "value": "31"
                      }
                    ],
                    "functionName": {
                      "name": "not",
                      "nodeType": "YulIdentifier",
                      "src": "3724:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3724:7:17"
                  },
                  "variables": [
                    {
                      "name": "_2",
                      "nodeType": "YulTypedName",
                      "src": "3718:2:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3740:23:17",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3760:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "3754:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3754:9:17"
                  },
                  "variables": [
                    {
                      "name": "memPtr",
                      "nodeType": "YulTypedName",
                      "src": "3744:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3772:73:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "memPtr",
                        "nodeType": "YulIdentifier",
                        "src": "3794:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "arguments": [
                                      {
                                        "name": "length",
                                        "nodeType": "YulIdentifier",
                                        "src": "3818:6:17"
                                      },
                                      {
                                        "kind": "number",
                                        "nodeType": "YulLiteral",
                                        "src": "3826:2:17",
                                        "type": "",
                                        "value": "31"
                                      }
                                    ],
                                    "functionName": {
                                      "name": "add",
                                      "nodeType": "YulIdentifier",
                                      "src": "3814:3:17"
                                    },
                                    "nodeType": "YulFunctionCall",
                                    "src": "3814:15:17"
                                  },
                                  {
                                    "name": "_2",
                                    "nodeType": "YulIdentifier",
                                    "src": "3831:2:17"
                                  }
                                ],
                                "functionName": {
                                  "name": "and",
                                  "nodeType": "YulIdentifier",
                                  "src": "3810:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "3810:24:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "3836:2:17",
                                "type": "",
                                "value": "63"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "3806:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "3806:33:17"
                          },
                          {
                            "name": "_2",
                            "nodeType": "YulIdentifier",
                            "src": "3841:2:17"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "3802:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3802:42:17"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "3790:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3790:55:17"
                  },
                  "variables": [
                    {
                      "name": "newFreePtr",
                      "nodeType": "YulTypedName",
                      "src": "3776:10:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "3904:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x41",
                            "nodeType": "YulIdentifier",
                            "src": "3906:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "3906:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "3906:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "newFreePtr",
                            "nodeType": "YulIdentifier",
                            "src": "3863:10:17"
                          },
                          {
                            "name": "_1",
                            "nodeType": "YulIdentifier",
                            "src": "3875:2:17"
                          }
                        ],
                        "functionName": {
                          "name": "gt",
                          "nodeType": "YulIdentifier",
                          "src": "3860:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3860:18:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "newFreePtr",
                            "nodeType": "YulIdentifier",
                            "src": "3883:10:17"
                          },
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "3895:6:17"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "3880:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3880:22:17"
                      }
                    ],
                    "functionName": {
                      "name": "or",
                      "nodeType": "YulIdentifier",
                      "src": "3857:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3857:46:17"
                  },
                  "nodeType": "YulIf",
                  "src": "3854:72:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3942:2:17",
                        "type": "",
                        "value": "64"
                      },
                      {
                        "name": "newFreePtr",
                        "nodeType": "YulIdentifier",
                        "src": "3946:10:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3935:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3935:22:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3935:22:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3966:15:17",
                  "value": {
                    "name": "memPtr",
                    "nodeType": "YulIdentifier",
                    "src": "3975:6:17"
                  },
                  "variableNames": [
                    {
                      "name": "array",
                      "nodeType": "YulIdentifier",
                      "src": "3966:5:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "memPtr",
                        "nodeType": "YulIdentifier",
                        "src": "3997:6:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "4005:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3990:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3990:22:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3990:22:17"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4050:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4059:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4062:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4052:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4052:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4052:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "src",
                            "nodeType": "YulIdentifier",
                            "src": "4031:3:17"
                          },
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "4036:6:17"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4027:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4027:16:17"
                      },
                      {
                        "name": "end",
                        "nodeType": "YulIdentifier",
                        "src": "4045:3:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "4024:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4024:25:17"
                  },
                  "nodeType": "YulIf",
                  "src": "4021:45:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "4092:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "4100:4:17",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4088:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4088:17:17"
                      },
                      {
                        "name": "src",
                        "nodeType": "YulIdentifier",
                        "src": "4107:3:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "4112:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldatacopy",
                      "nodeType": "YulIdentifier",
                      "src": "4075:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4075:44:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "4075:44:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "memPtr",
                                "nodeType": "YulIdentifier",
                                "src": "4143:6:17"
                              },
                              {
                                "name": "length",
                                "nodeType": "YulIdentifier",
                                "src": "4151:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "4139:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "4139:19:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "4160:4:17",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4135:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4135:30:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4167:1:17",
                        "type": "",
                        "value": "0"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "4128:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4128:41:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "4128:41:17"
                }
              ]
            },
            "name": "abi_decode_available_length_string",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "src",
                "nodeType": "YulTypedName",
                "src": "3587:3:17",
                "type": ""
              },
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "3592:6:17",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "3600:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "array",
                "nodeType": "YulTypedName",
                "src": "3608:5:17",
                "type": ""
              }
            ],
            "src": "3543:632:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4233:169:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4282:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4291:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4294:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4284:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4284:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4284:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "4261:6:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "4269:4:17",
                                "type": "",
                                "value": "0x1f"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "4257:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "4257:17:17"
                          },
                          {
                            "name": "end",
                            "nodeType": "YulIdentifier",
                            "src": "4276:3:17"
                          }
                        ],
                        "functionName": {
                          "name": "slt",
                          "nodeType": "YulIdentifier",
                          "src": "4253:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4253:27:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "4246:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4246:35:17"
                  },
                  "nodeType": "YulIf",
                  "src": "4243:55:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4307:89:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "4355:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "4363:4:17",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4351:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4351:17:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "4383:6:17"
                          }
                        ],
                        "functionName": {
                          "name": "calldataload",
                          "nodeType": "YulIdentifier",
                          "src": "4370:12:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4370:20:17"
                      },
                      {
                        "name": "end",
                        "nodeType": "YulIdentifier",
                        "src": "4392:3:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_available_length_string",
                      "nodeType": "YulIdentifier",
                      "src": "4316:34:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4316:80:17"
                  },
                  "variableNames": [
                    {
                      "name": "array",
                      "nodeType": "YulIdentifier",
                      "src": "4307:5:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_string",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "4207:6:17",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "4215:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "array",
                "nodeType": "YulTypedName",
                "src": "4223:5:17",
                "type": ""
              }
            ],
            "src": "4180:222:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4487:242:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4533:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4542:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4545:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4535:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4535:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4535:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "4508:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4517:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "4504:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4504:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4529:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "4500:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4500:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "4497:52:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "4558:37:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "4585:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "4572:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4572:23:17"
                  },
                  "variables": [
                    {
                      "name": "offset",
                      "nodeType": "YulTypedName",
                      "src": "4562:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4638:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4647:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4650:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4640:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4640:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4640:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "4610:6:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4618:18:17",
                        "type": "",
                        "value": "0xffffffffffffffff"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "4607:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4607:30:17"
                  },
                  "nodeType": "YulIf",
                  "src": "4604:50:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4663:60:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4695:9:17"
                          },
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "4706:6:17"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4691:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4691:22:17"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "4715:7:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string",
                      "nodeType": "YulIdentifier",
                      "src": "4673:17:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4673:50:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "4663:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_string_memory_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "4453:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "4464:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "4476:6:17",
                "type": ""
              }
            ],
            "src": "4407:322:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4848:350:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4894:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4903:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4906:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4896:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4896:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4896:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "4869:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4878:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "4865:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4865:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4890:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "4861:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4861:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "4858:52:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "4919:37:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "4946:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "4933:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4933:23:17"
                  },
                  "variables": [
                    {
                      "name": "offset",
                      "nodeType": "YulTypedName",
                      "src": "4923:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4999:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5008:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5011:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "5001:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "5001:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "5001:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "4971:6:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4979:18:17",
                        "type": "",
                        "value": "0xffffffffffffffff"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "4968:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4968:30:17"
                  },
                  "nodeType": "YulIf",
                  "src": "4965:50:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5024:60:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5056:9:17"
                          },
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "5067:6:17"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5052:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5052:22:17"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "5076:7:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string",
                      "nodeType": "YulIdentifier",
                      "src": "5034:17:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5034:50:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "5024:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5093:42:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5120:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5131:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5116:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5116:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "5103:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5103:32:17"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "5093:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5144:48:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5177:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5188:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5173:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5173:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "5154:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5154:38:17"
                  },
                  "variableNames": [
                    {
                      "name": "value2",
                      "nodeType": "YulIdentifier",
                      "src": "5144:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_string_memory_ptrt_uint256t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "4798:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "4809:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "4821:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "4829:6:17",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "4837:6:17",
                "type": ""
              }
            ],
            "src": "4734:464:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "5287:263:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "5333:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5342:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5345:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "5335:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "5335:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "5335:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "5308:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5317:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "5304:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5304:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5329:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "5300:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5300:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "5297:52:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5358:39:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "5387:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "5368:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5368:29:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "5358:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "5406:45:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5436:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5447:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5432:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5432:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "5419:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5419:32:17"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "5410:5:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "5504:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5513:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5516:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "5506:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "5506:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "5506:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "5473:5:17"
                          },
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "name": "value",
                                    "nodeType": "YulIdentifier",
                                    "src": "5494:5:17"
                                  }
                                ],
                                "functionName": {
                                  "name": "iszero",
                                  "nodeType": "YulIdentifier",
                                  "src": "5487:6:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "5487:13:17"
                              }
                            ],
                            "functionName": {
                              "name": "iszero",
                              "nodeType": "YulIdentifier",
                              "src": "5480:6:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "5480:21:17"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "5470:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5470:32:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "5463:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5463:40:17"
                  },
                  "nodeType": "YulIf",
                  "src": "5460:60:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5529:15:17",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "5539:5:17"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "5529:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_addresst_bool",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "5245:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "5256:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "5268:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "5276:6:17",
                "type": ""
              }
            ],
            "src": "5203:347:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "5685:537:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "5732:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5741:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5744:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "5734:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "5734:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "5734:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "5706:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5715:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "5702:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5702:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5727:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "5698:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5698:33:17"
                  },
                  "nodeType": "YulIf",
                  "src": "5695:53:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5757:39:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "5786:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "5767:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5767:29:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "5757:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5805:48:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5838:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5849:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5834:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5834:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "5815:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5815:38:17"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "5805:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5862:42:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5889:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5900:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5885:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5885:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "5872:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5872:32:17"
                  },
                  "variableNames": [
                    {
                      "name": "value2",
                      "nodeType": "YulIdentifier",
                      "src": "5862:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "5913:46:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5944:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5955:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5940:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5940:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "5927:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5927:32:17"
                  },
                  "variables": [
                    {
                      "name": "offset",
                      "nodeType": "YulTypedName",
                      "src": "5917:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "6002:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6011:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6014:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "6004:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6004:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6004:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "5974:6:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5982:18:17",
                        "type": "",
                        "value": "0xffffffffffffffff"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "5971:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5971:30:17"
                  },
                  "nodeType": "YulIf",
                  "src": "5968:50:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "6027:32:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "6041:9:17"
                      },
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "6052:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "6037:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6037:22:17"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "6031:2:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "6107:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6116:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6119:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "6109:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6109:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6109:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "_1",
                                "nodeType": "YulIdentifier",
                                "src": "6086:2:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "6090:4:17",
                                "type": "",
                                "value": "0x1f"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "6082:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "6082:13:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "6097:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "slt",
                          "nodeType": "YulIdentifier",
                          "src": "6078:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6078:27:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "6071:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6071:35:17"
                  },
                  "nodeType": "YulIf",
                  "src": "6068:55:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6132:84:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "_1",
                            "nodeType": "YulIdentifier",
                            "src": "6181:2:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "6185:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6177:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6177:11:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "_1",
                            "nodeType": "YulIdentifier",
                            "src": "6203:2:17"
                          }
                        ],
                        "functionName": {
                          "name": "calldataload",
                          "nodeType": "YulIdentifier",
                          "src": "6190:12:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6190:16:17"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "6208:7:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_available_length_string",
                      "nodeType": "YulIdentifier",
                      "src": "6142:34:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6142:74:17"
                  },
                  "variableNames": [
                    {
                      "name": "value3",
                      "nodeType": "YulIdentifier",
                      "src": "6132:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_addresst_addresst_uint256t_bytes_memory_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "5627:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "5638:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "5650:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "5658:6:17",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "5666:6:17",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "5674:6:17",
                "type": ""
              }
            ],
            "src": "5555:667:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "6314:173:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "6360:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6369:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6372:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "6362:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6362:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6362:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "6335:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6344:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "6331:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6331:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "6356:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "6327:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6327:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "6324:52:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6385:39:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "6414:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "6395:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6395:29:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "6385:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6433:48:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6466:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "6477:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6462:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6462:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_address",
                      "nodeType": "YulIdentifier",
                      "src": "6443:18:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6443:38:17"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "6433:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_addresst_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "6272:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "6283:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "6295:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "6303:6:17",
                "type": ""
              }
            ],
            "src": "6227:260:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "6547:325:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "6557:22:17",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "6571:1:17",
                        "type": "",
                        "value": "1"
                      },
                      {
                        "name": "data",
                        "nodeType": "YulIdentifier",
                        "src": "6574:4:17"
                      }
                    ],
                    "functionName": {
                      "name": "shr",
                      "nodeType": "YulIdentifier",
                      "src": "6567:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6567:12:17"
                  },
                  "variableNames": [
                    {
                      "name": "length",
                      "nodeType": "YulIdentifier",
                      "src": "6557:6:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "6588:38:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "data",
                        "nodeType": "YulIdentifier",
                        "src": "6618:4:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "6624:1:17",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "and",
                      "nodeType": "YulIdentifier",
                      "src": "6614:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6614:12:17"
                  },
                  "variables": [
                    {
                      "name": "outOfPlaceEncoding",
                      "nodeType": "YulTypedName",
                      "src": "6592:18:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "6665:31:17",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "6667:27:17",
                        "value": {
                          "arguments": [
                            {
                              "name": "length",
                              "nodeType": "YulIdentifier",
                              "src": "6681:6:17"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6689:4:17",
                              "type": "",
                              "value": "0x7f"
                            }
                          ],
                          "functionName": {
                            "name": "and",
                            "nodeType": "YulIdentifier",
                            "src": "6677:3:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6677:17:17"
                        },
                        "variableNames": [
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "6667:6:17"
                          }
                        ]
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "outOfPlaceEncoding",
                        "nodeType": "YulIdentifier",
                        "src": "6645:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "6638:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6638:26:17"
                  },
                  "nodeType": "YulIf",
                  "src": "6635:61:17"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "6755:111:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6776:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "arguments": [
                                {
                                  "kind": "number",
                                  "nodeType": "YulLiteral",
                                  "src": "6783:3:17",
                                  "type": "",
                                  "value": "224"
                                },
                                {
                                  "kind": "number",
                                  "nodeType": "YulLiteral",
                                  "src": "6788:10:17",
                                  "type": "",
                                  "value": "0x4e487b71"
                                }
                              ],
                              "functionName": {
                                "name": "shl",
                                "nodeType": "YulIdentifier",
                                "src": "6779:3:17"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "6779:20:17"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "6769:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6769:31:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6769:31:17"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6820:1:17",
                              "type": "",
                              "value": "4"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6823:4:17",
                              "type": "",
                              "value": "0x22"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "6813:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6813:15:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6813:15:17"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6848:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6851:4:17",
                              "type": "",
                              "value": "0x24"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "6841:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6841:15:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6841:15:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "outOfPlaceEncoding",
                        "nodeType": "YulIdentifier",
                        "src": "6711:18:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "6734:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "6742:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "6731:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6731:14:17"
                      }
                    ],
                    "functionName": {
                      "name": "eq",
                      "nodeType": "YulIdentifier",
                      "src": "6708:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6708:38:17"
                  },
                  "nodeType": "YulIf",
                  "src": "6705:161:17"
                }
              ]
            },
            "name": "extract_byte_array_length",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "data",
                "nodeType": "YulTypedName",
                "src": "6527:4:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "6536:6:17",
                "type": ""
              }
            ],
            "src": "6492:380:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7051:234:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "7068:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7079:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7061:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7061:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7061:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7102:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7113:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7098:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7098:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7118:2:17",
                        "type": "",
                        "value": "44"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7091:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7091:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7091:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7141:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7152:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7137:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7137:18:17"
                      },
                      {
                        "hexValue": "4552433732313a20617070726f76656420717565727920666f72206e6f6e6578",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "7157:34:17",
                        "type": "",
                        "value": "ERC721: approved query for nonex"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7130:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7130:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7130:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7212:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7223:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7208:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7208:18:17"
                      },
                      {
                        "hexValue": "697374656e7420746f6b656e",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "7228:14:17",
                        "type": "",
                        "value": "istent token"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7201:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7201:42:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7201:42:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "7252:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "7264:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7275:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "7260:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7260:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "7252:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_9291e0f44949204f2e9b40e6be090924979d6047b2365868f4e9f027722eb89d__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "7028:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "7042:4:17",
                "type": ""
              }
            ],
            "src": "6877:408:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7464:223:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "7481:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7492:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7474:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7474:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7474:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7515:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7526:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7511:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7511:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7531:2:17",
                        "type": "",
                        "value": "33"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7504:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7504:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7504:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7554:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7565:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7550:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7550:18:17"
                      },
                      {
                        "hexValue": "4552433732313a20617070726f76616c20746f2063757272656e74206f776e65",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "7570:34:17",
                        "type": "",
                        "value": "ERC721: approval to current owne"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7543:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7543:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7543:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7625:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7636:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7621:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7621:18:17"
                      },
                      {
                        "hexValue": "72",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "7641:3:17",
                        "type": "",
                        "value": "r"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7614:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7614:31:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7614:31:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "7654:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "7666:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7677:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "7662:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7662:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "7654:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_b51b4875eede07862961e8f9365c6749f5fe55c6ee5d7a9e42b6912ad0b15942__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "7441:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "7455:4:17",
                "type": ""
              }
            ],
            "src": "7290:397:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7866:246:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "7883:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7894:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7876:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7876:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7876:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7917:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7928:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7913:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7913:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7933:2:17",
                        "type": "",
                        "value": "56"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7906:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7906:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7906:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7956:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7967:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7952:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7952:18:17"
                      },
                      {
                        "hexValue": "4552433732313a20617070726f76652063616c6c6572206973206e6f74206f77",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "7972:34:17",
                        "type": "",
                        "value": "ERC721: approve caller is not ow"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7945:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7945:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7945:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8027:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8038:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8023:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8023:18:17"
                      },
                      {
                        "hexValue": "6e6572206e6f7220617070726f76656420666f7220616c6c",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "8043:26:17",
                        "type": "",
                        "value": "ner nor approved for all"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8016:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8016:54:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8016:54:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "8079:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8091:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8102:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "8087:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8087:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "8079:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_6d83cef3e0cb19b8320a9c5feb26b56bbb08f152a8e61b12eca3302d8d68b23d__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "7843:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "7857:4:17",
                "type": ""
              }
            ],
            "src": "7692:420:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "8291:239:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8308:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8319:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8301:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8301:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8301:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8342:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8353:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8338:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8338:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8358:2:17",
                        "type": "",
                        "value": "49"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8331:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8331:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8331:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8381:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8392:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8377:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8377:18:17"
                      },
                      {
                        "hexValue": "4552433732313a207472616e736665722063616c6c6572206973206e6f74206f",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "8397:34:17",
                        "type": "",
                        "value": "ERC721: transfer caller is not o"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8370:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8370:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8370:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8452:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8463:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8448:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8448:18:17"
                      },
                      {
                        "hexValue": "776e6572206e6f7220617070726f766564",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "8468:19:17",
                        "type": "",
                        "value": "wner nor approved"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8441:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8441:47:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8441:47:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "8497:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8509:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8520:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "8505:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8505:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "8497:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_c8682f3ad98807db59a6ec6bb812b72fed0a66e3150fa8239699ee83885247f2__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "8268:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "8282:4:17",
                "type": ""
              }
            ],
            "src": "8117:413:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "8709:178:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8726:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8737:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8719:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8719:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8719:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8760:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8771:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8756:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8756:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8776:2:17",
                        "type": "",
                        "value": "28"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8749:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8749:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8749:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8799:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8810:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8795:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8795:18:17"
                      },
                      {
                        "hexValue": "4552433732313a204e6f6e6578697374656e7420546f6b656e204944",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "8815:30:17",
                        "type": "",
                        "value": "ERC721: Nonexistent Token ID"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8788:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8788:58:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8788:58:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "8855:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8867:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8878:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "8863:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8863:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "8855:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_54ec63a34df5f93dcd1e2de2b3cda8a7cad00cf9da902f0e9a30741ff9bcf20d__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "8686:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "8700:4:17",
                "type": ""
              }
            ],
            "src": "8535:352:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "8924:95:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8941:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8948:3:17",
                            "type": "",
                            "value": "224"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8953:10:17",
                            "type": "",
                            "value": "0x4e487b71"
                          }
                        ],
                        "functionName": {
                          "name": "shl",
                          "nodeType": "YulIdentifier",
                          "src": "8944:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8944:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8934:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8934:31:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8934:31:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8981:1:17",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8984:4:17",
                        "type": "",
                        "value": "0x11"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8974:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8974:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8974:15:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9005:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9008:4:17",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "8998:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8998:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8998:15:17"
                }
              ]
            },
            "name": "panic_error_0x11",
            "nodeType": "YulFunctionDefinition",
            "src": "8892:127:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "9076:116:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "9135:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "9137:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "9137:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "9137:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "x",
                                "nodeType": "YulIdentifier",
                                "src": "9107:1:17"
                              }
                            ],
                            "functionName": {
                              "name": "iszero",
                              "nodeType": "YulIdentifier",
                              "src": "9100:6:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "9100:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "iszero",
                          "nodeType": "YulIdentifier",
                          "src": "9093:6:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9093:17:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "y",
                            "nodeType": "YulIdentifier",
                            "src": "9115:1:17"
                          },
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "9126:1:17",
                                    "type": "",
                                    "value": "0"
                                  }
                                ],
                                "functionName": {
                                  "name": "not",
                                  "nodeType": "YulIdentifier",
                                  "src": "9122:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "9122:6:17"
                              },
                              {
                                "name": "x",
                                "nodeType": "YulIdentifier",
                                "src": "9130:1:17"
                              }
                            ],
                            "functionName": {
                              "name": "div",
                              "nodeType": "YulIdentifier",
                              "src": "9118:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "9118:14:17"
                          }
                        ],
                        "functionName": {
                          "name": "gt",
                          "nodeType": "YulIdentifier",
                          "src": "9112:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9112:21:17"
                      }
                    ],
                    "functionName": {
                      "name": "and",
                      "nodeType": "YulIdentifier",
                      "src": "9089:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9089:45:17"
                  },
                  "nodeType": "YulIf",
                  "src": "9086:71:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "9166:20:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "9181:1:17"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "9184:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "mul",
                      "nodeType": "YulIdentifier",
                      "src": "9177:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9177:9:17"
                  },
                  "variableNames": [
                    {
                      "name": "product",
                      "nodeType": "YulIdentifier",
                      "src": "9166:7:17"
                    }
                  ]
                }
              ]
            },
            "name": "checked_mul_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "x",
                "nodeType": "YulTypedName",
                "src": "9055:1:17",
                "type": ""
              },
              {
                "name": "y",
                "nodeType": "YulTypedName",
                "src": "9058:1:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "product",
                "nodeType": "YulTypedName",
                "src": "9064:7:17",
                "type": ""
              }
            ],
            "src": "9024:168:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "9229:95:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9246:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9253:3:17",
                            "type": "",
                            "value": "224"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9258:10:17",
                            "type": "",
                            "value": "0x4e487b71"
                          }
                        ],
                        "functionName": {
                          "name": "shl",
                          "nodeType": "YulIdentifier",
                          "src": "9249:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9249:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9239:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9239:31:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9239:31:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9286:1:17",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9289:4:17",
                        "type": "",
                        "value": "0x12"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9279:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9279:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9279:15:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9310:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9313:4:17",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "9303:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9303:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9303:15:17"
                }
              ]
            },
            "name": "panic_error_0x12",
            "nodeType": "YulFunctionDefinition",
            "src": "9197:127:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "9375:74:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "9398:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x12",
                            "nodeType": "YulIdentifier",
                            "src": "9400:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "9400:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "9400:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "9395:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "9388:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9388:9:17"
                  },
                  "nodeType": "YulIf",
                  "src": "9385:35:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "9429:14:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "9438:1:17"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "9441:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "div",
                      "nodeType": "YulIdentifier",
                      "src": "9434:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9434:9:17"
                  },
                  "variableNames": [
                    {
                      "name": "r",
                      "nodeType": "YulIdentifier",
                      "src": "9429:1:17"
                    }
                  ]
                }
              ]
            },
            "name": "checked_div_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "x",
                "nodeType": "YulTypedName",
                "src": "9360:1:17",
                "type": ""
              },
              {
                "name": "y",
                "nodeType": "YulTypedName",
                "src": "9363:1:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "r",
                "nodeType": "YulTypedName",
                "src": "9369:1:17",
                "type": ""
              }
            ],
            "src": "9329:120:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "9628:231:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9645:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9656:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9638:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9638:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9638:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9679:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9690:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "9675:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9675:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9695:2:17",
                        "type": "",
                        "value": "41"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9668:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9668:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9668:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9718:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9729:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "9714:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9714:18:17"
                      },
                      {
                        "hexValue": "4552433732313a206f776e657220717565727920666f72206e6f6e6578697374",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "9734:34:17",
                        "type": "",
                        "value": "ERC721: owner query for nonexist"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9707:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9707:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9707:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9789:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9800:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "9785:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9785:18:17"
                      },
                      {
                        "hexValue": "656e7420746f6b656e",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "9805:11:17",
                        "type": "",
                        "value": "ent token"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9778:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9778:39:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9778:39:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "9826:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9838:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9849:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "9834:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9834:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "9826:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_7481f3df2a424c0755a1ad2356614e9a5a358d461ea2eae1f89cb21cbad00397__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "9605:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "9619:4:17",
                "type": ""
              }
            ],
            "src": "9454:405:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "10038:182:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10055:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10066:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10048:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10048:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10048:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10089:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10100:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "10085:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10085:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10105:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10078:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10078:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10078:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10128:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10139:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "10124:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10124:18:17"
                      },
                      {
                        "hexValue": "4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "10144:34:17",
                        "type": "",
                        "value": "Ownable: caller is not the owner"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10117:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10117:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10117:62:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "10188:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10200:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10211:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10196:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10196:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "10188:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "10015:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "10029:4:17",
                "type": ""
              }
            ],
            "src": "9864:356:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "10399:232:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10416:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10427:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10409:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10409:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10409:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10450:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10461:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "10446:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10446:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10466:2:17",
                        "type": "",
                        "value": "42"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10439:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10439:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10439:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10489:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10500:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "10485:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10485:18:17"
                      },
                      {
                        "hexValue": "4552433732313a2062616c616e636520717565727920666f7220746865207a65",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "10505:34:17",
                        "type": "",
                        "value": "ERC721: balance query for the ze"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10478:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10478:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10478:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10560:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10571:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "10556:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10556:18:17"
                      },
                      {
                        "hexValue": "726f2061646472657373",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "10576:12:17",
                        "type": "",
                        "value": "ro address"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10549:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10549:40:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10549:40:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "10598:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10610:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10621:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10606:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10606:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "10598:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_7395d4d3901c50cdfcab223d072f9aa36241df5d883e62cbf147ee1b05a9e6ba__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "10376:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "10390:4:17",
                "type": ""
              }
            ],
            "src": "10225:406:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "10668:95:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10685:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10692:3:17",
                            "type": "",
                            "value": "224"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10697:10:17",
                            "type": "",
                            "value": "0x4e487b71"
                          }
                        ],
                        "functionName": {
                          "name": "shl",
                          "nodeType": "YulIdentifier",
                          "src": "10688:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10688:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10678:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10678:31:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10678:31:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10725:1:17",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10728:4:17",
                        "type": "",
                        "value": "0x32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10718:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10718:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10718:15:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10749:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10752:4:17",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "10742:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10742:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10742:15:17"
                }
              ]
            },
            "name": "panic_error_0x32",
            "nodeType": "YulFunctionDefinition",
            "src": "10636:127:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "10815:88:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "10846:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "10848:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "10848:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "10848:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "10831:5:17"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10842:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "not",
                          "nodeType": "YulIdentifier",
                          "src": "10838:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10838:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "eq",
                      "nodeType": "YulIdentifier",
                      "src": "10828:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10828:17:17"
                  },
                  "nodeType": "YulIf",
                  "src": "10825:43:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "10877:20:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "10888:5:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10895:1:17",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10884:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10884:13:17"
                  },
                  "variableNames": [
                    {
                      "name": "ret",
                      "nodeType": "YulIdentifier",
                      "src": "10877:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "increment_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "10797:5:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "ret",
                "nodeType": "YulTypedName",
                "src": "10807:3:17",
                "type": ""
              }
            ],
            "src": "10768:135:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "11082:181:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "11099:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11110:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11092:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11092:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11092:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "11133:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "11144:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "11129:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "11129:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11149:2:17",
                        "type": "",
                        "value": "31"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11122:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11122:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11122:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "11172:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "11183:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "11168:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "11168:18:17"
                      },
                      {
                        "hexValue": "4552433732313a20546f6b656e20494420616c7265616479206d696e746564",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "11188:33:17",
                        "type": "",
                        "value": "ERC721: Token ID already minted"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11161:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11161:61:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11161:61:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "11231:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "11243:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11254:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "11239:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11239:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "11231:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_4a1e787e6c9300109d749bc57a11ac0f4f61a945da0469e79b2b6790785e7589__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "11059:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "11073:4:17",
                "type": ""
              }
            ],
            "src": "10908:355:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "11442:179:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "11459:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11470:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11452:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11452:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11452:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "11493:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "11504:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "11489:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "11489:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11509:2:17",
                        "type": "",
                        "value": "29"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11482:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11482:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11482:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "11532:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "11543:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "11528:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "11528:18:17"
                      },
                      {
                        "hexValue": "4552433732313a20546f6b656e204944206e6f74207265736572766564",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "11548:31:17",
                        "type": "",
                        "value": "ERC721: Token ID not reserved"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11521:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11521:59:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11521:59:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "11589:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "11601:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11612:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "11597:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11597:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "11589:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_1c2c7d0b3442273531ca7db6f6355720ec7286f878a3a593f7011d0ce5fdeca1__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "11419:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "11433:4:17",
                "type": ""
              }
            ],
            "src": "11268:353:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "11800:237:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "11817:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11828:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11810:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11810:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11810:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "11851:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "11862:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "11847:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "11847:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11867:2:17",
                        "type": "",
                        "value": "47"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11840:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11840:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11840:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "11890:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "11901:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "11886:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "11886:18:17"
                      },
                      {
                        "hexValue": "4552433732314d657461646174613a2055524920717565727920666f72206e6f",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "11906:34:17",
                        "type": "",
                        "value": "ERC721Metadata: URI query for no"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11879:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11879:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11879:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "11961:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "11972:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "11957:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "11957:18:17"
                      },
                      {
                        "hexValue": "6e6578697374656e7420746f6b656e",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "11977:17:17",
                        "type": "",
                        "value": "nexistent token"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11950:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11950:45:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11950:45:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "12004:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "12016:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12027:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "12012:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12012:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "12004:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_a2d45c0fba603d40d82d590051761ca952d1ab9d78cca6d0d464d7b6e961a9cb__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "11777:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "11791:4:17",
                "type": ""
              }
            ],
            "src": "11626:411:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "12229:283:17",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "12239:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "12259:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "12253:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12253:13:17"
                  },
                  "variables": [
                    {
                      "name": "length",
                      "nodeType": "YulTypedName",
                      "src": "12243:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "12301:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "12309:4:17",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "12297:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "12297:17:17"
                      },
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "12316:3:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "12321:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "copy_memory_to_memory",
                      "nodeType": "YulIdentifier",
                      "src": "12275:21:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12275:53:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "12275:53:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "12337:29:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "12354:3:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "12359:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "12350:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12350:16:17"
                  },
                  "variables": [
                    {
                      "name": "end_1",
                      "nodeType": "YulTypedName",
                      "src": "12341:5:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "12375:29:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value1",
                        "nodeType": "YulIdentifier",
                        "src": "12397:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "12391:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12391:13:17"
                  },
                  "variables": [
                    {
                      "name": "length_1",
                      "nodeType": "YulTypedName",
                      "src": "12379:8:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value1",
                            "nodeType": "YulIdentifier",
                            "src": "12439:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "12447:4:17",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "12435:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "12435:17:17"
                      },
                      {
                        "name": "end_1",
                        "nodeType": "YulIdentifier",
                        "src": "12454:5:17"
                      },
                      {
                        "name": "length_1",
                        "nodeType": "YulIdentifier",
                        "src": "12461:8:17"
                      }
                    ],
                    "functionName": {
                      "name": "copy_memory_to_memory",
                      "nodeType": "YulIdentifier",
                      "src": "12413:21:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12413:57:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "12413:57:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "12479:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "end_1",
                        "nodeType": "YulIdentifier",
                        "src": "12490:5:17"
                      },
                      {
                        "name": "length_1",
                        "nodeType": "YulIdentifier",
                        "src": "12497:8:17"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "12486:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12486:20:17"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "12479:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_packed_t_string_memory_ptr_t_string_memory_ptr__to_t_string_memory_ptr_t_string_memory_ptr__nonPadded_inplace_fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "12197:3:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "12202:6:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "12210:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "12221:3:17",
                "type": ""
              }
            ],
            "src": "12042:470:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "12691:170:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "12708:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12719:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "12701:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12701:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "12701:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "12742:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "12753:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "12738:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "12738:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12758:2:17",
                        "type": "",
                        "value": "20"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "12731:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12731:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "12731:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "12781:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "12792:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "12777:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "12777:18:17"
                      },
                      {
                        "hexValue": "4d7573742070617920666f72206d696e74696e67",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "12797:22:17",
                        "type": "",
                        "value": "Must pay for minting"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "12770:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12770:50:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "12770:50:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "12829:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "12841:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12852:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "12837:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12837:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "12829:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_fccfa08521b2a4f02b9d2ab831967715a908f7cc2cad0af859fbb6558108466d__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "12668:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "12682:4:17",
                "type": ""
              }
            ],
            "src": "12517:344:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13040:171:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "13057:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13068:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13050:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13050:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13050:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13091:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13102:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13087:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13087:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13107:2:17",
                        "type": "",
                        "value": "21"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13080:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13080:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13080:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13130:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13141:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13126:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13126:18:17"
                      },
                      {
                        "hexValue": "546f6b656e20537570706c79204465706c65746564",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "13146:23:17",
                        "type": "",
                        "value": "Token Supply Depleted"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13119:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13119:51:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13119:51:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "13179:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "13191:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13202:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "13187:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13187:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "13179:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_87071b775c098f158e75d4151fe00b2f4e6b1c99f64ed70bf38a282a217e04e7__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "13017:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "13031:4:17",
                "type": ""
              }
            ],
            "src": "12866:345:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13407:14:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "13409:10:17",
                  "value": {
                    "name": "pos",
                    "nodeType": "YulIdentifier",
                    "src": "13416:3:17"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "13409:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_packed_t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470__to_t_bytes_memory_ptr__nonPadded_inplace_fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "13391:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "13399:3:17",
                "type": ""
              }
            ],
            "src": "13216:205:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13600:165:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "13617:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13628:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13610:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13610:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13610:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13651:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13662:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13647:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13647:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13667:2:17",
                        "type": "",
                        "value": "15"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13640:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13640:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13640:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13690:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13701:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13686:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13686:18:17"
                      },
                      {
                        "hexValue": "5472616e73666572204661696c6564",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "13706:17:17",
                        "type": "",
                        "value": "Transfer Failed"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13679:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13679:45:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13679:45:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "13733:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "13745:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13756:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "13741:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13741:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "13733:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_c5acabcb762867cdbcf367c30c495273eabea012d93b81d74177ab1ef966623f__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "13577:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "13591:4:17",
                "type": ""
              }
            ],
            "src": "13426:339:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13944:228:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "13961:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13972:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13954:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13954:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13954:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13995:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14006:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13991:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13991:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14011:2:17",
                        "type": "",
                        "value": "38"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13984:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13984:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13984:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14034:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14045:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14030:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14030:18:17"
                      },
                      {
                        "hexValue": "4f776e61626c653a206e6577206f776e657220697320746865207a65726f2061",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14050:34:17",
                        "type": "",
                        "value": "Ownable: new owner is the zero a"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14023:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14023:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14023:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14105:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14116:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14101:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14101:18:17"
                      },
                      {
                        "hexValue": "646472657373",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14121:8:17",
                        "type": "",
                        "value": "ddress"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14094:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14094:36:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14094:36:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "14139:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14151:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14162:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "14147:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14147:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "14139:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "13921:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "13935:4:17",
                "type": ""
              }
            ],
            "src": "13770:402:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "14351:234:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14368:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14379:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14361:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14361:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14361:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14402:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14413:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14398:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14398:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14418:2:17",
                        "type": "",
                        "value": "44"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14391:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14391:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14391:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14441:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14452:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14437:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14437:18:17"
                      },
                      {
                        "hexValue": "4552433732313a206f70657261746f7220717565727920666f72206e6f6e6578",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14457:34:17",
                        "type": "",
                        "value": "ERC721: operator query for nonex"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14430:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14430:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14430:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14512:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14523:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14508:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14508:18:17"
                      },
                      {
                        "hexValue": "697374656e7420746f6b656e",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14528:14:17",
                        "type": "",
                        "value": "istent token"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14501:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14501:42:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14501:42:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "14552:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14564:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14575:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "14560:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14560:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "14552:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_5797d1ccb08b83980dd0c07ea40d8f6a64d35fff736a19bdd17522954cb0899c__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "14328:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "14342:4:17",
                "type": ""
              }
            ],
            "src": "14177:408:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "14764:231:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14781:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14792:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14774:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14774:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14774:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14815:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14826:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14811:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14811:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14831:2:17",
                        "type": "",
                        "value": "41"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14804:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14804:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14804:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14854:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14865:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14850:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14850:18:17"
                      },
                      {
                        "hexValue": "4552433732313a207472616e73666572206f6620746f6b656e20746861742069",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14870:34:17",
                        "type": "",
                        "value": "ERC721: transfer of token that i"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14843:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14843:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14843:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14925:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14936:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14921:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14921:18:17"
                      },
                      {
                        "hexValue": "73206e6f74206f776e",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14941:11:17",
                        "type": "",
                        "value": "s not own"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14914:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14914:39:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14914:39:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "14962:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14974:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14985:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "14970:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14970:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "14962:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_a01073130a885d6c1c1af6ac75fc3b1c4f9403c235362962bbf528e2bd87d950__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "14741:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "14755:4:17",
                "type": ""
              }
            ],
            "src": "14590:405:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "15174:226:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "15191:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15202:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15184:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15184:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15184:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15225:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15236:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15221:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15221:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15241:2:17",
                        "type": "",
                        "value": "36"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15214:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15214:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15214:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15264:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15275:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15260:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15260:18:17"
                      },
                      {
                        "hexValue": "4552433732313a207472616e7366657220746f20746865207a65726f20616464",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "15280:34:17",
                        "type": "",
                        "value": "ERC721: transfer to the zero add"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15253:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15253:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15253:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15335:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15346:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15331:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15331:18:17"
                      },
                      {
                        "hexValue": "72657373",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "15351:6:17",
                        "type": "",
                        "value": "ress"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15324:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15324:34:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15324:34:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "15367:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "15379:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15390:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "15375:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15375:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "15367:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_455fea98ea03c32d7dd1a6f1426917d80529bf47b3ccbde74e7206e889e709f4__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "15151:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "15165:4:17",
                "type": ""
              }
            ],
            "src": "15000:400:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "15454:76:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "15476:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "15478:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "15478:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "15478:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "15470:1:17"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "15473:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "15467:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15467:8:17"
                  },
                  "nodeType": "YulIf",
                  "src": "15464:34:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "15507:17:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "15519:1:17"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "15522:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "sub",
                      "nodeType": "YulIdentifier",
                      "src": "15515:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15515:9:17"
                  },
                  "variableNames": [
                    {
                      "name": "diff",
                      "nodeType": "YulIdentifier",
                      "src": "15507:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "checked_sub_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "x",
                "nodeType": "YulTypedName",
                "src": "15436:1:17",
                "type": ""
              },
              {
                "name": "y",
                "nodeType": "YulTypedName",
                "src": "15439:1:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "diff",
                "nodeType": "YulTypedName",
                "src": "15445:4:17",
                "type": ""
              }
            ],
            "src": "15405:125:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "15583:80:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "15610:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "15612:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "15612:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "15612:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "15599:1:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "y",
                            "nodeType": "YulIdentifier",
                            "src": "15606:1:17"
                          }
                        ],
                        "functionName": {
                          "name": "not",
                          "nodeType": "YulIdentifier",
                          "src": "15602:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15602:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "15596:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15596:13:17"
                  },
                  "nodeType": "YulIf",
                  "src": "15593:39:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "15641:16:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "15652:1:17"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "15655:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "15648:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15648:9:17"
                  },
                  "variableNames": [
                    {
                      "name": "sum",
                      "nodeType": "YulIdentifier",
                      "src": "15641:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "checked_add_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "x",
                "nodeType": "YulTypedName",
                "src": "15566:1:17",
                "type": ""
              },
              {
                "name": "y",
                "nodeType": "YulTypedName",
                "src": "15569:1:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "sum",
                "nodeType": "YulTypedName",
                "src": "15575:3:17",
                "type": ""
              }
            ],
            "src": "15535:128:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "15842:178:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "15859:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15870:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15852:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15852:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15852:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15893:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15904:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15889:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15889:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15909:2:17",
                        "type": "",
                        "value": "28"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15882:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15882:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15882:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15932:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15943:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15928:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15928:18:17"
                      },
                      {
                        "hexValue": "5370656c6c206d757374206265202f5b612d7a302d395d7b31307d2f",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "15948:30:17",
                        "type": "",
                        "value": "Spell must be /[a-z0-9]{10}/"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15921:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15921:58:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15921:58:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "15988:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16000:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16011:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "15996:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15996:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "15988:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_aba60cc965cfe1c7515403b444382e9ca8447d0e21230479a8ddb6f5870b1445__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "15819:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "15833:4:17",
                "type": ""
              }
            ],
            "src": "15668:352:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "16174:168:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16191:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16202:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16184:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16184:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16184:21:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "16214:53:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "16240:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16252:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16263:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16248:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16248:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "16222:17:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16222:45:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "16214:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16287:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16298:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16283:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16283:18:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value1",
                            "nodeType": "YulIdentifier",
                            "src": "16307:6:17"
                          },
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "16323:3:17",
                                    "type": "",
                                    "value": "160"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "16328:1:17",
                                    "type": "",
                                    "value": "1"
                                  }
                                ],
                                "functionName": {
                                  "name": "shl",
                                  "nodeType": "YulIdentifier",
                                  "src": "16319:3:17"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "16319:11:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "16332:1:17",
                                "type": "",
                                "value": "1"
                              }
                            ],
                            "functionName": {
                              "name": "sub",
                              "nodeType": "YulIdentifier",
                              "src": "16315:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "16315:19:17"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "16303:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16303:32:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16276:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16276:60:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16276:60:17"
                }
              ]
            },
            "name": "abi_encode_tuple_t_string_memory_ptr_t_address__to_t_string_memory_ptr_t_address__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "16135:9:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "16146:6:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "16154:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "16165:4:17",
                "type": ""
              }
            ],
            "src": "16025:317:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "16521:175:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16538:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16549:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16531:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16531:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16531:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16572:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16583:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16568:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16568:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16588:2:17",
                        "type": "",
                        "value": "25"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16561:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16561:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16561:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16611:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16622:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16607:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16607:18:17"
                      },
                      {
                        "hexValue": "4552433732313a20617070726f766520746f2063616c6c6572",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "16627:27:17",
                        "type": "",
                        "value": "ERC721: approve to caller"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16600:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16600:55:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16600:55:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "16664:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16676:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16687:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "16672:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16672:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "16664:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_45fe4329685be5ecd250fd0e6a25aea0ea4d0e30fb6a73c118b95749e6d70d05__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "16498:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "16512:4:17",
                "type": ""
              }
            ],
            "src": "16347:349:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "16875:240:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16892:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16903:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16885:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16885:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16885:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16926:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16937:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16922:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16922:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16942:2:17",
                        "type": "",
                        "value": "50"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16915:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16915:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16915:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16965:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16976:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16961:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16961:18:17"
                      },
                      {
                        "hexValue": "4552433732313a207472616e7366657220746f206e6f6e204552433732315265",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "16981:34:17",
                        "type": "",
                        "value": "ERC721: transfer to non ERC721Re"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16954:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16954:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16954:62:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17036:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17047:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17032:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17032:18:17"
                      },
                      {
                        "hexValue": "63656976657220696d706c656d656e746572",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "17052:20:17",
                        "type": "",
                        "value": "ceiver implementer"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17025:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17025:48:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17025:48:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "17082:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "17094:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17105:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "17090:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17090:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "17082:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_1e766a06da43a53d0f4c380e06e5a342e14d5af1bf8501996c844905530ca84e__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "16852:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "16866:4:17",
                "type": ""
              }
            ],
            "src": "16701:414:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "17158:74:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "17181:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x12",
                            "nodeType": "YulIdentifier",
                            "src": "17183:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "17183:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "17183:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "17178:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "17171:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17171:9:17"
                  },
                  "nodeType": "YulIf",
                  "src": "17168:35:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "17212:14:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "17221:1:17"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "17224:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "mod",
                      "nodeType": "YulIdentifier",
                      "src": "17217:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17217:9:17"
                  },
                  "variableNames": [
                    {
                      "name": "r",
                      "nodeType": "YulIdentifier",
                      "src": "17212:1:17"
                    }
                  ]
                }
              ]
            },
            "name": "mod_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "x",
                "nodeType": "YulTypedName",
                "src": "17143:1:17",
                "type": ""
              },
              {
                "name": "y",
                "nodeType": "YulTypedName",
                "src": "17146:1:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "r",
                "nodeType": "YulTypedName",
                "src": "17152:1:17",
                "type": ""
              }
            ],
            "src": "17120:112:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "17440:286:17",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "17450:29:17",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17468:3:17",
                            "type": "",
                            "value": "160"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17473:1:17",
                            "type": "",
                            "value": "1"
                          }
                        ],
                        "functionName": {
                          "name": "shl",
                          "nodeType": "YulIdentifier",
                          "src": "17464:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17464:11:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17477:1:17",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "sub",
                      "nodeType": "YulIdentifier",
                      "src": "17460:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17460:19:17"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "17454:2:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "17495:9:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "17510:6:17"
                          },
                          {
                            "name": "_1",
                            "nodeType": "YulIdentifier",
                            "src": "17518:2:17"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "17506:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17506:15:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17488:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17488:34:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17488:34:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17542:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17553:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17538:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17538:18:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value1",
                            "nodeType": "YulIdentifier",
                            "src": "17562:6:17"
                          },
                          {
                            "name": "_1",
                            "nodeType": "YulIdentifier",
                            "src": "17570:2:17"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "17558:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17558:15:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17531:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17531:43:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17531:43:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17594:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17605:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17590:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17590:18:17"
                      },
                      {
                        "name": "value2",
                        "nodeType": "YulIdentifier",
                        "src": "17610:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17583:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17583:34:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17583:34:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17637:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17648:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17633:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17633:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17653:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17626:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17626:31:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17626:31:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "17666:54:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value3",
                        "nodeType": "YulIdentifier",
                        "src": "17692:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17704:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17715:3:17",
                            "type": "",
                            "value": "128"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17700:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17700:19:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "17674:17:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17674:46:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "17666:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_address_t_address_t_uint256_t_bytes_memory_ptr__to_t_address_t_address_t_uint256_t_bytes_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "17385:9:17",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "17396:6:17",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "17404:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "17412:6:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "17420:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "17431:4:17",
                "type": ""
              }
            ],
            "src": "17237:489:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "17811:169:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "17857:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "17866:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "17869:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "17859:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "17859:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "17859:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "17832:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17841:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "17828:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17828:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17853:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "17824:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17824:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "17821:52:17"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "17882:29:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "17901:9:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "17895:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17895:16:17"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "17886:5:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "17944:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_bytes4",
                      "nodeType": "YulIdentifier",
                      "src": "17920:23:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17920:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17920:30:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "17959:15:17",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "17969:5:17"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "17959:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_bytes4_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "17777:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "17788:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "17800:6:17",
                "type": ""
              }
            ],
            "src": "17731:249:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "18159:182:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "18176:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "18187:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18169:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18169:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18169:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18210:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "18221:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18206:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18206:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "18226:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18199:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18199:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18199:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18249:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "18260:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18245:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18245:18:17"
                      },
                      {
                        "hexValue": "4552433732313a206d696e7420746f20746865207a65726f2061646472657373",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "18265:34:17",
                        "type": "",
                        "value": "ERC721: mint to the zero address"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18238:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18238:62:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18238:62:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "18309:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "18321:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "18332:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "18317:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18317:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "18309:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_8a66f4bb6512ffbfcc3db9b42318eb65f26ac15163eaa9a1e5cfa7bee9d1c7c6__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "18136:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "18150:4:17",
                "type": ""
              }
            ],
            "src": "17985:356:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "18520:178:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "18537:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "18548:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18530:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18530:21:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18530:21:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18571:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "18582:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18567:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18567:18:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "18587:2:17",
                        "type": "",
                        "value": "28"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18560:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18560:30:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18560:30:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18610:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "18621:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18606:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18606:18:17"
                      },
                      {
                        "hexValue": "4552433732313a20746f6b656e20616c7265616479206d696e746564",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "18626:30:17",
                        "type": "",
                        "value": "ERC721: token already minted"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18599:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18599:58:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18599:58:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "18666:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "18678:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "18689:2:17",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "18674:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18674:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "18666:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_2a63ce106ef95058ed21fd07c42a10f11dc5c32ac13a4e847923f7759f635d57__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "18497:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "18511:4:17",
                "type": ""
              }
            ],
            "src": "18346:352:17"
          }
        ]
      },
      "contents": "{\n    { }\n    function validator_revert_bytes4(value)\n    {\n        if iszero(eq(value, and(value, shl(224, 0xffffffff)))) { revert(0, 0) }\n    }\n    function abi_decode_tuple_t_bytes4(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        let value := calldataload(headStart)\n        validator_revert_bytes4(value)\n        value0 := value\n    }\n    function abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed(headStart, value0) -> tail\n    {\n        tail := add(headStart, 32)\n        mstore(headStart, iszero(iszero(value0)))\n    }\n    function copy_memory_to_memory(src, dst, length)\n    {\n        let i := 0\n        for { } lt(i, length) { i := add(i, 32) }\n        {\n            mstore(add(dst, i), mload(add(src, i)))\n        }\n        if gt(i, length) { mstore(add(dst, length), 0) }\n    }\n    function abi_encode_string(value, pos) -> end\n    {\n        let length := mload(value)\n        mstore(pos, length)\n        copy_memory_to_memory(add(value, 0x20), add(pos, 0x20), length)\n        end := add(add(pos, and(add(length, 31), not(31))), 0x20)\n    }\n    function abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed(headStart, value0) -> tail\n    {\n        mstore(headStart, 32)\n        tail := abi_encode_string(value0, add(headStart, 32))\n    }\n    function abi_decode_tuple_t_uint256(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        value0 := calldataload(headStart)\n    }\n    function abi_encode_tuple_t_address__to_t_address__fromStack_reversed(headStart, value0) -> tail\n    {\n        tail := add(headStart, 32)\n        mstore(headStart, and(value0, sub(shl(160, 1), 1)))\n    }\n    function abi_decode_address(offset) -> value\n    {\n        value := calldataload(offset)\n        if iszero(eq(value, and(value, sub(shl(160, 1), 1)))) { revert(0, 0) }\n    }\n    function abi_decode_tuple_t_addresst_uint256(headStart, dataEnd) -> value0, value1\n    {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n        value0 := abi_decode_address(headStart)\n        value1 := calldataload(add(headStart, 32))\n    }\n    function abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed(headStart, value0) -> tail\n    {\n        tail := add(headStart, 32)\n        mstore(headStart, value0)\n    }\n    function abi_decode_tuple_t_addresst_addresst_uint256(headStart, dataEnd) -> value0, value1, value2\n    {\n        if slt(sub(dataEnd, headStart), 96) { revert(0, 0) }\n        value0 := abi_decode_address(headStart)\n        value1 := abi_decode_address(add(headStart, 32))\n        value2 := calldataload(add(headStart, 64))\n    }\n    function abi_decode_tuple_t_uint256t_uint256(headStart, dataEnd) -> value0, value1\n    {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n        value0 := calldataload(headStart)\n        value1 := calldataload(add(headStart, 32))\n    }\n    function abi_encode_tuple_t_address_t_uint256__to_t_address_t_uint256__fromStack_reversed(headStart, value1, value0) -> tail\n    {\n        tail := add(headStart, 64)\n        mstore(headStart, and(value0, sub(shl(160, 1), 1)))\n        mstore(add(headStart, 32), value1)\n    }\n    function abi_decode_tuple_t_address(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        value0 := abi_decode_address(headStart)\n    }\n    function panic_error_0x41()\n    {\n        mstore(0, shl(224, 0x4e487b71))\n        mstore(4, 0x41)\n        revert(0, 0x24)\n    }\n    function abi_decode_available_length_string(src, length, end) -> array\n    {\n        let _1 := 0xffffffffffffffff\n        if gt(length, _1) { panic_error_0x41() }\n        let _2 := not(31)\n        let memPtr := mload(64)\n        let newFreePtr := add(memPtr, and(add(and(add(length, 31), _2), 63), _2))\n        if or(gt(newFreePtr, _1), lt(newFreePtr, memPtr)) { panic_error_0x41() }\n        mstore(64, newFreePtr)\n        array := memPtr\n        mstore(memPtr, length)\n        if gt(add(src, length), end) { revert(0, 0) }\n        calldatacopy(add(memPtr, 0x20), src, length)\n        mstore(add(add(memPtr, length), 0x20), 0)\n    }\n    function abi_decode_string(offset, end) -> array\n    {\n        if iszero(slt(add(offset, 0x1f), end)) { revert(0, 0) }\n        array := abi_decode_available_length_string(add(offset, 0x20), calldataload(offset), end)\n    }\n    function abi_decode_tuple_t_string_memory_ptr(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        let offset := calldataload(headStart)\n        if gt(offset, 0xffffffffffffffff) { revert(0, 0) }\n        value0 := abi_decode_string(add(headStart, offset), dataEnd)\n    }\n    function abi_decode_tuple_t_string_memory_ptrt_uint256t_address(headStart, dataEnd) -> value0, value1, value2\n    {\n        if slt(sub(dataEnd, headStart), 96) { revert(0, 0) }\n        let offset := calldataload(headStart)\n        if gt(offset, 0xffffffffffffffff) { revert(0, 0) }\n        value0 := abi_decode_string(add(headStart, offset), dataEnd)\n        value1 := calldataload(add(headStart, 32))\n        value2 := abi_decode_address(add(headStart, 64))\n    }\n    function abi_decode_tuple_t_addresst_bool(headStart, dataEnd) -> value0, value1\n    {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n        value0 := abi_decode_address(headStart)\n        let value := calldataload(add(headStart, 32))\n        if iszero(eq(value, iszero(iszero(value)))) { revert(0, 0) }\n        value1 := value\n    }\n    function abi_decode_tuple_t_addresst_addresst_uint256t_bytes_memory_ptr(headStart, dataEnd) -> value0, value1, value2, value3\n    {\n        if slt(sub(dataEnd, headStart), 128) { revert(0, 0) }\n        value0 := abi_decode_address(headStart)\n        value1 := abi_decode_address(add(headStart, 32))\n        value2 := calldataload(add(headStart, 64))\n        let offset := calldataload(add(headStart, 96))\n        if gt(offset, 0xffffffffffffffff) { revert(0, 0) }\n        let _1 := add(headStart, offset)\n        if iszero(slt(add(_1, 0x1f), dataEnd)) { revert(0, 0) }\n        value3 := abi_decode_available_length_string(add(_1, 32), calldataload(_1), dataEnd)\n    }\n    function abi_decode_tuple_t_addresst_address(headStart, dataEnd) -> value0, value1\n    {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n        value0 := abi_decode_address(headStart)\n        value1 := abi_decode_address(add(headStart, 32))\n    }\n    function extract_byte_array_length(data) -> length\n    {\n        length := shr(1, data)\n        let outOfPlaceEncoding := and(data, 1)\n        if iszero(outOfPlaceEncoding) { length := and(length, 0x7f) }\n        if eq(outOfPlaceEncoding, lt(length, 32))\n        {\n            mstore(0, shl(224, 0x4e487b71))\n            mstore(4, 0x22)\n            revert(0, 0x24)\n        }\n    }\n    function abi_encode_tuple_t_stringliteral_9291e0f44949204f2e9b40e6be090924979d6047b2365868f4e9f027722eb89d__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 44)\n        mstore(add(headStart, 64), \"ERC721: approved query for nonex\")\n        mstore(add(headStart, 96), \"istent token\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_b51b4875eede07862961e8f9365c6749f5fe55c6ee5d7a9e42b6912ad0b15942__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 33)\n        mstore(add(headStart, 64), \"ERC721: approval to current owne\")\n        mstore(add(headStart, 96), \"r\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_6d83cef3e0cb19b8320a9c5feb26b56bbb08f152a8e61b12eca3302d8d68b23d__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 56)\n        mstore(add(headStart, 64), \"ERC721: approve caller is not ow\")\n        mstore(add(headStart, 96), \"ner nor approved for all\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_c8682f3ad98807db59a6ec6bb812b72fed0a66e3150fa8239699ee83885247f2__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 49)\n        mstore(add(headStart, 64), \"ERC721: transfer caller is not o\")\n        mstore(add(headStart, 96), \"wner nor approved\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_54ec63a34df5f93dcd1e2de2b3cda8a7cad00cf9da902f0e9a30741ff9bcf20d__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 28)\n        mstore(add(headStart, 64), \"ERC721: Nonexistent Token ID\")\n        tail := add(headStart, 96)\n    }\n    function panic_error_0x11()\n    {\n        mstore(0, shl(224, 0x4e487b71))\n        mstore(4, 0x11)\n        revert(0, 0x24)\n    }\n    function checked_mul_t_uint256(x, y) -> product\n    {\n        if and(iszero(iszero(x)), gt(y, div(not(0), x))) { panic_error_0x11() }\n        product := mul(x, y)\n    }\n    function panic_error_0x12()\n    {\n        mstore(0, shl(224, 0x4e487b71))\n        mstore(4, 0x12)\n        revert(0, 0x24)\n    }\n    function checked_div_t_uint256(x, y) -> r\n    {\n        if iszero(y) { panic_error_0x12() }\n        r := div(x, y)\n    }\n    function abi_encode_tuple_t_stringliteral_7481f3df2a424c0755a1ad2356614e9a5a358d461ea2eae1f89cb21cbad00397__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 41)\n        mstore(add(headStart, 64), \"ERC721: owner query for nonexist\")\n        mstore(add(headStart, 96), \"ent token\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 32)\n        mstore(add(headStart, 64), \"Ownable: caller is not the owner\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_7395d4d3901c50cdfcab223d072f9aa36241df5d883e62cbf147ee1b05a9e6ba__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 42)\n        mstore(add(headStart, 64), \"ERC721: balance query for the ze\")\n        mstore(add(headStart, 96), \"ro address\")\n        tail := add(headStart, 128)\n    }\n    function panic_error_0x32()\n    {\n        mstore(0, shl(224, 0x4e487b71))\n        mstore(4, 0x32)\n        revert(0, 0x24)\n    }\n    function increment_t_uint256(value) -> ret\n    {\n        if eq(value, not(0)) { panic_error_0x11() }\n        ret := add(value, 1)\n    }\n    function abi_encode_tuple_t_stringliteral_4a1e787e6c9300109d749bc57a11ac0f4f61a945da0469e79b2b6790785e7589__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 31)\n        mstore(add(headStart, 64), \"ERC721: Token ID already minted\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_1c2c7d0b3442273531ca7db6f6355720ec7286f878a3a593f7011d0ce5fdeca1__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 29)\n        mstore(add(headStart, 64), \"ERC721: Token ID not reserved\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_a2d45c0fba603d40d82d590051761ca952d1ab9d78cca6d0d464d7b6e961a9cb__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 47)\n        mstore(add(headStart, 64), \"ERC721Metadata: URI query for no\")\n        mstore(add(headStart, 96), \"nexistent token\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_packed_t_string_memory_ptr_t_string_memory_ptr__to_t_string_memory_ptr_t_string_memory_ptr__nonPadded_inplace_fromStack_reversed(pos, value1, value0) -> end\n    {\n        let length := mload(value0)\n        copy_memory_to_memory(add(value0, 0x20), pos, length)\n        let end_1 := add(pos, length)\n        let length_1 := mload(value1)\n        copy_memory_to_memory(add(value1, 0x20), end_1, length_1)\n        end := add(end_1, length_1)\n    }\n    function abi_encode_tuple_t_stringliteral_fccfa08521b2a4f02b9d2ab831967715a908f7cc2cad0af859fbb6558108466d__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 20)\n        mstore(add(headStart, 64), \"Must pay for minting\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_87071b775c098f158e75d4151fe00b2f4e6b1c99f64ed70bf38a282a217e04e7__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 21)\n        mstore(add(headStart, 64), \"Token Supply Depleted\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_packed_t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470__to_t_bytes_memory_ptr__nonPadded_inplace_fromStack_reversed(pos) -> end\n    { end := pos }\n    function abi_encode_tuple_t_stringliteral_c5acabcb762867cdbcf367c30c495273eabea012d93b81d74177ab1ef966623f__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 15)\n        mstore(add(headStart, 64), \"Transfer Failed\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 38)\n        mstore(add(headStart, 64), \"Ownable: new owner is the zero a\")\n        mstore(add(headStart, 96), \"ddress\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_5797d1ccb08b83980dd0c07ea40d8f6a64d35fff736a19bdd17522954cb0899c__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 44)\n        mstore(add(headStart, 64), \"ERC721: operator query for nonex\")\n        mstore(add(headStart, 96), \"istent token\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_a01073130a885d6c1c1af6ac75fc3b1c4f9403c235362962bbf528e2bd87d950__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 41)\n        mstore(add(headStart, 64), \"ERC721: transfer of token that i\")\n        mstore(add(headStart, 96), \"s not own\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_455fea98ea03c32d7dd1a6f1426917d80529bf47b3ccbde74e7206e889e709f4__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 36)\n        mstore(add(headStart, 64), \"ERC721: transfer to the zero add\")\n        mstore(add(headStart, 96), \"ress\")\n        tail := add(headStart, 128)\n    }\n    function checked_sub_t_uint256(x, y) -> diff\n    {\n        if lt(x, y) { panic_error_0x11() }\n        diff := sub(x, y)\n    }\n    function checked_add_t_uint256(x, y) -> sum\n    {\n        if gt(x, not(y)) { panic_error_0x11() }\n        sum := add(x, y)\n    }\n    function abi_encode_tuple_t_stringliteral_aba60cc965cfe1c7515403b444382e9ca8447d0e21230479a8ddb6f5870b1445__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 28)\n        mstore(add(headStart, 64), \"Spell must be /[a-z0-9]{10}/\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_string_memory_ptr_t_address__to_t_string_memory_ptr_t_address__fromStack_reversed(headStart, value1, value0) -> tail\n    {\n        mstore(headStart, 64)\n        tail := abi_encode_string(value0, add(headStart, 64))\n        mstore(add(headStart, 32), and(value1, sub(shl(160, 1), 1)))\n    }\n    function abi_encode_tuple_t_stringliteral_45fe4329685be5ecd250fd0e6a25aea0ea4d0e30fb6a73c118b95749e6d70d05__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 25)\n        mstore(add(headStart, 64), \"ERC721: approve to caller\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_1e766a06da43a53d0f4c380e06e5a342e14d5af1bf8501996c844905530ca84e__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 50)\n        mstore(add(headStart, 64), \"ERC721: transfer to non ERC721Re\")\n        mstore(add(headStart, 96), \"ceiver implementer\")\n        tail := add(headStart, 128)\n    }\n    function mod_t_uint256(x, y) -> r\n    {\n        if iszero(y) { panic_error_0x12() }\n        r := mod(x, y)\n    }\n    function abi_encode_tuple_t_address_t_address_t_uint256_t_bytes_memory_ptr__to_t_address_t_address_t_uint256_t_bytes_memory_ptr__fromStack_reversed(headStart, value3, value2, value1, value0) -> tail\n    {\n        let _1 := sub(shl(160, 1), 1)\n        mstore(headStart, and(value0, _1))\n        mstore(add(headStart, 32), and(value1, _1))\n        mstore(add(headStart, 64), value2)\n        mstore(add(headStart, 96), 128)\n        tail := abi_encode_string(value3, add(headStart, 128))\n    }\n    function abi_decode_tuple_t_bytes4_fromMemory(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        let value := mload(headStart)\n        validator_revert_bytes4(value)\n        value0 := value\n    }\n    function abi_encode_tuple_t_stringliteral_8a66f4bb6512ffbfcc3db9b42318eb65f26ac15163eaa9a1e5cfa7bee9d1c7c6__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 32)\n        mstore(add(headStart, 64), \"ERC721: mint to the zero address\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_2a63ce106ef95058ed21fd07c42a10f11dc5c32ac13a4e847923f7759f635d57__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 28)\n        mstore(add(headStart, 64), \"ERC721: token already minted\")\n        tail := add(headStart, 96)\n    }\n}",
      "id": 17,
      "language": "Yul",
      "name": "#utility.yul"
    }
  ],
  "sourceMap": "615:3:15:-:0;587:31;;;;647:19;624:42;;754:298;404:4915;754:298;876:1;404:4915;754:298;;;881:1;754:298;;886:1;754:298;;891:1;754:298;;896:2;754:298;;;;901:2;754:298;;906:2;754:298;;911:2;754:298;;923:2;754:298;;928:2;754:298;;933:2;754:298;;938:2;754:298;;943:2;754:298;;948:2;754:298;;953:2;754:298;;958:2;754:298;;970:2;754:298;;975:2;754:298;;980:2;754:298;;985:2;754:298;;990:2;754:298;;995:2;754:298;;1000:3;754:298;;1005:3;754:298;;1018:3;754:298;;1023:3;754:298;;1028:3;754:298;;1033:3;754:298;;1038:3;754:298;;;;;;;;;896:2;754:298;;:::i;:::-;-1:-1:-1;1237:76:15;;;-1:-1:-1;;;;;;1237:76:15;1271:42;1237:76;;;;1332:35;;1541:540;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;1441:13:3;;1659:5:15;;1666:7;;1441:13:3;;:5;;:13;;;;;:::i;:::-;-1:-1:-1;1464:17:3;;;;:7;;:17;;;;;:::i;:::-;;1375:113;;921:32:0;940:12;:10;;;:12;;:::i;:::-;921:18;:32::i;:::-;1685:24:15;;::::1;::::0;:13:::1;::::0;:24:::1;::::0;::::1;::::0;::::1;:::i;:::-;-1:-1:-1::0;1769:40:15::1;-1:-1:-1::0;;;1769:18:15::1;:40::i;:::-;1819:41;-1:-1:-1::0;;;1819:18:15::1;:41::i;:::-;1904:9;1899:114;1923:19;1919:1;:23;1899:114;;;1998:4;1963:15;:32;1979:12;1992:1;1979:15;;;;;;;:::i;:::-;;::::0;1963:32;;::::1;::::0;::::1;::::0;;;;;;-1:-1:-1;1963:32:15;:39;;-1:-1:-1;;1963:39:15::1;::::0;::::1;;::::0;;;::::1;::::0;;1944:3;::::1;::::0;::::1;:::i;:::-;;;;1899:114;;;;2053:21;:9;:19;;;;;:21;;:::i;:::-;1541:540:::0;;;404:4915;;640:96:8;719:10;;640:96::o;2270:187:0:-;2362:6;;;-1:-1:-1;;;;;2378:17:0;;;-1:-1:-1;;;;;;2378:17:0;;;;;;;2410:40;;2362:6;;;2378:17;2362:6;;2410:40;;2343:16;;2410:40;2333:124;2270:187;:::o;1178:198:12:-;-1:-1:-1;;;;;;1261:25:12;;;;;1253:66;;;;-1:-1:-1;;;1253:66:12;;2378:2:17;1253:66:12;;;2360:21:17;2417:2;2397:18;;;2390:30;2456;2436:18;;;2429:58;2504:18;;1253:66:12;;;;;;;;-1:-1:-1;;;;;;1329:33:12;;;;;:20;:33;;;;;:40;;-1:-1:-1;;1329:40:12;1365:4;1329:40;;;1178:198::o;945:123:9:-;1032:19;;1050:1;1032:19;;;945:123::o;404:4915:15:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;404:4915:15;;;-1:-1:-1;404:4915:15;:::i;:::-;;;:::o;:::-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;14:127:17;75:10;70:3;66:20;63:1;56:31;106:4;103:1;96:15;130:4;127:1;120:15;146:885;200:5;253:3;246:4;238:6;234:17;230:27;220:55;;271:1;268;261:12;220:55;294:13;;-1:-1:-1;;;;;356:10:17;;;353:36;;;369:18;;:::i;:::-;444:2;438:9;412:2;498:13;;-1:-1:-1;;494:22:17;;;518:2;490:31;486:40;474:53;;;542:18;;;562:22;;;539:46;536:72;;;588:18;;:::i;:::-;628:10;624:2;617:22;663:2;655:6;648:18;685:4;675:14;;730:3;725:2;720;712:6;708:15;704:24;701:33;698:53;;;747:1;744;737:12;698:53;769:1;760:10;;779:133;793:2;790:1;787:9;779:133;;;881:14;;;877:23;;871:30;850:14;;;846:23;;839:63;804:10;;;;779:133;;;930:2;927:1;924:9;921:80;;;989:1;984:2;979;971:6;967:15;963:24;956:35;921:80;1019:6;146:885;-1:-1:-1;;;;;;146:885:17:o;1036:766::-;1154:6;1162;1170;1223:2;1211:9;1202:7;1198:23;1194:32;1191:52;;;1239:1;1236;1229:12;1191:52;1266:16;;-1:-1:-1;;;;;1331:14:17;;;1328:34;;;1358:1;1355;1348:12;1328:34;1381:61;1434:7;1425:6;1414:9;1410:22;1381:61;:::i;:::-;1371:71;;1488:2;1477:9;1473:18;1467:25;1451:41;;1517:2;1507:8;1504:16;1501:36;;;1533:1;1530;1523:12;1501:36;1556:63;1611:7;1600:8;1589:9;1585:24;1556:63;:::i;:::-;1546:73;;1665:2;1654:9;1650:18;1644:25;1628:41;;1694:2;1684:8;1681:16;1678:36;;;1710:1;1707;1700:12;1678:36;;1733:63;1788:7;1777:8;1766:9;1762:24;1733:63;:::i;:::-;1723:73;;;1036:766;;;;;:::o;1807:127::-;1868:10;1863:3;1859:20;1856:1;1849:31;1899:4;1896:1;1889:15;1923:4;1920:1;1913:15;1939:232;1978:3;-1:-1:-1;;1999:17:17;;1996:140;;;2058:10;2053:3;2049:20;2046:1;2039:31;2093:4;2090:1;2083:15;2121:4;2118:1;2111:15;1996:140;-1:-1:-1;2163:1:17;2152:13;;1939:232::o;2533:380::-;2612:1;2608:12;;;;2655;;;2676:61;;2730:4;2722:6;2718:17;2708:27;;2676:61;2783:2;2775:6;2772:14;2752:18;2749:38;2746:161;;;2829:10;2824:3;2820:20;2817:1;2810:31;2864:4;2861:1;2854:15;2892:4;2889:1;2882:15;2746:161;;2533:380;;;:::o;:::-;404:4915:15;;;;;;",
  "deployedSourceMap": "404:4915:15:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4310:283;;;;;;;;;;-1:-1:-1;4310:283:15;;;;;:::i;:::-;;:::i;:::-;;;565:14:17;;558:22;540:41;;528:2;513:18;4310:283:15;;;;;;;;2473:98:3;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;3984:217::-;;;;;;;;;;-1:-1:-1;3984:217:3;;;;;:::i;:::-;;:::i;:::-;;;-1:-1:-1;;;;;1692:32:17;;;1674:51;;1662:2;1647:18;3984:217:3;1528:203:17;3522:401:3;;;;;;;;;;-1:-1:-1;3522:401:3;;;;;:::i;:::-;;:::i;:::-;;4816:98:15;;;;;;;;;;;;;:::i;:::-;;;2319:25:17;;;2307:2;2292:18;4816:98:15;2173:177:17;1113:48:15;;;;;;;;;;-1:-1:-1;1113:48:15;;;;;:::i;:::-;;:::i;4711:330:3:-;;;;;;;;;;-1:-1:-1;4711:330:3;;;;;:::i;:::-;;:::i;3944:359:15:-;;;;;;;;;;-1:-1:-1;3944:359:15;;;;;:::i;:::-;;:::i;:::-;;;;-1:-1:-1;;;;;3133:32:17;;;3115:51;;3197:2;3182:18;;3175:34;;;;3088:18;3944:359:15;2941:274:17;587:31:15;;;;;;;;;;;;;;;;5107:179:3;;;;;;;;;;-1:-1:-1;5107:179:3;;;;;:::i;:::-;;:::i;2176:235::-;;;;;;;;;;-1:-1:-1;2176:235:3;;;;;:::i;:::-;;:::i;4600:96:15:-;;;;;;;;;;-1:-1:-1;4600:96:15;;;;;:::i;:::-;;:::i;1914:205:3:-;;;;;;;;;;-1:-1:-1;1914:205:3;;;;;:::i;:::-;;:::i;1668:101:0:-;;;;;;;;;;;;;:::i;3064:464:15:-;;;;;;;;;;-1:-1:-1;3064:464:15;;;;;:::i;:::-;;:::i;4703:106::-;;;;;;;;;;-1:-1:-1;4703:106:15;;;;;:::i;:::-;;:::i;624:42::-;;;;;;;;;;;;;;;;1036:85:0;;;;;;;;;;-1:-1:-1;1108:6:0;;-1:-1:-1;;;;;1108:6:0;1036:85;;2088:291:15;;;;;;;;;;-1:-1:-1;2088:291:15;;;;;:::i;:::-;;:::i;2635:102:3:-;;;;;;;;;;;;;:::i;4268:153::-;;;;;;;;;;-1:-1:-1;4268:153:3;;;;;:::i;:::-;;:::i;5352:320::-;;;;;;;;;;-1:-1:-1;5352:320:3;;;;;:::i;:::-;;:::i;2803:329::-;;;;;;;;;;-1:-1:-1;2803:329:3;;;;;:::i;:::-;;:::i;2386:627:15:-;;;;;;:::i;:::-;;:::i;4487:162:3:-;;;;;;;;;;-1:-1:-1;4487:162:3;;;;;:::i;:::-;-1:-1:-1;;;;;4607:25:3;;;4584:4;4607:25;;;:18;:25;;;;;;;;:35;;;;;;;;;;;;;;;4487:162;1918:198:0;;;;;;;;;;-1:-1:-1;1918:198:0;;;;;:::i;:::-;;:::i;4310:283:15:-;4474:4;-1:-1:-1;;;;;;4505:41:15;;-1:-1:-1;;;4505:41:15;;:81;;;4550:36;4574:11;4550:23;:36::i;:::-;4498:88;4310:283;-1:-1:-1;;4310:283:15:o;2473:98:3:-;2527:13;2559:5;2552:12;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2473:98;:::o;3984:217::-;4060:7;4087:16;4095:7;4087;:16::i;:::-;4079:73;;;;-1:-1:-1;;;4079:73:3;;7079:2:17;4079:73:3;;;7061:21:17;7118:2;7098:18;;;7091:30;7157:34;7137:18;;;7130:62;-1:-1:-1;;;7208:18:17;;;7201:42;7260:19;;4079:73:3;;;;;;;;;-1:-1:-1;4170:24:3;;;;:15;:24;;;;;;-1:-1:-1;;;;;4170:24:3;;3984:217::o;3522:401::-;3602:13;3618:23;3633:7;3618:14;:23::i;:::-;3602:39;;3665:5;-1:-1:-1;;;;;3659:11:3;:2;-1:-1:-1;;;;;3659:11:3;;;3651:57;;;;-1:-1:-1;;;3651:57:3;;7492:2:17;3651:57:3;;;7474:21:17;7531:2;7511:18;;;7504:30;7570:34;7550:18;;;7543:62;-1:-1:-1;;;7621:18:17;;;7614:31;7662:19;;3651:57:3;7290:397:17;3651:57:3;719:10:8;-1:-1:-1;;;;;3740:21:3;;;;:62;;-1:-1:-1;3765:37:3;3782:5;719:10:8;4487:162:3;:::i;3765:37::-;3719:165;;;;-1:-1:-1;;;3719:165:3;;7894:2:17;3719:165:3;;;7876:21:17;7933:2;7913:18;;;7906:30;7972:34;7952:18;;;7945:62;8043:26;8023:18;;;8016:54;8087:19;;3719:165:3;7692:420:17;3719:165:3;3895:21;3904:2;3908:7;3895:8;:21::i;:::-;3592:331;3522:401;;:::o;4816:98:15:-;4862:7;4888:19;:9;918:14:9;;827:112;4888:19:15;4881:26;;4816:98;:::o;1113:48::-;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;4711:330:3:-;4900:41;719:10:8;4933:7:3;4900:18;:41::i;:::-;4892:103;;;;-1:-1:-1;;;4892:103:3;;;;;;;:::i;:::-;5006:28;5016:4;5022:2;5026:7;5006:9;:28::i;3944:359:15:-;4076:16;4102:22;4149:17;4157:8;4149:7;:17::i;:::-;4141:58;;;;-1:-1:-1;;;4141:58:15;;8737:2:17;4141:58:15;;;8719:21:17;8776:2;8756:18;;;8749:30;8815;8795:18;;;8788:58;8863:18;;4141:58:15;8535:352:17;4141:58:15;4220:15;;4275;;-1:-1:-1;;;;;4220:15:15;;;;-1:-1:-1;4293:3:15;;4262:28;;:10;:28;:::i;:::-;:34;;;;:::i;:::-;4245:51;;3944:359;;;;;:::o;5107:179:3:-;5240:39;5257:4;5263:2;5267:7;5240:39;;;;;;;;;;;;:16;:39::i;2176:235::-;2248:7;2283:16;;;:7;:16;;;;;;-1:-1:-1;;;;;2283:16:3;2317:19;2309:73;;;;-1:-1:-1;;;2309:73:3;;9656:2:17;2309:73:3;;;9638:21:17;9695:2;9675:18;;;9668:30;9734:34;9714:18;;;9707:62;-1:-1:-1;;;9785:18:17;;;9778:39;9834:19;;2309:73:3;9454:405:17;4600:96:15;1108:6:0;;-1:-1:-1;;;;;1108:6:0;719:10:8;1248:23:0;1240:68;;;;-1:-1:-1;;;1240:68:0;;;;;;;:::i;:::-;4668:15:15::1;:21:::0;;-1:-1:-1;;;;;;4668:21:15::1;-1:-1:-1::0;;;;;4668:21:15;;;::::1;::::0;;;::::1;::::0;;4600:96::o;1914:205:3:-;1986:7;-1:-1:-1;;;;;2013:19:3;;2005:74;;;;-1:-1:-1;;;2005:74:3;;10427:2:17;2005:74:3;;;10409:21:17;10466:2;10446:18;;;10439:30;10505:34;10485:18;;;10478:62;-1:-1:-1;;;10556:18:17;;;10549:40;10606:19;;2005:74:3;10225:406:17;2005:74:3;-1:-1:-1;;;;;;2096:16:3;;;;;:9;:16;;;;;;;1914:205::o;1668:101:0:-;1108:6;;-1:-1:-1;;;;;1108:6:0;719:10:8;1248:23:0;1240:68;;;;-1:-1:-1;;;1240:68:0;;;;;;;:::i;:::-;1732:30:::1;1759:1;1732:18;:30::i;:::-;1668:101::o:0;3064:464:15:-;3194:8;;3126:4;;3165;;3223:2;3216:9;;3212:60;;-1:-1:-1;3256:5:15;;3064:464;-1:-1:-1;;;3064:464:15:o;3212:60::-;3286:9;3281:220;3301:3;3297:1;:7;3281:220;;;3325:8;3336:1;3338;3336:4;;;;;;;;:::i;:::-;;;;;-1:-1:-1;;;;;;3336:4:15;;-1:-1:-1;;;;3359:9:15;;;;;:22;;-1:-1:-1;;;;;;;;;;3372:9:15;;;;3359:22;3357:25;:78;;;;-1:-1:-1;;;;;;;;;;3412:9:15;;;;;;:22;;-1:-1:-1;;;;;;;;;;3425:9:15;;;;3412:22;3410:25;3357:78;3354:137;;;-1:-1:-1;3471:5:15;;3064:464;-1:-1:-1;;;;;3064:464:15:o;3354:137::-;-1:-1:-1;3306:3:15;;;;:::i;:::-;;;;3281:220;;;-1:-1:-1;3517:4:15;;3064:464;-1:-1:-1;;;;3064:464:15:o;4703:106::-;1108:6:0;;-1:-1:-1;;;;;1108:6:0;719:10:8;1248:23:0;1240:68;;;;-1:-1:-1;;;1240:68:0;;;;;;;:::i;:::-;4776:15:15::1;:26:::0;4703:106::o;2088:291::-;1108:6:0;;-1:-1:-1;;;;;1108:6:0;719:10:8;1248:23:0;1240:68;;;;-1:-1:-1;;;1240:68:0;;;;;;;:::i;:::-;2199:17:15::1;2207:8;2199:7;:17::i;:::-;2198:18;2190:62;;;::::0;-1:-1:-1;;;2190:62:15;;11110:2:17;2190:62:15::1;::::0;::::1;11092:21:17::0;11149:2;11129:18;;;11122:30;11188:33;11168:18;;;11161:61;11239:18;;2190:62:15::1;10908:355:17::0;2190:62:15::1;2270:25;::::0;;;:15:::1;:25;::::0;;;;;::::1;;2262:67;;;::::0;-1:-1:-1;;;2262:67:15;;11470:2:17;2262:67:15::1;::::0;::::1;11452:21:17::0;11509:2;11489:18;;;11482:30;11548:31;11528:18;;;11521:59;11597:18;;2262:67:15::1;11268:353:17::0;2262:67:15::1;2339:33;2350:6;2358:8;2368:3;2339:10;:33::i;2635:102:3:-:0;2691:13;2723:7;2716:14;;;;;:::i;4268:153::-;4362:52;719:10:8;4395:8:3;4405;4362:18;:52::i;:::-;4268:153;;:::o;5352:320::-;5521:41;719:10:8;5554:7:3;5521:18;:41::i;:::-;5513:103;;;;-1:-1:-1;;;5513:103:3;;;;;;;:::i;:::-;5626:39;5640:4;5646:2;5650:7;5659:5;5626:13;:39::i;:::-;5352:320;;;;:::o;2803:329::-;2876:13;2909:16;2917:7;2909;:16::i;:::-;2901:76;;;;-1:-1:-1;;;2901:76:3;;11828:2:17;2901:76:3;;;11810:21:17;11867:2;11847:18;;;11840:30;11906:34;11886:18;;;11879:62;-1:-1:-1;;;11957:18:17;;;11950:45;12012:19;;2901:76:3;11626:411:17;2901:76:3;2988:21;3012:10;:8;:10::i;:::-;2988:34;;3063:1;3045:7;3039:21;:25;:86;;;;;;;;;;;;;;;;;3091:7;3100:18;:7;:16;:18::i;:::-;3074:45;;;;;;;;;:::i;:::-;;;;;;;;;;;;;3039:86;3032:93;2803:329;-1:-1:-1;;;2803:329:3:o;2386:627:15:-;2468:5;;2455:9;:18;;2447:51;;;;-1:-1:-1;;;2447:51:15;;12719:2:17;2447:51:15;;;12701:21:17;12758:2;12738:18;;;12731:30;-1:-1:-1;;;12777:18:17;;;12770:50;12837:18;;2447:51:15;12517:344:17;2447:51:15;2508:15;2533:313;-1:-1:-1;2570:9:15;918:14:9;2607:24:15;;;;:15;:24;;;;;;;;;:44;;;2635:16;2643:7;2635;:16::i;:::-;2603:233;;;2671:21;:9;1032:19:9;;1050:1;1032:19;;;945:123;2671:21:15;2741:10;;2718:9;918:14:9;2718:33:15;;2710:67;;;;-1:-1:-1;;;2710:67:15;;13068:2:17;2710:67:15;;;13050:21:17;13107:2;13087:18;;;13080:30;-1:-1:-1;;;13126:18:17;;;13119:51;13187:18;;2710:67:15;12866:345:17;2710:67:15;2533:313;;2603:233;2856:12;2874:7;1108:6:0;;-1:-1:-1;;;;;1108:6:0;;1036:85;2874:7:15;-1:-1:-1;;;;;2874:12:15;2895:9;2874:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2855:55;;;2928:7;2920:35;;;;-1:-1:-1;;;2920:35:15;;13628:2:17;2920:35:15;;;13610:21:17;13667:2;13647:18;;;13640:30;-1:-1:-1;;;13686:18:17;;;13679:45;13741:18;;2920:35:15;13426:339:17;2920:35:15;2965:41;2976:6;2984:7;719:10:8;2965::15;:41::i;1918:198:0:-;1108:6;;-1:-1:-1;;;;;1108:6:0;719:10:8;1248:23:0;1240:68;;;;-1:-1:-1;;;1240:68:0;;;;;;;:::i;:::-;-1:-1:-1;;;;;2006:22:0;::::1;1998:73;;;::::0;-1:-1:-1;;;1998:73:0;;13972:2:17;1998:73:0::1;::::0;::::1;13954:21:17::0;14011:2;13991:18;;;13984:30;14050:34;14030:18;;;14023:62;-1:-1:-1;;;14101:18:17;;;14094:36;14147:19;;1998:73:0::1;13770:402:17::0;1998:73:0::1;2081:28;2100:8;2081:18;:28::i;:::-;1918:198:::0;:::o;945:123:9:-;1032:19;;1050:1;1032:19;;;945:123::o;596:188:12:-;681:4;704:36;728:11;704:23;:36::i;:::-;:73;;;-1:-1:-1;;;;;;;;744:33:12;;;;;:20;:33;;;;;;;;;596:188::o;7144:125:3:-;7209:4;7232:16;;;:7;:16;;;;;;-1:-1:-1;;;;;7232:16:3;:30;;;7144:125::o;10995:171::-;11069:24;;;;:15;:24;;;;;:29;;-1:-1:-1;;;;;;11069:29:3;-1:-1:-1;;;;;11069:29:3;;;;;;;;:24;;11122:23;11069:24;11122:14;:23::i;:::-;-1:-1:-1;;;;;11113:46:3;;;;;;;;;;;10995:171;;:::o;7427:344::-;7520:4;7544:16;7552:7;7544;:16::i;:::-;7536:73;;;;-1:-1:-1;;;7536:73:3;;14379:2:17;7536:73:3;;;14361:21:17;14418:2;14398:18;;;14391:30;14457:34;14437:18;;;14430:62;-1:-1:-1;;;14508:18:17;;;14501:42;14560:19;;7536:73:3;14177:408:17;7536:73:3;7619:13;7635:23;7650:7;7635:14;:23::i;:::-;7619:39;;7687:5;-1:-1:-1;;;;;7676:16:3;:7;-1:-1:-1;;;;;7676:16:3;;:51;;;;7720:7;-1:-1:-1;;;;;7696:31:3;:20;7708:7;7696:11;:20::i;:::-;-1:-1:-1;;;;;7696:31:3;;7676:51;:87;;;-1:-1:-1;;;;;;4607:25:3;;;4584:4;4607:25;;;:18;:25;;;;;;;;:35;;;;;;;;;;;;7731:32;7668:96;7427:344;-1:-1:-1;;;;7427:344:3:o;10324:560::-;10478:4;-1:-1:-1;;;;;10451:31:3;:23;10466:7;10451:14;:23::i;:::-;-1:-1:-1;;;;;10451:31:3;;10443:85;;;;-1:-1:-1;;;10443:85:3;;14792:2:17;10443:85:3;;;14774:21:17;14831:2;14811:18;;;14804:30;14870:34;14850:18;;;14843:62;-1:-1:-1;;;14921:18:17;;;14914:39;14970:19;;10443:85:3;14590:405:17;10443:85:3;-1:-1:-1;;;;;10546:16:3;;10538:65;;;;-1:-1:-1;;;10538:65:3;;15202:2:17;10538:65:3;;;15184:21:17;15241:2;15221:18;;;15214:30;15280:34;15260:18;;;15253:62;-1:-1:-1;;;15331:18:17;;;15324:34;15375:19;;10538:65:3;15000:400:17;10538:65:3;10715:29;10732:1;10736:7;10715:8;:29::i;:::-;-1:-1:-1;;;;;10755:15:3;;;;;;:9;:15;;;;;:20;;10774:1;;10755:15;:20;;10774:1;;10755:20;:::i;:::-;;;;-1:-1:-1;;;;;;;10785:13:3;;;;;;:9;:13;;;;;:18;;10802:1;;10785:13;:18;;10802:1;;10785:18;:::i;:::-;;;;-1:-1:-1;;10813:16:3;;;;:7;:16;;;;;;:21;;-1:-1:-1;;;;;;10813:21:3;-1:-1:-1;;;;;10813:21:3;;;;;;;;;10850:27;;10813:16;;10850:27;;;;;;;10324:560;;;:::o;2270:187:0:-;2362:6;;;-1:-1:-1;;;;;2378:17:0;;;-1:-1:-1;;;;;;2378:17:0;;;;;;;2410:40;;2362:6;;;2378:17;2362:6;;2410:40;;2343:16;;2410:40;2333:124;2270:187;:::o;4921:277:15:-;5020:19;5032:6;5020:11;:19::i;:::-;5012:60;;;;-1:-1:-1;;;5012:60:15;;15870:2:17;5012:60:15;;;15852:21:17;15909:2;15889:18;;;15882:30;15948;15928:18;;;15921:58;15996:18;;5012:60:15;15668:352:17;5012:60:15;5082:24;;;;:14;:24;;;;;;;;:33;;;;;;;;:::i;:::-;;5125:24;5135:3;5140:8;5125:9;:24::i;:::-;5169:8;5164:27;5179:6;5187:3;5164:27;;;;;;;:::i;:::-;;;;;;;;4921:277;;;:::o;11301:307:3:-;11451:8;-1:-1:-1;;;;;11442:17:3;:5;-1:-1:-1;;;;;11442:17:3;;;11434:55;;;;-1:-1:-1;;;11434:55:3;;16549:2:17;11434:55:3;;;16531:21:17;16588:2;16568:18;;;16561:30;16627:27;16607:18;;;16600:55;16672:18;;11434:55:3;16347:349:17;11434:55:3;-1:-1:-1;;;;;11499:25:3;;;;;;;:18;:25;;;;;;;;:35;;;;;;;;;;;;;:46;;-1:-1:-1;;11499:46:3;;;;;;;;;;11560:41;;540::17;;;11560::3;;513:18:17;11560:41:3;;;;;;;11301:307;;;:::o;6534:::-;6685:28;6695:4;6701:2;6705:7;6685:9;:28::i;:::-;6731:48;6754:4;6760:2;6764:7;6773:5;6731:22;:48::i;:::-;6723:111;;;;-1:-1:-1;;;6723:111:3;;;;;;;:::i;5205:112:15:-;5265:13;5297;5290:20;;;;;:::i;328:703:10:-;384:13;601:10;597:51;;-1:-1:-1;;627:10:10;;;;;;;;;;;;-1:-1:-1;;;627:10:10;;;;;328:703::o;597:51::-;672:5;657:12;711:75;718:9;;711:75;;743:8;;;;:::i;:::-;;-1:-1:-1;765:10:10;;-1:-1:-1;773:2:10;765:10;;:::i;:::-;;;711:75;;;795:19;827:6;817:17;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;817:17:10;;795:39;;844:150;851:10;;844:150;;877:11;887:1;877:11;;:::i;:::-;;-1:-1:-1;945:10:10;953:2;945:5;:10;:::i;:::-;932:24;;:2;:24;:::i;:::-;919:39;;902:6;909;902:14;;;;;;;;:::i;:::-;;;;:56;-1:-1:-1;;;;;902:56:10;;;;;;;;-1:-1:-1;972:11:10;981:2;972:11;;:::i;:::-;;;844:150;;1555:300:3;1657:4;-1:-1:-1;;;;;;1692:40:3;;-1:-1:-1;;;1692:40:3;;:104;;-1:-1:-1;;;;;;;1748:48:3;;-1:-1:-1;;;1748:48:3;1692:104;:156;;;-1:-1:-1;;;;;;;;;;937:40:11;;;1812:36:3;829:155:11;8101:108:3;8176:26;8186:2;8190:7;8176:26;;;;;;;;;;;;:9;:26::i;12161:778::-;12311:4;-1:-1:-1;;;;;12331:13:3;;1087:20:7;1133:8;12327:606:3;;12366:72;;-1:-1:-1;;;12366:72:3;;-1:-1:-1;;;;;12366:36:3;;;;;:72;;719:10:8;;12417:4:3;;12423:7;;12432:5;;12366:72;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;-1:-1:-1;12366:72:3;;;;;;;;-1:-1:-1;;12366:72:3;;;;;;;;;;;;:::i;:::-;;;12362:519;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;12605:13:3;;12601:266;;12647:60;;-1:-1:-1;;;12647:60:3;;;;;;;:::i;12601:266::-;12819:6;12813:13;12804:6;12800:2;12796:15;12789:38;12362:519;-1:-1:-1;;;;;;12488:51:3;-1:-1:-1;;;12488:51:3;;-1:-1:-1;12481:58:3;;8430:311;8555:18;8561:2;8565:7;8555:5;:18::i;:::-;8604:54;8635:1;8639:2;8643:7;8652:5;8604:22;:54::i;:::-;8583:151;;;;-1:-1:-1;;;8583:151:3;;;;;;;:::i;9063:372::-;-1:-1:-1;;;;;9142:16:3;;9134:61;;;;-1:-1:-1;;;9134:61:3;;18187:2:17;9134:61:3;;;18169:21:17;;;18206:18;;;18199:30;18265:34;18245:18;;;18238:62;18317:18;;9134:61:3;17985:356:17;9134:61:3;9214:16;9222:7;9214;:16::i;:::-;9213:17;9205:58;;;;-1:-1:-1;;;9205:58:3;;18548:2:17;9205:58:3;;;18530:21:17;18587:2;18567:18;;;18560:30;18626;18606:18;;;18599:58;18674:18;;9205:58:3;18346:352:17;9205:58:3;-1:-1:-1;;;;;9330:13:3;;;;;;:9;:13;;;;;:18;;9347:1;;9330:13;:18;;9347:1;;9330:18;:::i;:::-;;;;-1:-1:-1;;9358:16:3;;;;:7;:16;;;;;;:21;;-1:-1:-1;;;;;;9358:21:3;-1:-1:-1;;;;;9358:21:3;;;;;;;;9395:33;;9358:16;;;9395:33;;9358:16;;9395:33;9063:372;;:::o;-1:-1:-1:-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;14:131:17;-1:-1:-1;;;;;;88:32:17;;78:43;;68:71;;135:1;132;125:12;150:245;208:6;261:2;249:9;240:7;236:23;232:32;229:52;;;277:1;274;267:12;229:52;316:9;303:23;335:30;359:5;335:30;:::i;592:258::-;664:1;674:113;688:6;685:1;682:13;674:113;;;764:11;;;758:18;745:11;;;738:39;710:2;703:10;674:113;;;805:6;802:1;799:13;796:48;;;-1:-1:-1;;840:1:17;822:16;;815:27;592:258::o;855:::-;897:3;935:5;929:12;962:6;957:3;950:19;978:63;1034:6;1027:4;1022:3;1018:14;1011:4;1004:5;1000:16;978:63;:::i;:::-;1095:2;1074:15;-1:-1:-1;;1070:29:17;1061:39;;;;1102:4;1057:50;;855:258;-1:-1:-1;;855:258:17:o;1118:220::-;1267:2;1256:9;1249:21;1230:4;1287:45;1328:2;1317:9;1313:18;1305:6;1287:45;:::i;1343:180::-;1402:6;1455:2;1443:9;1434:7;1430:23;1426:32;1423:52;;;1471:1;1468;1461:12;1423:52;-1:-1:-1;1494:23:17;;1343:180;-1:-1:-1;1343:180:17:o;1736:173::-;1804:20;;-1:-1:-1;;;;;1853:31:17;;1843:42;;1833:70;;1899:1;1896;1889:12;1833:70;1736:173;;;:::o;1914:254::-;1982:6;1990;2043:2;2031:9;2022:7;2018:23;2014:32;2011:52;;;2059:1;2056;2049:12;2011:52;2082:29;2101:9;2082:29;:::i;:::-;2072:39;2158:2;2143:18;;;;2130:32;;-1:-1:-1;;;1914:254:17:o;2355:328::-;2432:6;2440;2448;2501:2;2489:9;2480:7;2476:23;2472:32;2469:52;;;2517:1;2514;2507:12;2469:52;2540:29;2559:9;2540:29;:::i;:::-;2530:39;;2588:38;2622:2;2611:9;2607:18;2588:38;:::i;:::-;2578:48;;2673:2;2662:9;2658:18;2645:32;2635:42;;2355:328;;;;;:::o;2688:248::-;2756:6;2764;2817:2;2805:9;2796:7;2792:23;2788:32;2785:52;;;2833:1;2830;2823:12;2785:52;-1:-1:-1;;2856:23:17;;;2926:2;2911:18;;;2898:32;;-1:-1:-1;2688:248:17:o;3220:186::-;3279:6;3332:2;3320:9;3311:7;3307:23;3303:32;3300:52;;;3348:1;3345;3338:12;3300:52;3371:29;3390:9;3371:29;:::i;3411:127::-;3472:10;3467:3;3463:20;3460:1;3453:31;3503:4;3500:1;3493:15;3527:4;3524:1;3517:15;3543:632;3608:5;3638:18;3679:2;3671:6;3668:14;3665:40;;;3685:18;;:::i;:::-;3760:2;3754:9;3728:2;3814:15;;-1:-1:-1;;3810:24:17;;;3836:2;3806:33;3802:42;3790:55;;;3860:18;;;3880:22;;;3857:46;3854:72;;;3906:18;;:::i;:::-;3946:10;3942:2;3935:22;3975:6;3966:15;;4005:6;3997;3990:22;4045:3;4036:6;4031:3;4027:16;4024:25;4021:45;;;4062:1;4059;4052:12;4021:45;4112:6;4107:3;4100:4;4092:6;4088:17;4075:44;4167:1;4160:4;4151:6;4143;4139:19;4135:30;4128:41;;;;3543:632;;;;;:::o;4180:222::-;4223:5;4276:3;4269:4;4261:6;4257:17;4253:27;4243:55;;4294:1;4291;4284:12;4243:55;4316:80;4392:3;4383:6;4370:20;4363:4;4355:6;4351:17;4316:80;:::i;4407:322::-;4476:6;4529:2;4517:9;4508:7;4504:23;4500:32;4497:52;;;4545:1;4542;4535:12;4497:52;4585:9;4572:23;4618:18;4610:6;4607:30;4604:50;;;4650:1;4647;4640:12;4604:50;4673;4715:7;4706:6;4695:9;4691:22;4673:50;:::i;4734:464::-;4821:6;4829;4837;4890:2;4878:9;4869:7;4865:23;4861:32;4858:52;;;4906:1;4903;4896:12;4858:52;4946:9;4933:23;4979:18;4971:6;4968:30;4965:50;;;5011:1;5008;5001:12;4965:50;5034;5076:7;5067:6;5056:9;5052:22;5034:50;:::i;:::-;5024:60;;;5131:2;5120:9;5116:18;5103:32;5093:42;;5154:38;5188:2;5177:9;5173:18;5154:38;:::i;:::-;5144:48;;4734:464;;;;;:::o;5203:347::-;5268:6;5276;5329:2;5317:9;5308:7;5304:23;5300:32;5297:52;;;5345:1;5342;5335:12;5297:52;5368:29;5387:9;5368:29;:::i;:::-;5358:39;;5447:2;5436:9;5432:18;5419:32;5494:5;5487:13;5480:21;5473:5;5470:32;5460:60;;5516:1;5513;5506:12;5460:60;5539:5;5529:15;;;5203:347;;;;;:::o;5555:667::-;5650:6;5658;5666;5674;5727:3;5715:9;5706:7;5702:23;5698:33;5695:53;;;5744:1;5741;5734:12;5695:53;5767:29;5786:9;5767:29;:::i;:::-;5757:39;;5815:38;5849:2;5838:9;5834:18;5815:38;:::i;:::-;5805:48;;5900:2;5889:9;5885:18;5872:32;5862:42;;5955:2;5944:9;5940:18;5927:32;5982:18;5974:6;5971:30;5968:50;;;6014:1;6011;6004:12;5968:50;6037:22;;6090:4;6082:13;;6078:27;-1:-1:-1;6068:55:17;;6119:1;6116;6109:12;6068:55;6142:74;6208:7;6203:2;6190:16;6185:2;6181;6177:11;6142:74;:::i;:::-;6132:84;;;5555:667;;;;;;;:::o;6227:260::-;6295:6;6303;6356:2;6344:9;6335:7;6331:23;6327:32;6324:52;;;6372:1;6369;6362:12;6324:52;6395:29;6414:9;6395:29;:::i;:::-;6385:39;;6443:38;6477:2;6466:9;6462:18;6443:38;:::i;6492:380::-;6571:1;6567:12;;;;6614;;;6635:61;;6689:4;6681:6;6677:17;6667:27;;6635:61;6742:2;6734:6;6731:14;6711:18;6708:38;6705:161;;;6788:10;6783:3;6779:20;6776:1;6769:31;6823:4;6820:1;6813:15;6851:4;6848:1;6841:15;6705:161;;6492:380;;;:::o;8117:413::-;8319:2;8301:21;;;8358:2;8338:18;;;8331:30;8397:34;8392:2;8377:18;;8370:62;-1:-1:-1;;;8463:2:17;8448:18;;8441:47;8520:3;8505:19;;8117:413::o;8892:127::-;8953:10;8948:3;8944:20;8941:1;8934:31;8984:4;8981:1;8974:15;9008:4;9005:1;8998:15;9024:168;9064:7;9130:1;9126;9122:6;9118:14;9115:1;9112:21;9107:1;9100:9;9093:17;9089:45;9086:71;;;9137:18;;:::i;:::-;-1:-1:-1;9177:9:17;;9024:168::o;9197:127::-;9258:10;9253:3;9249:20;9246:1;9239:31;9289:4;9286:1;9279:15;9313:4;9310:1;9303:15;9329:120;9369:1;9395;9385:35;;9400:18;;:::i;:::-;-1:-1:-1;9434:9:17;;9329:120::o;9864:356::-;10066:2;10048:21;;;10085:18;;;10078:30;10144:34;10139:2;10124:18;;10117:62;10211:2;10196:18;;9864:356::o;10636:127::-;10697:10;10692:3;10688:20;10685:1;10678:31;10728:4;10725:1;10718:15;10752:4;10749:1;10742:15;10768:135;10807:3;-1:-1:-1;;10828:17:17;;10825:43;;;10848:18;;:::i;:::-;-1:-1:-1;10895:1:17;10884:13;;10768:135::o;12042:470::-;12221:3;12259:6;12253:13;12275:53;12321:6;12316:3;12309:4;12301:6;12297:17;12275:53;:::i;:::-;12391:13;;12350:16;;;;12413:57;12391:13;12350:16;12447:4;12435:17;;12413:57;:::i;:::-;12486:20;;12042:470;-1:-1:-1;;;;12042:470:17:o;15405:125::-;15445:4;15473:1;15470;15467:8;15464:34;;;15478:18;;:::i;:::-;-1:-1:-1;15515:9:17;;15405:125::o;15535:128::-;15575:3;15606:1;15602:6;15599:1;15596:13;15593:39;;;15612:18;;:::i;:::-;-1:-1:-1;15648:9:17;;15535:128::o;16025:317::-;16202:2;16191:9;16184:21;16165:4;16222:45;16263:2;16252:9;16248:18;16240:6;16222:45;:::i;:::-;16214:53;;16332:1;16328;16323:3;16319:11;16315:19;16307:6;16303:32;16298:2;16287:9;16283:18;16276:60;16025:317;;;;;:::o;16701:414::-;16903:2;16885:21;;;16942:2;16922:18;;;16915:30;16981:34;16976:2;16961:18;;16954:62;-1:-1:-1;;;17047:2:17;17032:18;;17025:48;17105:3;17090:19;;16701:414::o;17120:112::-;17152:1;17178;17168:35;;17183:18;;:::i;:::-;-1:-1:-1;17217:9:17;;17120:112::o;17237:489::-;-1:-1:-1;;;;;17506:15:17;;;17488:34;;17558:15;;17553:2;17538:18;;17531:43;17605:2;17590:18;;17583:34;;;17653:3;17648:2;17633:18;;17626:31;;;17431:4;;17674:46;;17700:19;;17692:6;17674:46;:::i;:::-;17666:54;17237:489;-1:-1:-1;;;;;;17237:489:17:o;17731:249::-;17800:6;17853:2;17841:9;17832:7;17828:23;17824:32;17821:52;;;17869:1;17866;17859:12;17821:52;17901:9;17895:16;17920:30;17944:5;17920:30;:::i",
  "source": "// SPDX-License-Identifier: MIT\npragma solidity ^0.8.0;\n\nimport \"@openzeppelin/contracts/token/ERC721/ERC721.sol\";\nimport \"@openzeppelin/contracts/interfaces/IERC2981.sol\";\nimport \"@openzeppelin/contracts/utils/introspection/ERC165Storage.sol\";\nimport \"@openzeppelin/contracts/utils/Context.sol\";\nimport \"@openzeppelin/contracts/utils/Counters.sol\";\nimport \"@openzeppelin/contracts/access/Ownable.sol\";\n\ncontract ClavesAngelicae is Context, ERC721, Ownable, IERC2981, ERC165Storage {\n\n    event Mint(\n        uint256 indexed tokenId,\n        string spell,\n        address to\n    );\n\n    uint256 public MAX_SUPPLY = 777;\n    uint256 public PRICE = 0.000777 * 10 ** 18;\n\n    using Counters for Counters.Counter;\n    Counters.Counter private _tokenIds;\n    uint256[30] private _reservedIds = [ // ~658992 gwei to store these here -- is there a more efficient way? Bytes?\n        1,   2,   3,   7,   11,  12,  13,  14,\n        17,  19,  21,  23,  27,  29,  31,  37,\n        41,  47,  67,  71,  83,  93,  111, 222,\n        333, 418, 444, 555, 666, 777\n    ];\n\n    mapping(uint256 => bool) private _reservedIdsMap;\n    mapping(uint256 => string) public tokenIdToSpell;\n\n    string private _baseTokenURI;\n\n    // secondary market royalties\n    address private donationAddress = 0x7cF2eBb5Ca55A8bd671A020F8BDbAF07f60F26C1; // give well\n    uint256 private donationPercent = 1;\n\n    // Bytes4 Code for ERC interfaces\n    bytes4 private constant _INTERFACE_ID_ERC2981 = 0x2a55205a;\n    bytes4 private constant _INTERFACE_ID_ERC721 = 0x80ac58cd;\n\n\n    constructor(\n        string memory name_,\n        string memory symbol_,\n        string memory baseURI_\n    ) ERC721 (name_, symbol_) {\n        _baseTokenURI = baseURI_;\n\n        // register the supported ERC interfaces\n        _registerInterface(_INTERFACE_ID_ERC721);\n        _registerInterface(_INTERFACE_ID_ERC2981);\n\n        // map reserved ids\n        for (uint256 i = 0; i < _reservedIds.length; i++) {\n            _reservedIdsMap[_reservedIds[i]] = true;\n        }\n\n        // start counter at 1\n        _tokenIds.increment();\n    }\n\n\n    function mintReserved(string memory spell_, uint256 tokenId_, address to_) public onlyOwner {\n        require(!_exists(tokenId_), \"ERC721: Token ID already minted\");\n        require(_reservedIdsMap[tokenId_], \"ERC721: Token ID not reserved\");\n        _mintSpell(spell_, tokenId_, to_);\n    }\n\n\n    function mint(string memory spell_) public payable {\n        require(msg.value >= PRICE, \"Must pay for minting\");\n        uint256 tokenId;\n        while (true) {\n            tokenId = _tokenIds.current();\n            if (_reservedIdsMap[tokenId] || _exists(tokenId)) {\n                _tokenIds.increment();\n                require(_tokenIds.current() <= MAX_SUPPLY, \"Token Supply Depleted\");\n            } else {\n                break;\n            }\n        }\n        (bool success, ) = owner().call{ value: msg.value }(\"\");\n        require(success, \"Transfer Failed\");\n        _mintSpell(spell_, tokenId, _msgSender());\n    }\n\n\n    // A valid spell must be /[a-z0-9]{10}/\n    function verifySpell(string memory str_) public pure returns (bool) {\n        bytes memory b = bytes(str_);\n        uint256 len = b.length;\n        if (len != 10) { // {10}\n            return false;\n        }\n        for (uint256 i; i < len; i++) {\n            bytes1 c = b[i];\n            if(!(c >= 0x61 && c <= 0x7A) && // [a-z]\n               !(c >= 0x30 && c <= 0x39)) { // [0-9]\n                return false;\n            }\n        }\n        return true;\n    }\n\n    /**\n     * @dev Called with the sale price to determine how much royalty is owed and to whom.\n     * @param tokenId_ - the NFT asset queried for royalty information\n     * @param salePrice_ - the sale price of the NFT asset specified by `tokenId`\n     * @return receiver - address of who should be sent the royalty payment\n     * @return donationAmount - the royalty payment amount for `salePrice`\n     */\n    function royaltyInfo(\n        uint256 tokenId_,\n        uint256 salePrice_\n    ) external view override(IERC2981) returns (\n        address receiver,\n        uint256 donationAmount\n    ) {\n        require(_exists(tokenId_), \"ERC721: Nonexistent Token ID\");\n        receiver = donationAddress;\n        donationAmount = salePrice_ * donationPercent / 100;\n    }\n\n\n    function supportsInterface(bytes4 interfaceId)\n        public\n        view\n        virtual\n        override (ERC721, IERC165, ERC165Storage\n    ) returns (\n        bool\n    )    {\n        return interfaceId == type(IERC2981).interfaceId || super.supportsInterface(interfaceId);\n    }\n\n\n    function setDonationAddress(address to_) public onlyOwner {\n        donationAddress = to_;\n    }\n\n\n    function setDonationPercent(uint256 percent_) public onlyOwner {\n        donationPercent = percent_;\n    }\n\n\n    function totalSupply() external view returns (uint256) {\n        return _tokenIds.current();\n    }\n\n\n    function _mintSpell(string memory spell_, uint256 tokenId_, address to_) private {\n        require(verifySpell(spell_), \"Spell must be /[a-z0-9]{10}/\");\n        tokenIdToSpell[tokenId_] = spell_;\n        _safeMint(to_, tokenId_);\n        emit Mint(tokenId_, spell_, to_);\n    }\n\n\n    function _baseURI() internal view virtual override returns (string memory) {\n        return _baseTokenURI;\n    }\n}\n\n",
  "sourcePath": "/Users/gld/_projects/claves2/ca-web3/contracts/ClavesAngelicae.sol",
  "ast": {
    "absolutePath": "project:/contracts/ClavesAngelicae.sol",
    "exportedSymbols": {
      "Address": [
        1415
      ],
      "ClavesAngelicae": [
        2323
      ],
      "Context": [
        1437
      ],
      "Counters": [
        1511
      ],
      "ERC165": [
        1738
      ],
      "ERC165Storage": [
        1789
      ],
      "ERC721": [
        957
      ],
      "IERC165": [
        1801
      ],
      "IERC2981": [
        126
      ],
      "IERC721": [
        1073
      ],
      "IERC721Metadata": [
        1118
      ],
      "IERC721Receiver": [
        1091
      ],
      "Ownable": [
        104
      ],
      "Strings": [
        1714
      ]
    },
    "id": 2324,
    "license": "MIT",
    "nodeType": "SourceUnit",
    "nodes": [
      {
        "id": 1861,
        "literals": [
          "solidity",
          "^",
          "0.8",
          ".0"
        ],
        "nodeType": "PragmaDirective",
        "src": "32:23:15"
      },
      {
        "absolutePath": "@openzeppelin/contracts/token/ERC721/ERC721.sol",
        "file": "@openzeppelin/contracts/token/ERC721/ERC721.sol",
        "id": 1862,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 958,
        "src": "57:57:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/interfaces/IERC2981.sol",
        "file": "@openzeppelin/contracts/interfaces/IERC2981.sol",
        "id": 1863,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 127,
        "src": "115:57:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/utils/introspection/ERC165Storage.sol",
        "file": "@openzeppelin/contracts/utils/introspection/ERC165Storage.sol",
        "id": 1864,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 1790,
        "src": "173:71:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/utils/Context.sol",
        "file": "@openzeppelin/contracts/utils/Context.sol",
        "id": 1865,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 1438,
        "src": "245:51:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/utils/Counters.sol",
        "file": "@openzeppelin/contracts/utils/Counters.sol",
        "id": 1866,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 1512,
        "src": "297:52:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/access/Ownable.sol",
        "file": "@openzeppelin/contracts/access/Ownable.sol",
        "id": 1867,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 105,
        "src": "350:52:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "abstract": false,
        "baseContracts": [
          {
            "baseName": {
              "id": 1868,
              "name": "Context",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 1437,
              "src": "432:7:15"
            },
            "id": 1869,
            "nodeType": "InheritanceSpecifier",
            "src": "432:7:15"
          },
          {
            "baseName": {
              "id": 1870,
              "name": "ERC721",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 957,
              "src": "441:6:15"
            },
            "id": 1871,
            "nodeType": "InheritanceSpecifier",
            "src": "441:6:15"
          },
          {
            "baseName": {
              "id": 1872,
              "name": "Ownable",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 104,
              "src": "449:7:15"
            },
            "id": 1873,
            "nodeType": "InheritanceSpecifier",
            "src": "449:7:15"
          },
          {
            "baseName": {
              "id": 1874,
              "name": "IERC2981",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 126,
              "src": "458:8:15"
            },
            "id": 1875,
            "nodeType": "InheritanceSpecifier",
            "src": "458:8:15"
          },
          {
            "baseName": {
              "id": 1876,
              "name": "ERC165Storage",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 1789,
              "src": "468:13:15"
            },
            "id": 1877,
            "nodeType": "InheritanceSpecifier",
            "src": "468:13:15"
          }
        ],
        "canonicalName": "ClavesAngelicae",
        "contractDependencies": [],
        "contractKind": "contract",
        "fullyImplemented": true,
        "id": 2323,
        "linearizedBaseContracts": [
          2323,
          1789,
          126,
          104,
          957,
          1118,
          1073,
          1738,
          1801,
          1437
        ],
        "name": "ClavesAngelicae",
        "nameLocation": "413:15:15",
        "nodeType": "ContractDefinition",
        "nodes": [
          {
            "anonymous": false,
            "id": 1885,
            "name": "Mint",
            "nameLocation": "495:4:15",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 1884,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1879,
                  "indexed": true,
                  "mutability": "mutable",
                  "name": "tokenId",
                  "nameLocation": "525:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 1885,
                  "src": "509:23:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1878,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "509:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1881,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "spell",
                  "nameLocation": "549:5:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 1885,
                  "src": "542:12:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1880,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "542:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1883,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "to",
                  "nameLocation": "572:2:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 1885,
                  "src": "564:10:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 1882,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "564:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "499:81:15"
            },
            "src": "489:92:15"
          },
          {
            "constant": false,
            "functionSelector": "32cb6b0c",
            "id": 1888,
            "mutability": "mutable",
            "name": "MAX_SUPPLY",
            "nameLocation": "602:10:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "587:31:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 1886,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "587:7:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "hexValue": "373737",
              "id": 1887,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "615:3:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_777_by_1",
                "typeString": "int_const 777"
              },
              "value": "777"
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "8d859f3e",
            "id": 1895,
            "mutability": "mutable",
            "name": "PRICE",
            "nameLocation": "639:5:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "624:42:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 1889,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "624:7:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "commonType": {
                "typeIdentifier": "t_rational_777000000000000_by_1",
                "typeString": "int_const 777000000000000"
              },
              "id": 1894,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "lValueRequested": false,
              "leftExpression": {
                "hexValue": "302e303030373737",
                "id": 1890,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "kind": "number",
                "lValueRequested": false,
                "nodeType": "Literal",
                "src": "647:8:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_777_by_1000000",
                  "typeString": "rational_const 777 / 1000000"
                },
                "value": "0.000777"
              },
              "nodeType": "BinaryOperation",
              "operator": "*",
              "rightExpression": {
                "commonType": {
                  "typeIdentifier": "t_rational_1000000000000000000_by_1",
                  "typeString": "int_const 1000000000000000000"
                },
                "id": 1893,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "lValueRequested": false,
                "leftExpression": {
                  "hexValue": "3130",
                  "id": 1891,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "658:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_10_by_1",
                    "typeString": "int_const 10"
                  },
                  "value": "10"
                },
                "nodeType": "BinaryOperation",
                "operator": "**",
                "rightExpression": {
                  "hexValue": "3138",
                  "id": 1892,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "664:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_18_by_1",
                    "typeString": "int_const 18"
                  },
                  "value": "18"
                },
                "src": "658:8:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_1000000000000000000_by_1",
                  "typeString": "int_const 1000000000000000000"
                }
              },
              "src": "647:19:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_777000000000000_by_1",
                "typeString": "int_const 777000000000000"
              }
            },
            "visibility": "public"
          },
          {
            "id": 1899,
            "libraryName": {
              "id": 1896,
              "name": "Counters",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 1511,
              "src": "679:8:15"
            },
            "nodeType": "UsingForDirective",
            "src": "673:36:15",
            "typeName": {
              "id": 1898,
              "nodeType": "UserDefinedTypeName",
              "pathNode": {
                "id": 1897,
                "name": "Counters.Counter",
                "nodeType": "IdentifierPath",
                "referencedDeclaration": 1443,
                "src": "692:16:15"
              },
              "referencedDeclaration": 1443,
              "src": "692:16:15",
              "typeDescriptions": {
                "typeIdentifier": "t_struct$_Counter_$1443_storage_ptr",
                "typeString": "struct Counters.Counter"
              }
            }
          },
          {
            "constant": false,
            "id": 1902,
            "mutability": "mutable",
            "name": "_tokenIds",
            "nameLocation": "739:9:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "714:34:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_struct$_Counter_$1443_storage",
              "typeString": "struct Counters.Counter"
            },
            "typeName": {
              "id": 1901,
              "nodeType": "UserDefinedTypeName",
              "pathNode": {
                "id": 1900,
                "name": "Counters.Counter",
                "nodeType": "IdentifierPath",
                "referencedDeclaration": 1443,
                "src": "714:16:15"
              },
              "referencedDeclaration": 1443,
              "src": "714:16:15",
              "typeDescriptions": {
                "typeIdentifier": "t_struct$_Counter_$1443_storage_ptr",
                "typeString": "struct Counters.Counter"
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "id": 1937,
            "mutability": "mutable",
            "name": "_reservedIds",
            "nameLocation": "774:12:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "754:298:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_array$_t_uint256_$30_storage",
              "typeString": "uint256[30]"
            },
            "typeName": {
              "baseType": {
                "id": 1903,
                "name": "uint256",
                "nodeType": "ElementaryTypeName",
                "src": "754:7:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "id": 1905,
              "length": {
                "hexValue": "3330",
                "id": 1904,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "kind": "number",
                "lValueRequested": false,
                "nodeType": "Literal",
                "src": "762:2:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_30_by_1",
                  "typeString": "int_const 30"
                },
                "value": "30"
              },
              "nodeType": "ArrayTypeName",
              "src": "754:11:15",
              "typeDescriptions": {
                "typeIdentifier": "t_array$_t_uint256_$30_storage_ptr",
                "typeString": "uint256[30]"
              }
            },
            "value": {
              "components": [
                {
                  "hexValue": "31",
                  "id": 1906,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "876:1:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_1_by_1",
                    "typeString": "int_const 1"
                  },
                  "value": "1"
                },
                {
                  "hexValue": "32",
                  "id": 1907,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "881:1:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_2_by_1",
                    "typeString": "int_const 2"
                  },
                  "value": "2"
                },
                {
                  "hexValue": "33",
                  "id": 1908,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "886:1:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_3_by_1",
                    "typeString": "int_const 3"
                  },
                  "value": "3"
                },
                {
                  "hexValue": "37",
                  "id": 1909,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "891:1:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_7_by_1",
                    "typeString": "int_const 7"
                  },
                  "value": "7"
                },
                {
                  "hexValue": "3131",
                  "id": 1910,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "896:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_11_by_1",
                    "typeString": "int_const 11"
                  },
                  "value": "11"
                },
                {
                  "hexValue": "3132",
                  "id": 1911,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "901:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_12_by_1",
                    "typeString": "int_const 12"
                  },
                  "value": "12"
                },
                {
                  "hexValue": "3133",
                  "id": 1912,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "906:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_13_by_1",
                    "typeString": "int_const 13"
                  },
                  "value": "13"
                },
                {
                  "hexValue": "3134",
                  "id": 1913,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "911:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_14_by_1",
                    "typeString": "int_const 14"
                  },
                  "value": "14"
                },
                {
                  "hexValue": "3137",
                  "id": 1914,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "923:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_17_by_1",
                    "typeString": "int_const 17"
                  },
                  "value": "17"
                },
                {
                  "hexValue": "3139",
                  "id": 1915,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "928:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_19_by_1",
                    "typeString": "int_const 19"
                  },
                  "value": "19"
                },
                {
                  "hexValue": "3231",
                  "id": 1916,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "933:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_21_by_1",
                    "typeString": "int_const 21"
                  },
                  "value": "21"
                },
                {
                  "hexValue": "3233",
                  "id": 1917,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "938:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_23_by_1",
                    "typeString": "int_const 23"
                  },
                  "value": "23"
                },
                {
                  "hexValue": "3237",
                  "id": 1918,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "943:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_27_by_1",
                    "typeString": "int_const 27"
                  },
                  "value": "27"
                },
                {
                  "hexValue": "3239",
                  "id": 1919,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "948:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_29_by_1",
                    "typeString": "int_const 29"
                  },
                  "value": "29"
                },
                {
                  "hexValue": "3331",
                  "id": 1920,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "953:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_31_by_1",
                    "typeString": "int_const 31"
                  },
                  "value": "31"
                },
                {
                  "hexValue": "3337",
                  "id": 1921,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "958:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_37_by_1",
                    "typeString": "int_const 37"
                  },
                  "value": "37"
                },
                {
                  "hexValue": "3431",
                  "id": 1922,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "970:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_41_by_1",
                    "typeString": "int_const 41"
                  },
                  "value": "41"
                },
                {
                  "hexValue": "3437",
                  "id": 1923,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "975:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_47_by_1",
                    "typeString": "int_const 47"
                  },
                  "value": "47"
                },
                {
                  "hexValue": "3637",
                  "id": 1924,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "980:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_67_by_1",
                    "typeString": "int_const 67"
                  },
                  "value": "67"
                },
                {
                  "hexValue": "3731",
                  "id": 1925,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "985:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_71_by_1",
                    "typeString": "int_const 71"
                  },
                  "value": "71"
                },
                {
                  "hexValue": "3833",
                  "id": 1926,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "990:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_83_by_1",
                    "typeString": "int_const 83"
                  },
                  "value": "83"
                },
                {
                  "hexValue": "3933",
                  "id": 1927,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "995:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_93_by_1",
                    "typeString": "int_const 93"
                  },
                  "value": "93"
                },
                {
                  "hexValue": "313131",
                  "id": 1928,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1000:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_111_by_1",
                    "typeString": "int_const 111"
                  },
                  "value": "111"
                },
                {
                  "hexValue": "323232",
                  "id": 1929,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1005:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_222_by_1",
                    "typeString": "int_const 222"
                  },
                  "value": "222"
                },
                {
                  "hexValue": "333333",
                  "id": 1930,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1018:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_333_by_1",
                    "typeString": "int_const 333"
                  },
                  "value": "333"
                },
                {
                  "hexValue": "343138",
                  "id": 1931,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1023:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_418_by_1",
                    "typeString": "int_const 418"
                  },
                  "value": "418"
                },
                {
                  "hexValue": "343434",
                  "id": 1932,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1028:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_444_by_1",
                    "typeString": "int_const 444"
                  },
                  "value": "444"
                },
                {
                  "hexValue": "353535",
                  "id": 1933,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1033:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_555_by_1",
                    "typeString": "int_const 555"
                  },
                  "value": "555"
                },
                {
                  "hexValue": "363636",
                  "id": 1934,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1038:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_666_by_1",
                    "typeString": "int_const 666"
                  },
                  "value": "666"
                },
                {
                  "hexValue": "373737",
                  "id": 1935,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1043:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_777_by_1",
                    "typeString": "int_const 777"
                  },
                  "value": "777"
                }
              ],
              "id": 1936,
              "isConstant": false,
              "isInlineArray": true,
              "isLValue": false,
              "isPure": true,
              "lValueRequested": false,
              "nodeType": "TupleExpression",
              "src": "789:263:15",
              "typeDescriptions": {
                "typeIdentifier": "t_array$_t_uint16_$30_memory_ptr",
                "typeString": "uint16[30] memory"
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "id": 1941,
            "mutability": "mutable",
            "name": "_reservedIdsMap",
            "nameLocation": "1092:15:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1059:48:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
              "typeString": "mapping(uint256 => bool)"
            },
            "typeName": {
              "id": 1940,
              "keyType": {
                "id": 1938,
                "name": "uint256",
                "nodeType": "ElementaryTypeName",
                "src": "1067:7:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "1059:24:15",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
                "typeString": "mapping(uint256 => bool)"
              },
              "valueType": {
                "id": 1939,
                "name": "bool",
                "nodeType": "ElementaryTypeName",
                "src": "1078:4:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_bool",
                  "typeString": "bool"
                }
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "functionSelector": "1aae9e03",
            "id": 1945,
            "mutability": "mutable",
            "name": "tokenIdToSpell",
            "nameLocation": "1147:14:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1113:48:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_string_storage_$",
              "typeString": "mapping(uint256 => string)"
            },
            "typeName": {
              "id": 1944,
              "keyType": {
                "id": 1942,
                "name": "uint256",
                "nodeType": "ElementaryTypeName",
                "src": "1121:7:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "1113:26:15",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_string_storage_$",
                "typeString": "mapping(uint256 => string)"
              },
              "valueType": {
                "id": 1943,
                "name": "string",
                "nodeType": "ElementaryTypeName",
                "src": "1132:6:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage_ptr",
                  "typeString": "string"
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "id": 1947,
            "mutability": "mutable",
            "name": "_baseTokenURI",
            "nameLocation": "1183:13:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1168:28:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_storage",
              "typeString": "string"
            },
            "typeName": {
              "id": 1946,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "1168:6:15",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "id": 1950,
            "mutability": "mutable",
            "name": "donationAddress",
            "nameLocation": "1253:15:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1237:76:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 1948,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "1237:7:15",
              "stateMutability": "nonpayable",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": {
              "hexValue": "307837634632654262354361353541386264363731413032304638424462414630376636304632364331",
              "id": 1949,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "1271:42:15",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              },
              "value": "0x7cF2eBb5Ca55A8bd671A020F8BDbAF07f60F26C1"
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "id": 1953,
            "mutability": "mutable",
            "name": "donationPercent",
            "nameLocation": "1348:15:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1332:35:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 1951,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "1332:7:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "hexValue": "31",
              "id": 1952,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "1366:1:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_1_by_1",
                "typeString": "int_const 1"
              },
              "value": "1"
            },
            "visibility": "private"
          },
          {
            "constant": true,
            "id": 1956,
            "mutability": "constant",
            "name": "_INTERFACE_ID_ERC2981",
            "nameLocation": "1436:21:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1412:58:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_bytes4",
              "typeString": "bytes4"
            },
            "typeName": {
              "id": 1954,
              "name": "bytes4",
              "nodeType": "ElementaryTypeName",
              "src": "1412:6:15",
              "typeDescriptions": {
                "typeIdentifier": "t_bytes4",
                "typeString": "bytes4"
              }
            },
            "value": {
              "hexValue": "30783261353532303561",
              "id": 1955,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "1460:10:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_710221914_by_1",
                "typeString": "int_const 710221914"
              },
              "value": "0x2a55205a"
            },
            "visibility": "private"
          },
          {
            "constant": true,
            "id": 1959,
            "mutability": "constant",
            "name": "_INTERFACE_ID_ERC721",
            "nameLocation": "1500:20:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1476:57:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_bytes4",
              "typeString": "bytes4"
            },
            "typeName": {
              "id": 1957,
              "name": "bytes4",
              "nodeType": "ElementaryTypeName",
              "src": "1476:6:15",
              "typeDescriptions": {
                "typeIdentifier": "t_bytes4",
                "typeString": "bytes4"
              }
            },
            "value": {
              "hexValue": "30783830616335386364",
              "id": 1958,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "1523:10:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_2158778573_by_1",
                "typeString": "int_const 2158778573"
              },
              "value": "0x80ac58cd"
            },
            "visibility": "private"
          },
          {
            "body": {
              "id": 2010,
              "nodeType": "Block",
              "src": "1675:406:15",
              "statements": [
                {
                  "expression": {
                    "id": 1974,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 1972,
                      "name": "_baseTokenURI",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1947,
                      "src": "1685:13:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1973,
                      "name": "baseURI_",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1965,
                      "src": "1701:8:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "1685:24:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1975,
                  "nodeType": "ExpressionStatement",
                  "src": "1685:24:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1977,
                        "name": "_INTERFACE_ID_ERC721",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1959,
                        "src": "1788:20:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      ],
                      "id": 1976,
                      "name": "_registerInterface",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1788,
                      "src": "1769:18:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_bytes4_$returns$__$",
                        "typeString": "function (bytes4)"
                      }
                    },
                    "id": 1978,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1769:40:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1979,
                  "nodeType": "ExpressionStatement",
                  "src": "1769:40:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1981,
                        "name": "_INTERFACE_ID_ERC2981",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1956,
                        "src": "1838:21:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      ],
                      "id": 1980,
                      "name": "_registerInterface",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1788,
                      "src": "1819:18:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_bytes4_$returns$__$",
                        "typeString": "function (bytes4)"
                      }
                    },
                    "id": 1982,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1819:41:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1983,
                  "nodeType": "ExpressionStatement",
                  "src": "1819:41:15"
                },
                {
                  "body": {
                    "id": 2003,
                    "nodeType": "Block",
                    "src": "1949:64:15",
                    "statements": [
                      {
                        "expression": {
                          "id": 2001,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "baseExpression": {
                              "id": 1995,
                              "name": "_reservedIdsMap",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1941,
                              "src": "1963:15:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
                                "typeString": "mapping(uint256 => bool)"
                              }
                            },
                            "id": 1999,
                            "indexExpression": {
                              "baseExpression": {
                                "id": 1996,
                                "name": "_reservedIds",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1937,
                                "src": "1979:12:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_array$_t_uint256_$30_storage",
                                  "typeString": "uint256[30] storage ref"
                                }
                              },
                              "id": 1998,
                              "indexExpression": {
                                "id": 1997,
                                "name": "i",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1985,
                                "src": "1992:1:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "nodeType": "IndexAccess",
                              "src": "1979:15:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": true,
                            "nodeType": "IndexAccess",
                            "src": "1963:32:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "hexValue": "74727565",
                            "id": 2000,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "bool",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "1998:4:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            },
                            "value": "true"
                          },
                          "src": "1963:39:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 2002,
                        "nodeType": "ExpressionStatement",
                        "src": "1963:39:15"
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1991,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1988,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1985,
                      "src": "1919:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "expression": {
                        "id": 1989,
                        "name": "_reservedIds",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1937,
                        "src": "1923:12:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_uint256_$30_storage",
                          "typeString": "uint256[30] storage ref"
                        }
                      },
                      "id": 1990,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "length",
                      "nodeType": "MemberAccess",
                      "src": "1923:19:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1919:23:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 2004,
                  "initializationExpression": {
                    "assignments": [
                      1985
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1985,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "1912:1:15",
                        "nodeType": "VariableDeclaration",
                        "scope": 2004,
                        "src": "1904:9:15",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1984,
                          "name": "uint256",
                          "nodeType": "ElementaryTypeName",
                          "src": "1904:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1987,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1986,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "1916:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "1904:13:15"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1993,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "1944:3:15",
                      "subExpression": {
                        "id": 1992,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1985,
                        "src": "1944:1:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1994,
                    "nodeType": "ExpressionStatement",
                    "src": "1944:3:15"
                  },
                  "nodeType": "ForStatement",
                  "src": "1899:114:15"
                },
                {
                  "expression": {
                    "arguments": [],
                    "expression": {
                      "argumentTypes": [],
                      "expression": {
                        "id": 2005,
                        "name": "_tokenIds",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1902,
                        "src": "2053:9:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_Counter_$1443_storage",
                          "typeString": "struct Counters.Counter storage ref"
                        }
                      },
                      "id": 2007,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "increment",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 1469,
                      "src": "2053:19:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_struct$_Counter_$1443_storage_ptr_$returns$__$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                        "typeString": "function (struct Counters.Counter storage pointer)"
                      }
                    },
                    "id": 2008,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2053:21:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2009,
                  "nodeType": "ExpressionStatement",
                  "src": "2053:21:15"
                }
              ]
            },
            "id": 2011,
            "implemented": true,
            "kind": "constructor",
            "modifiers": [
              {
                "arguments": [
                  {
                    "id": 1968,
                    "name": "name_",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1961,
                    "src": "1659:5:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_memory_ptr",
                      "typeString": "string memory"
                    }
                  },
                  {
                    "id": 1969,
                    "name": "symbol_",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1963,
                    "src": "1666:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_memory_ptr",
                      "typeString": "string memory"
                    }
                  }
                ],
                "id": 1970,
                "kind": "baseConstructorSpecifier",
                "modifierName": {
                  "id": 1967,
                  "name": "ERC721",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 957,
                  "src": "1651:6:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "1651:23:15"
              }
            ],
            "name": "",
            "nameLocation": "-1:-1:-1",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1966,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1961,
                  "mutability": "mutable",
                  "name": "name_",
                  "nameLocation": "1576:5:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2011,
                  "src": "1562:19:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1960,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "1562:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1963,
                  "mutability": "mutable",
                  "name": "symbol_",
                  "nameLocation": "1605:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2011,
                  "src": "1591:21:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1962,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "1591:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1965,
                  "mutability": "mutable",
                  "name": "baseURI_",
                  "nameLocation": "1636:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2011,
                  "src": "1622:22:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1964,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "1622:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1552:98:15"
            },
            "returnParameters": {
              "id": 1971,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1675:0:15"
            },
            "scope": 2323,
            "src": "1541:540:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2043,
              "nodeType": "Block",
              "src": "2180:199:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2026,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "nodeType": "UnaryOperation",
                        "operator": "!",
                        "prefix": true,
                        "src": "2198:18:15",
                        "subExpression": {
                          "arguments": [
                            {
                              "id": 2024,
                              "name": "tokenId_",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2015,
                              "src": "2207:8:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            ],
                            "id": 2023,
                            "name": "_exists",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 565,
                            "src": "2199:7:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_bool_$",
                              "typeString": "function (uint256) view returns (bool)"
                            }
                          },
                          "id": 2025,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2199:17:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4552433732313a20546f6b656e20494420616c7265616479206d696e746564",
                        "id": 2027,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2218:33:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_4a1e787e6c9300109d749bc57a11ac0f4f61a945da0469e79b2b6790785e7589",
                          "typeString": "literal_string \"ERC721: Token ID already minted\""
                        },
                        "value": "ERC721: Token ID already minted"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_4a1e787e6c9300109d749bc57a11ac0f4f61a945da0469e79b2b6790785e7589",
                          "typeString": "literal_string \"ERC721: Token ID already minted\""
                        }
                      ],
                      "id": 2022,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2190:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2028,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2190:62:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2029,
                  "nodeType": "ExpressionStatement",
                  "src": "2190:62:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "baseExpression": {
                          "id": 2031,
                          "name": "_reservedIdsMap",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1941,
                          "src": "2270:15:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
                            "typeString": "mapping(uint256 => bool)"
                          }
                        },
                        "id": 2033,
                        "indexExpression": {
                          "id": 2032,
                          "name": "tokenId_",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2015,
                          "src": "2286:8:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "nodeType": "IndexAccess",
                        "src": "2270:25:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4552433732313a20546f6b656e204944206e6f74207265736572766564",
                        "id": 2034,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2297:31:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_1c2c7d0b3442273531ca7db6f6355720ec7286f878a3a593f7011d0ce5fdeca1",
                          "typeString": "literal_string \"ERC721: Token ID not reserved\""
                        },
                        "value": "ERC721: Token ID not reserved"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_1c2c7d0b3442273531ca7db6f6355720ec7286f878a3a593f7011d0ce5fdeca1",
                          "typeString": "literal_string \"ERC721: Token ID not reserved\""
                        }
                      ],
                      "id": 2030,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2262:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2035,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2262:67:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2036,
                  "nodeType": "ExpressionStatement",
                  "src": "2262:67:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2038,
                        "name": "spell_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2013,
                        "src": "2350:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 2039,
                        "name": "tokenId_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2015,
                        "src": "2358:8:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 2040,
                        "name": "to_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2017,
                        "src": "2368:3:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2037,
                      "name": "_mintSpell",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2313,
                      "src": "2339:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$_t_uint256_$_t_address_$returns$__$",
                        "typeString": "function (string memory,uint256,address)"
                      }
                    },
                    "id": 2041,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2339:33:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2042,
                  "nodeType": "ExpressionStatement",
                  "src": "2339:33:15"
                }
              ]
            },
            "functionSelector": "8e67b39a",
            "id": 2044,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 2020,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 2019,
                  "name": "onlyOwner",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 46,
                  "src": "2170:9:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "2170:9:15"
              }
            ],
            "name": "mintReserved",
            "nameLocation": "2097:12:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2018,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2013,
                  "mutability": "mutable",
                  "name": "spell_",
                  "nameLocation": "2124:6:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2044,
                  "src": "2110:20:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2012,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "2110:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2015,
                  "mutability": "mutable",
                  "name": "tokenId_",
                  "nameLocation": "2140:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2044,
                  "src": "2132:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2014,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "2132:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2017,
                  "mutability": "mutable",
                  "name": "to_",
                  "nameLocation": "2158:3:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2044,
                  "src": "2150:11:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2016,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "2150:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "2109:53:15"
            },
            "returnParameters": {
              "id": 2021,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "2180:0:15"
            },
            "scope": 2323,
            "src": "2088:291:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2117,
              "nodeType": "Block",
              "src": "2437:576:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 2053,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 2050,
                            "name": "msg",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967281,
                            "src": "2455:3:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_message",
                              "typeString": "msg"
                            }
                          },
                          "id": 2051,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "value",
                          "nodeType": "MemberAccess",
                          "src": "2455:9:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">=",
                        "rightExpression": {
                          "id": 2052,
                          "name": "PRICE",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1895,
                          "src": "2468:5:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "2455:18:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4d7573742070617920666f72206d696e74696e67",
                        "id": 2054,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2475:22:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_fccfa08521b2a4f02b9d2ab831967715a908f7cc2cad0af859fbb6558108466d",
                          "typeString": "literal_string \"Must pay for minting\""
                        },
                        "value": "Must pay for minting"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_fccfa08521b2a4f02b9d2ab831967715a908f7cc2cad0af859fbb6558108466d",
                          "typeString": "literal_string \"Must pay for minting\""
                        }
                      ],
                      "id": 2049,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2447:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2055,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2447:51:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2056,
                  "nodeType": "ExpressionStatement",
                  "src": "2447:51:15"
                },
                {
                  "assignments": [
                    2058
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2058,
                      "mutability": "mutable",
                      "name": "tokenId",
                      "nameLocation": "2516:7:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2117,
                      "src": "2508:15:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 2057,
                        "name": "uint256",
                        "nodeType": "ElementaryTypeName",
                        "src": "2508:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2059,
                  "nodeType": "VariableDeclarationStatement",
                  "src": "2508:15:15"
                },
                {
                  "body": {
                    "id": 2092,
                    "nodeType": "Block",
                    "src": "2546:300:15",
                    "statements": [
                      {
                        "expression": {
                          "id": 2065,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "id": 2061,
                            "name": "tokenId",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2058,
                            "src": "2560:7:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "arguments": [],
                            "expression": {
                              "argumentTypes": [],
                              "expression": {
                                "id": 2062,
                                "name": "_tokenIds",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1902,
                                "src": "2570:9:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_struct$_Counter_$1443_storage",
                                  "typeString": "struct Counters.Counter storage ref"
                                }
                              },
                              "id": 2063,
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "current",
                              "nodeType": "MemberAccess",
                              "referencedDeclaration": 1455,
                              "src": "2570:17:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_function_internal_view$_t_struct$_Counter_$1443_storage_ptr_$returns$_t_uint256_$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                                "typeString": "function (struct Counters.Counter storage pointer) view returns (uint256)"
                              }
                            },
                            "id": 2064,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "kind": "functionCall",
                            "lValueRequested": false,
                            "names": [],
                            "nodeType": "FunctionCall",
                            "src": "2570:19:15",
                            "tryCall": false,
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "2560:29:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "id": 2066,
                        "nodeType": "ExpressionStatement",
                        "src": "2560:29:15"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          "id": 2073,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "baseExpression": {
                              "id": 2067,
                              "name": "_reservedIdsMap",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1941,
                              "src": "2607:15:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
                                "typeString": "mapping(uint256 => bool)"
                              }
                            },
                            "id": 2069,
                            "indexExpression": {
                              "id": 2068,
                              "name": "tokenId",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2058,
                              "src": "2623:7:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "IndexAccess",
                            "src": "2607:24:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "||",
                          "rightExpression": {
                            "arguments": [
                              {
                                "id": 2071,
                                "name": "tokenId",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 2058,
                                "src": "2643:7:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              }
                            ],
                            "expression": {
                              "argumentTypes": [
                                {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              ],
                              "id": 2070,
                              "name": "_exists",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 565,
                              "src": "2635:7:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_bool_$",
                                "typeString": "function (uint256) view returns (bool)"
                              }
                            },
                            "id": 2072,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "kind": "functionCall",
                            "lValueRequested": false,
                            "names": [],
                            "nodeType": "FunctionCall",
                            "src": "2635:16:15",
                            "tryCall": false,
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "src": "2607:44:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "falseBody": {
                          "id": 2090,
                          "nodeType": "Block",
                          "src": "2798:38:15",
                          "statements": [
                            {
                              "id": 2089,
                              "nodeType": "Break",
                              "src": "2816:5:15"
                            }
                          ]
                        },
                        "id": 2091,
                        "nodeType": "IfStatement",
                        "src": "2603:233:15",
                        "trueBody": {
                          "id": 2088,
                          "nodeType": "Block",
                          "src": "2653:139:15",
                          "statements": [
                            {
                              "expression": {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2074,
                                    "name": "_tokenIds",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1902,
                                    "src": "2671:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_Counter_$1443_storage",
                                      "typeString": "struct Counters.Counter storage ref"
                                    }
                                  },
                                  "id": 2076,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "increment",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1469,
                                  "src": "2671:19:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_internal_nonpayable$_t_struct$_Counter_$1443_storage_ptr_$returns$__$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                                    "typeString": "function (struct Counters.Counter storage pointer)"
                                  }
                                },
                                "id": 2077,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "2671:21:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_tuple$__$",
                                  "typeString": "tuple()"
                                }
                              },
                              "id": 2078,
                              "nodeType": "ExpressionStatement",
                              "src": "2671:21:15"
                            },
                            {
                              "expression": {
                                "arguments": [
                                  {
                                    "commonType": {
                                      "typeIdentifier": "t_uint256",
                                      "typeString": "uint256"
                                    },
                                    "id": 2084,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "arguments": [],
                                      "expression": {
                                        "argumentTypes": [],
                                        "expression": {
                                          "id": 2080,
                                          "name": "_tokenIds",
                                          "nodeType": "Identifier",
                                          "overloadedDeclarations": [],
                                          "referencedDeclaration": 1902,
                                          "src": "2718:9:15",
                                          "typeDescriptions": {
                                            "typeIdentifier": "t_struct$_Counter_$1443_storage",
                                            "typeString": "struct Counters.Counter storage ref"
                                          }
                                        },
                                        "id": 2081,
                                        "isConstant": false,
                                        "isLValue": true,
                                        "isPure": false,
                                        "lValueRequested": false,
                                        "memberName": "current",
                                        "nodeType": "MemberAccess",
                                        "referencedDeclaration": 1455,
                                        "src": "2718:17:15",
                                        "typeDescriptions": {
                                          "typeIdentifier": "t_function_internal_view$_t_struct$_Counter_$1443_storage_ptr_$returns$_t_uint256_$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                                          "typeString": "function (struct Counters.Counter storage pointer) view returns (uint256)"
                                        }
                                      },
                                      "id": 2082,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": false,
                                      "kind": "functionCall",
                                      "lValueRequested": false,
                                      "names": [],
                                      "nodeType": "FunctionCall",
                                      "src": "2718:19:15",
                                      "tryCall": false,
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_uint256",
                                        "typeString": "uint256"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": "<=",
                                    "rightExpression": {
                                      "id": 2083,
                                      "name": "MAX_SUPPLY",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1888,
                                      "src": "2741:10:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_uint256",
                                        "typeString": "uint256"
                                      }
                                    },
                                    "src": "2718:33:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  {
                                    "hexValue": "546f6b656e20537570706c79204465706c65746564",
                                    "id": 2085,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": true,
                                    "kind": "string",
                                    "lValueRequested": false,
                                    "nodeType": "Literal",
                                    "src": "2753:23:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_stringliteral_87071b775c098f158e75d4151fe00b2f4e6b1c99f64ed70bf38a282a217e04e7",
                                      "typeString": "literal_string \"Token Supply Depleted\""
                                    },
                                    "value": "Token Supply Depleted"
                                  }
                                ],
                                "expression": {
                                  "argumentTypes": [
                                    {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    },
                                    {
                                      "typeIdentifier": "t_stringliteral_87071b775c098f158e75d4151fe00b2f4e6b1c99f64ed70bf38a282a217e04e7",
                                      "typeString": "literal_string \"Token Supply Depleted\""
                                    }
                                  ],
                                  "id": 2079,
                                  "name": "require",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [
                                    4294967278,
                                    4294967278
                                  ],
                                  "referencedDeclaration": 4294967278,
                                  "src": "2710:7:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                                    "typeString": "function (bool,string memory) pure"
                                  }
                                },
                                "id": 2086,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "2710:67:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_tuple$__$",
                                  "typeString": "tuple()"
                                }
                              },
                              "id": 2087,
                              "nodeType": "ExpressionStatement",
                              "src": "2710:67:15"
                            }
                          ]
                        }
                      }
                    ]
                  },
                  "condition": {
                    "hexValue": "74727565",
                    "id": 2060,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "bool",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "2540:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    },
                    "value": "true"
                  },
                  "id": 2093,
                  "nodeType": "WhileStatement",
                  "src": "2533:313:15"
                },
                {
                  "assignments": [
                    2095,
                    null
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2095,
                      "mutability": "mutable",
                      "name": "success",
                      "nameLocation": "2861:7:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2117,
                      "src": "2856:12:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_bool",
                        "typeString": "bool"
                      },
                      "typeName": {
                        "id": 2094,
                        "name": "bool",
                        "nodeType": "ElementaryTypeName",
                        "src": "2856:4:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      "visibility": "internal"
                    },
                    null
                  ],
                  "id": 2104,
                  "initialValue": {
                    "arguments": [
                      {
                        "hexValue": "",
                        "id": 2102,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2907:2:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                          "typeString": "literal_string \"\""
                        },
                        "value": ""
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                          "typeString": "literal_string \"\""
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                            "typeString": "literal_string \"\""
                          }
                        ],
                        "expression": {
                          "arguments": [],
                          "expression": {
                            "argumentTypes": [],
                            "id": 2096,
                            "name": "owner",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 32,
                            "src": "2874:5:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_view$__$returns$_t_address_$",
                              "typeString": "function () view returns (address)"
                            }
                          },
                          "id": 2097,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2874:7:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "id": 2098,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "call",
                        "nodeType": "MemberAccess",
                        "src": "2874:12:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_barecall_payable$_t_bytes_memory_ptr_$returns$_t_bool_$_t_bytes_memory_ptr_$",
                          "typeString": "function (bytes memory) payable returns (bool,bytes memory)"
                        }
                      },
                      "id": 2101,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "names": [
                        "value"
                      ],
                      "nodeType": "FunctionCallOptions",
                      "options": [
                        {
                          "expression": {
                            "id": 2099,
                            "name": "msg",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967281,
                            "src": "2895:3:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_message",
                              "typeString": "msg"
                            }
                          },
                          "id": 2100,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "value",
                          "nodeType": "MemberAccess",
                          "src": "2895:9:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "src": "2874:32:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_barecall_payable$_t_bytes_memory_ptr_$returns$_t_bool_$_t_bytes_memory_ptr_$value",
                        "typeString": "function (bytes memory) payable returns (bool,bytes memory)"
                      }
                    },
                    "id": 2103,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2874:36:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$_t_bool_$_t_bytes_memory_ptr_$",
                      "typeString": "tuple(bool,bytes memory)"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "2855:55:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2106,
                        "name": "success",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2095,
                        "src": "2928:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "5472616e73666572204661696c6564",
                        "id": 2107,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2937:17:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_c5acabcb762867cdbcf367c30c495273eabea012d93b81d74177ab1ef966623f",
                          "typeString": "literal_string \"Transfer Failed\""
                        },
                        "value": "Transfer Failed"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_c5acabcb762867cdbcf367c30c495273eabea012d93b81d74177ab1ef966623f",
                          "typeString": "literal_string \"Transfer Failed\""
                        }
                      ],
                      "id": 2105,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2920:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2108,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2920:35:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2109,
                  "nodeType": "ExpressionStatement",
                  "src": "2920:35:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2111,
                        "name": "spell_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2046,
                        "src": "2976:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 2112,
                        "name": "tokenId",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2058,
                        "src": "2984:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "arguments": [],
                        "expression": {
                          "argumentTypes": [],
                          "id": 2113,
                          "name": "_msgSender",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1427,
                          "src": "2993:10:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_view$__$returns$_t_address_$",
                            "typeString": "function () view returns (address)"
                          }
                        },
                        "id": 2114,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "2993:12:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2110,
                      "name": "_mintSpell",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2313,
                      "src": "2965:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$_t_uint256_$_t_address_$returns$__$",
                        "typeString": "function (string memory,uint256,address)"
                      }
                    },
                    "id": 2115,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2965:41:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2116,
                  "nodeType": "ExpressionStatement",
                  "src": "2965:41:15"
                }
              ]
            },
            "functionSelector": "d85d3d27",
            "id": 2118,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "mint",
            "nameLocation": "2395:4:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2047,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2046,
                  "mutability": "mutable",
                  "name": "spell_",
                  "nameLocation": "2414:6:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2118,
                  "src": "2400:20:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2045,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "2400:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "2399:22:15"
            },
            "returnParameters": {
              "id": 2048,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "2437:0:15"
            },
            "scope": 2323,
            "src": "2386:627:15",
            "stateMutability": "payable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2186,
              "nodeType": "Block",
              "src": "3132:396:15",
              "statements": [
                {
                  "assignments": [
                    2126
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2126,
                      "mutability": "mutable",
                      "name": "b",
                      "nameLocation": "3155:1:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2186,
                      "src": "3142:14:15",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes"
                      },
                      "typeName": {
                        "id": 2125,
                        "name": "bytes",
                        "nodeType": "ElementaryTypeName",
                        "src": "3142:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes_storage_ptr",
                          "typeString": "bytes"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2131,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2129,
                        "name": "str_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2120,
                        "src": "3165:4:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      ],
                      "id": 2128,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "nodeType": "ElementaryTypeNameExpression",
                      "src": "3159:5:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
                        "typeString": "type(bytes storage pointer)"
                      },
                      "typeName": {
                        "id": 2127,
                        "name": "bytes",
                        "nodeType": "ElementaryTypeName",
                        "src": "3159:5:15",
                        "typeDescriptions": {}
                      }
                    },
                    "id": 2130,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "typeConversion",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "3159:11:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_memory_ptr",
                      "typeString": "bytes memory"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "3142:28:15"
                },
                {
                  "assignments": [
                    2133
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2133,
                      "mutability": "mutable",
                      "name": "len",
                      "nameLocation": "3188:3:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2186,
                      "src": "3180:11:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 2132,
                        "name": "uint256",
                        "nodeType": "ElementaryTypeName",
                        "src": "3180:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2136,
                  "initialValue": {
                    "expression": {
                      "id": 2134,
                      "name": "b",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2126,
                      "src": "3194:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "id": 2135,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "length",
                    "nodeType": "MemberAccess",
                    "src": "3194:8:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "3180:22:15"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 2139,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 2137,
                      "name": "len",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2133,
                      "src": "3216:3:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "!=",
                    "rightExpression": {
                      "hexValue": "3130",
                      "id": 2138,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "3223:2:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_10_by_1",
                        "typeString": "int_const 10"
                      },
                      "value": "10"
                    },
                    "src": "3216:9:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 2143,
                  "nodeType": "IfStatement",
                  "src": "3212:60:15",
                  "trueBody": {
                    "id": 2142,
                    "nodeType": "Block",
                    "src": "3227:45:15",
                    "statements": [
                      {
                        "expression": {
                          "hexValue": "66616c7365",
                          "id": 2140,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "bool",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "3256:5:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          "value": "false"
                        },
                        "functionReturnParameters": 2124,
                        "id": 2141,
                        "nodeType": "Return",
                        "src": "3249:12:15"
                      }
                    ]
                  }
                },
                {
                  "body": {
                    "id": 2182,
                    "nodeType": "Block",
                    "src": "3311:190:15",
                    "statements": [
                      {
                        "assignments": [
                          2154
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 2154,
                            "mutability": "mutable",
                            "name": "c",
                            "nameLocation": "3332:1:15",
                            "nodeType": "VariableDeclaration",
                            "scope": 2182,
                            "src": "3325:8:15",
                            "stateVariable": false,
                            "storageLocation": "default",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bytes1",
                              "typeString": "bytes1"
                            },
                            "typeName": {
                              "id": 2153,
                              "name": "bytes1",
                              "nodeType": "ElementaryTypeName",
                              "src": "3325:6:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_bytes1",
                                "typeString": "bytes1"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 2158,
                        "initialValue": {
                          "baseExpression": {
                            "id": 2155,
                            "name": "b",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2126,
                            "src": "3336:1:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bytes_memory_ptr",
                              "typeString": "bytes memory"
                            }
                          },
                          "id": 2157,
                          "indexExpression": {
                            "id": 2156,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2145,
                            "src": "3338:1:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "3336:4:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bytes1",
                            "typeString": "bytes1"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "3325:15:15"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          "id": 2177,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "id": 2167,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "UnaryOperation",
                            "operator": "!",
                            "prefix": true,
                            "src": "3357:25:15",
                            "subExpression": {
                              "components": [
                                {
                                  "commonType": {
                                    "typeIdentifier": "t_bool",
                                    "typeString": "bool"
                                  },
                                  "id": 2165,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "leftExpression": {
                                    "commonType": {
                                      "typeIdentifier": "t_bytes1",
                                      "typeString": "bytes1"
                                    },
                                    "id": 2161,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "id": 2159,
                                      "name": "c",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 2154,
                                      "src": "3359:1:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_bytes1",
                                        "typeString": "bytes1"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": ">=",
                                    "rightExpression": {
                                      "hexValue": "30783631",
                                      "id": 2160,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "number",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "3364:4:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_rational_97_by_1",
                                        "typeString": "int_const 97"
                                      },
                                      "value": "0x61"
                                    },
                                    "src": "3359:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  "nodeType": "BinaryOperation",
                                  "operator": "&&",
                                  "rightExpression": {
                                    "commonType": {
                                      "typeIdentifier": "t_bytes1",
                                      "typeString": "bytes1"
                                    },
                                    "id": 2164,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "id": 2162,
                                      "name": "c",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 2154,
                                      "src": "3372:1:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_bytes1",
                                        "typeString": "bytes1"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": "<=",
                                    "rightExpression": {
                                      "hexValue": "30783741",
                                      "id": 2163,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "number",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "3377:4:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_rational_122_by_1",
                                        "typeString": "int_const 122"
                                      },
                                      "value": "0x7A"
                                    },
                                    "src": "3372:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  "src": "3359:22:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_bool",
                                    "typeString": "bool"
                                  }
                                }
                              ],
                              "id": 2166,
                              "isConstant": false,
                              "isInlineArray": false,
                              "isLValue": false,
                              "isPure": false,
                              "lValueRequested": false,
                              "nodeType": "TupleExpression",
                              "src": "3358:24:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_bool",
                                "typeString": "bool"
                              }
                            },
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "&&",
                          "rightExpression": {
                            "id": 2176,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "UnaryOperation",
                            "operator": "!",
                            "prefix": true,
                            "src": "3410:25:15",
                            "subExpression": {
                              "components": [
                                {
                                  "commonType": {
                                    "typeIdentifier": "t_bool",
                                    "typeString": "bool"
                                  },
                                  "id": 2174,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "leftExpression": {
                                    "commonType": {
                                      "typeIdentifier": "t_bytes1",
                                      "typeString": "bytes1"
                                    },
                                    "id": 2170,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "id": 2168,
                                      "name": "c",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 2154,
                                      "src": "3412:1:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_bytes1",
                                        "typeString": "bytes1"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": ">=",
                                    "rightExpression": {
                                      "hexValue": "30783330",
                                      "id": 2169,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "number",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "3417:4:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_rational_48_by_1",
                                        "typeString": "int_const 48"
                                      },
                                      "value": "0x30"
                                    },
                                    "src": "3412:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  "nodeType": "BinaryOperation",
                                  "operator": "&&",
                                  "rightExpression": {
                                    "commonType": {
                                      "typeIdentifier": "t_bytes1",
                                      "typeString": "bytes1"
                                    },
                                    "id": 2173,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "id": 2171,
                                      "name": "c",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 2154,
                                      "src": "3425:1:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_bytes1",
                                        "typeString": "bytes1"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": "<=",
                                    "rightExpression": {
                                      "hexValue": "30783339",
                                      "id": 2172,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "number",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "3430:4:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_rational_57_by_1",
                                        "typeString": "int_const 57"
                                      },
                                      "value": "0x39"
                                    },
                                    "src": "3425:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  "src": "3412:22:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_bool",
                                    "typeString": "bool"
                                  }
                                }
                              ],
                              "id": 2175,
                              "isConstant": false,
                              "isInlineArray": false,
                              "isLValue": false,
                              "isPure": false,
                              "lValueRequested": false,
                              "nodeType": "TupleExpression",
                              "src": "3411:24:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_bool",
                                "typeString": "bool"
                              }
                            },
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "src": "3357:78:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 2181,
                        "nodeType": "IfStatement",
                        "src": "3354:137:15",
                        "trueBody": {
                          "id": 2180,
                          "nodeType": "Block",
                          "src": "3437:54:15",
                          "statements": [
                            {
                              "expression": {
                                "hexValue": "66616c7365",
                                "id": 2178,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "kind": "bool",
                                "lValueRequested": false,
                                "nodeType": "Literal",
                                "src": "3471:5:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_bool",
                                  "typeString": "bool"
                                },
                                "value": "false"
                              },
                              "functionReturnParameters": 2124,
                              "id": 2179,
                              "nodeType": "Return",
                              "src": "3464:12:15"
                            }
                          ]
                        }
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 2149,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 2147,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2145,
                      "src": "3297:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 2148,
                      "name": "len",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2133,
                      "src": "3301:3:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3297:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 2183,
                  "initializationExpression": {
                    "assignments": [
                      2145
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 2145,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "3294:1:15",
                        "nodeType": "VariableDeclaration",
                        "scope": 2183,
                        "src": "3286:9:15",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 2144,
                          "name": "uint256",
                          "nodeType": "ElementaryTypeName",
                          "src": "3286:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 2146,
                    "nodeType": "VariableDeclarationStatement",
                    "src": "3286:9:15"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 2151,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "3306:3:15",
                      "subExpression": {
                        "id": 2150,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2145,
                        "src": "3306:1:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 2152,
                    "nodeType": "ExpressionStatement",
                    "src": "3306:3:15"
                  },
                  "nodeType": "ForStatement",
                  "src": "3281:220:15"
                },
                {
                  "expression": {
                    "hexValue": "74727565",
                    "id": 2184,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "bool",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "3517:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    },
                    "value": "true"
                  },
                  "functionReturnParameters": 2124,
                  "id": 2185,
                  "nodeType": "Return",
                  "src": "3510:11:15"
                }
              ]
            },
            "functionSelector": "7649d3cb",
            "id": 2187,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "verifySpell",
            "nameLocation": "3073:11:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2121,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2120,
                  "mutability": "mutable",
                  "name": "str_",
                  "nameLocation": "3099:4:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2187,
                  "src": "3085:18:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2119,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "3085:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3084:20:15"
            },
            "returnParameters": {
              "id": 2124,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2123,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2187,
                  "src": "3126:4:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 2122,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "3126:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3125:6:15"
            },
            "scope": 2323,
            "src": "3064:464:15",
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "baseFunctions": [
              125
            ],
            "body": {
              "id": 2220,
              "nodeType": "Block",
              "src": "4131:172:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 2203,
                            "name": "tokenId_",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2190,
                            "src": "4157:8:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          ],
                          "id": 2202,
                          "name": "_exists",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 565,
                          "src": "4149:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_bool_$",
                            "typeString": "function (uint256) view returns (bool)"
                          }
                        },
                        "id": 2204,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "4149:17:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4552433732313a204e6f6e6578697374656e7420546f6b656e204944",
                        "id": 2205,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "4168:30:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_54ec63a34df5f93dcd1e2de2b3cda8a7cad00cf9da902f0e9a30741ff9bcf20d",
                          "typeString": "literal_string \"ERC721: Nonexistent Token ID\""
                        },
                        "value": "ERC721: Nonexistent Token ID"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_54ec63a34df5f93dcd1e2de2b3cda8a7cad00cf9da902f0e9a30741ff9bcf20d",
                          "typeString": "literal_string \"ERC721: Nonexistent Token ID\""
                        }
                      ],
                      "id": 2201,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "4141:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2206,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4141:58:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2207,
                  "nodeType": "ExpressionStatement",
                  "src": "4141:58:15"
                },
                {
                  "expression": {
                    "id": 2210,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2208,
                      "name": "receiver",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2197,
                      "src": "4209:8:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 2209,
                      "name": "donationAddress",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1950,
                      "src": "4220:15:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "src": "4209:26:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "id": 2211,
                  "nodeType": "ExpressionStatement",
                  "src": "4209:26:15"
                },
                {
                  "expression": {
                    "id": 2218,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2212,
                      "name": "donationAmount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2199,
                      "src": "4245:14:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "commonType": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "id": 2217,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "leftExpression": {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 2215,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 2213,
                          "name": "salePrice_",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2192,
                          "src": "4262:10:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "*",
                        "rightExpression": {
                          "id": 2214,
                          "name": "donationPercent",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1953,
                          "src": "4275:15:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "4262:28:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "nodeType": "BinaryOperation",
                      "operator": "/",
                      "rightExpression": {
                        "hexValue": "313030",
                        "id": 2216,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "number",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "4293:3:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_rational_100_by_1",
                          "typeString": "int_const 100"
                        },
                        "value": "100"
                      },
                      "src": "4262:34:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "4245:51:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 2219,
                  "nodeType": "ExpressionStatement",
                  "src": "4245:51:15"
                }
              ]
            },
            "documentation": {
              "id": 2188,
              "nodeType": "StructuredDocumentation",
              "src": "3534:405:15",
              "text": " @dev Called with the sale price to determine how much royalty is owed and to whom.\n @param tokenId_ - the NFT asset queried for royalty information\n @param salePrice_ - the sale price of the NFT asset specified by `tokenId`\n @return receiver - address of who should be sent the royalty payment\n @return donationAmount - the royalty payment amount for `salePrice`"
            },
            "functionSelector": "2a55205a",
            "id": 2221,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "royaltyInfo",
            "nameLocation": "3953:11:15",
            "nodeType": "FunctionDefinition",
            "overrides": {
              "id": 2195,
              "nodeType": "OverrideSpecifier",
              "overrides": [
                {
                  "id": 2194,
                  "name": "IERC2981",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 126,
                  "src": "4048:8:15"
                }
              ],
              "src": "4039:18:15"
            },
            "parameters": {
              "id": 2193,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2190,
                  "mutability": "mutable",
                  "name": "tokenId_",
                  "nameLocation": "3982:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2221,
                  "src": "3974:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2189,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "3974:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2192,
                  "mutability": "mutable",
                  "name": "salePrice_",
                  "nameLocation": "4008:10:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2221,
                  "src": "4000:18:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2191,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4000:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3964:60:15"
            },
            "returnParameters": {
              "id": 2200,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2197,
                  "mutability": "mutable",
                  "name": "receiver",
                  "nameLocation": "4084:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2221,
                  "src": "4076:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2196,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "4076:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2199,
                  "mutability": "mutable",
                  "name": "donationAmount",
                  "nameLocation": "4110:14:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2221,
                  "src": "4102:22:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2198,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4102:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4066:64:15"
            },
            "scope": 2323,
            "src": "3944:359:15",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "baseFunctions": [
              220,
              1768,
              1800
            ],
            "body": {
              "id": 2244,
              "nodeType": "Block",
              "src": "4488:105:15",
              "statements": [
                {
                  "expression": {
                    "commonType": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    },
                    "id": 2242,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "commonType": {
                        "typeIdentifier": "t_bytes4",
                        "typeString": "bytes4"
                      },
                      "id": 2237,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "leftExpression": {
                        "id": 2232,
                        "name": "interfaceId",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2223,
                        "src": "4505:11:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      },
                      "nodeType": "BinaryOperation",
                      "operator": "==",
                      "rightExpression": {
                        "expression": {
                          "arguments": [
                            {
                              "id": 2234,
                              "name": "IERC2981",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 126,
                              "src": "4525:8:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_type$_t_contract$_IERC2981_$126_$",
                                "typeString": "type(contract IERC2981)"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_type$_t_contract$_IERC2981_$126_$",
                                "typeString": "type(contract IERC2981)"
                              }
                            ],
                            "id": 2233,
                            "name": "type",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967269,
                            "src": "4520:4:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_metatype_pure$__$returns$__$",
                              "typeString": "function () pure"
                            }
                          },
                          "id": 2235,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "4520:14:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_meta_type_t_contract$_IERC2981_$126",
                            "typeString": "type(contract IERC2981)"
                          }
                        },
                        "id": 2236,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "interfaceId",
                        "nodeType": "MemberAccess",
                        "src": "4520:26:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      },
                      "src": "4505:41:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_bool",
                        "typeString": "bool"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "||",
                    "rightExpression": {
                      "arguments": [
                        {
                          "id": 2240,
                          "name": "interfaceId",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2223,
                          "src": "4574:11:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bytes4",
                            "typeString": "bytes4"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_bytes4",
                            "typeString": "bytes4"
                          }
                        ],
                        "expression": {
                          "id": 2238,
                          "name": "super",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967271,
                          "src": "4550:5:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_super$_ClavesAngelicae_$2323_$",
                            "typeString": "type(contract super ClavesAngelicae)"
                          }
                        },
                        "id": 2239,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "supportsInterface",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 1768,
                        "src": "4550:23:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_internal_view$_t_bytes4_$returns$_t_bool_$",
                          "typeString": "function (bytes4) view returns (bool)"
                        }
                      },
                      "id": 2241,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "4550:36:15",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bool",
                        "typeString": "bool"
                      }
                    },
                    "src": "4505:81:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "functionReturnParameters": 2231,
                  "id": 2243,
                  "nodeType": "Return",
                  "src": "4498:88:15"
                }
              ]
            },
            "functionSelector": "01ffc9a7",
            "id": 2245,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "supportsInterface",
            "nameLocation": "4319:17:15",
            "nodeType": "FunctionDefinition",
            "overrides": {
              "id": 2228,
              "nodeType": "OverrideSpecifier",
              "overrides": [
                {
                  "id": 2225,
                  "name": "ERC721",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 957,
                  "src": "4419:6:15"
                },
                {
                  "id": 2226,
                  "name": "IERC165",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1801,
                  "src": "4427:7:15"
                },
                {
                  "id": 2227,
                  "name": "ERC165Storage",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1789,
                  "src": "4436:13:15"
                }
              ],
              "src": "4409:46:15"
            },
            "parameters": {
              "id": 2224,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2223,
                  "mutability": "mutable",
                  "name": "interfaceId",
                  "nameLocation": "4344:11:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2245,
                  "src": "4337:18:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes4",
                    "typeString": "bytes4"
                  },
                  "typeName": {
                    "id": 2222,
                    "name": "bytes4",
                    "nodeType": "ElementaryTypeName",
                    "src": "4337:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes4",
                      "typeString": "bytes4"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4336:20:15"
            },
            "returnParameters": {
              "id": 2231,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2230,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2245,
                  "src": "4474:4:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 2229,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "4474:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4464:20:15"
            },
            "scope": 2323,
            "src": "4310:283:15",
            "stateMutability": "view",
            "virtual": true,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2256,
              "nodeType": "Block",
              "src": "4658:38:15",
              "statements": [
                {
                  "expression": {
                    "id": 2254,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2252,
                      "name": "donationAddress",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1950,
                      "src": "4668:15:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 2253,
                      "name": "to_",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2247,
                      "src": "4686:3:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "src": "4668:21:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "id": 2255,
                  "nodeType": "ExpressionStatement",
                  "src": "4668:21:15"
                }
              ]
            },
            "functionSelector": "6f48e79b",
            "id": 2257,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 2250,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 2249,
                  "name": "onlyOwner",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 46,
                  "src": "4648:9:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "4648:9:15"
              }
            ],
            "name": "setDonationAddress",
            "nameLocation": "4609:18:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2248,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2247,
                  "mutability": "mutable",
                  "name": "to_",
                  "nameLocation": "4636:3:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2257,
                  "src": "4628:11:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2246,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "4628:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4627:13:15"
            },
            "returnParameters": {
              "id": 2251,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4658:0:15"
            },
            "scope": 2323,
            "src": "4600:96:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2268,
              "nodeType": "Block",
              "src": "4766:43:15",
              "statements": [
                {
                  "expression": {
                    "id": 2266,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2264,
                      "name": "donationPercent",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1953,
                      "src": "4776:15:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 2265,
                      "name": "percent_",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2259,
                      "src": "4794:8:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "4776:26:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 2267,
                  "nodeType": "ExpressionStatement",
                  "src": "4776:26:15"
                }
              ]
            },
            "functionSelector": "87a89091",
            "id": 2269,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 2262,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 2261,
                  "name": "onlyOwner",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 46,
                  "src": "4756:9:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "4756:9:15"
              }
            ],
            "name": "setDonationPercent",
            "nameLocation": "4712:18:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2260,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2259,
                  "mutability": "mutable",
                  "name": "percent_",
                  "nameLocation": "4739:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2269,
                  "src": "4731:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2258,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4731:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4730:18:15"
            },
            "returnParameters": {
              "id": 2263,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4766:0:15"
            },
            "scope": 2323,
            "src": "4703:106:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2278,
              "nodeType": "Block",
              "src": "4871:43:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [],
                    "expression": {
                      "argumentTypes": [],
                      "expression": {
                        "id": 2274,
                        "name": "_tokenIds",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1902,
                        "src": "4888:9:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_Counter_$1443_storage",
                          "typeString": "struct Counters.Counter storage ref"
                        }
                      },
                      "id": 2275,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "current",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 1455,
                      "src": "4888:17:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_view$_t_struct$_Counter_$1443_storage_ptr_$returns$_t_uint256_$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                        "typeString": "function (struct Counters.Counter storage pointer) view returns (uint256)"
                      }
                    },
                    "id": 2276,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4888:19:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 2273,
                  "id": 2277,
                  "nodeType": "Return",
                  "src": "4881:26:15"
                }
              ]
            },
            "functionSelector": "18160ddd",
            "id": 2279,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "totalSupply",
            "nameLocation": "4825:11:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2270,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4836:2:15"
            },
            "returnParameters": {
              "id": 2273,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2272,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2279,
                  "src": "4862:7:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2271,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4862:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4861:9:15"
            },
            "scope": 2323,
            "src": "4816:98:15",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 2312,
              "nodeType": "Block",
              "src": "5002:196:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 2290,
                            "name": "spell_",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2281,
                            "src": "5032:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_string_memory_ptr",
                              "typeString": "string memory"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_string_memory_ptr",
                              "typeString": "string memory"
                            }
                          ],
                          "id": 2289,
                          "name": "verifySpell",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2187,
                          "src": "5020:11:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_pure$_t_string_memory_ptr_$returns$_t_bool_$",
                            "typeString": "function (string memory) pure returns (bool)"
                          }
                        },
                        "id": 2291,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "5020:19:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "5370656c6c206d757374206265202f5b612d7a302d395d7b31307d2f",
                        "id": 2292,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "5041:30:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_aba60cc965cfe1c7515403b444382e9ca8447d0e21230479a8ddb6f5870b1445",
                          "typeString": "literal_string \"Spell must be /[a-z0-9]{10}/\""
                        },
                        "value": "Spell must be /[a-z0-9]{10}/"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_aba60cc965cfe1c7515403b444382e9ca8447d0e21230479a8ddb6f5870b1445",
                          "typeString": "literal_string \"Spell must be /[a-z0-9]{10}/\""
                        }
                      ],
                      "id": 2288,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "5012:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2293,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5012:60:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2294,
                  "nodeType": "ExpressionStatement",
                  "src": "5012:60:15"
                },
                {
                  "expression": {
                    "id": 2299,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "id": 2295,
                        "name": "tokenIdToSpell",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1945,
                        "src": "5082:14:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_uint256_$_t_string_storage_$",
                          "typeString": "mapping(uint256 => string storage ref)"
                        }
                      },
                      "id": 2297,
                      "indexExpression": {
                        "id": 2296,
                        "name": "tokenId_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2283,
                        "src": "5097:8:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "5082:24:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 2298,
                      "name": "spell_",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2281,
                      "src": "5109:6:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "5082:33:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 2300,
                  "nodeType": "ExpressionStatement",
                  "src": "5082:33:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2302,
                        "name": "to_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2285,
                        "src": "5135:3:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2303,
                        "name": "tokenId_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2283,
                        "src": "5140:8:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 2301,
                      "name": "_safeMint",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        621,
                        650
                      ],
                      "referencedDeclaration": 621,
                      "src": "5125:9:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        "typeString": "function (address,uint256)"
                      }
                    },
                    "id": 2304,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5125:24:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2305,
                  "nodeType": "ExpressionStatement",
                  "src": "5125:24:15"
                },
                {
                  "eventCall": {
                    "arguments": [
                      {
                        "id": 2307,
                        "name": "tokenId_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2283,
                        "src": "5169:8:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 2308,
                        "name": "spell_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2281,
                        "src": "5179:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 2309,
                        "name": "to_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2285,
                        "src": "5187:3:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2306,
                      "name": "Mint",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1885,
                      "src": "5164:4:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_string_memory_ptr_$_t_address_$returns$__$",
                        "typeString": "function (uint256,string memory,address)"
                      }
                    },
                    "id": 2310,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5164:27:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2311,
                  "nodeType": "EmitStatement",
                  "src": "5159:32:15"
                }
              ]
            },
            "id": 2313,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "_mintSpell",
            "nameLocation": "4930:10:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2286,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2281,
                  "mutability": "mutable",
                  "name": "spell_",
                  "nameLocation": "4955:6:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2313,
                  "src": "4941:20:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2280,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "4941:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2283,
                  "mutability": "mutable",
                  "name": "tokenId_",
                  "nameLocation": "4971:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2313,
                  "src": "4963:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2282,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4963:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2285,
                  "mutability": "mutable",
                  "name": "to_",
                  "nameLocation": "4989:3:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2313,
                  "src": "4981:11:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2284,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "4981:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4940:53:15"
            },
            "returnParameters": {
              "id": 2287,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "5002:0:15"
            },
            "scope": 2323,
            "src": "4921:277:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "private"
          },
          {
            "baseFunctions": [
              343
            ],
            "body": {
              "id": 2321,
              "nodeType": "Block",
              "src": "5280:37:15",
              "statements": [
                {
                  "expression": {
                    "id": 2319,
                    "name": "_baseTokenURI",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1947,
                    "src": "5297:13:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "functionReturnParameters": 2318,
                  "id": 2320,
                  "nodeType": "Return",
                  "src": "5290:20:15"
                }
              ]
            },
            "id": 2322,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "_baseURI",
            "nameLocation": "5214:8:15",
            "nodeType": "FunctionDefinition",
            "overrides": {
              "id": 2315,
              "nodeType": "OverrideSpecifier",
              "overrides": [],
              "src": "5247:8:15"
            },
            "parameters": {
              "id": 2314,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "5222:2:15"
            },
            "returnParameters": {
              "id": 2318,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2317,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2322,
                  "src": "5265:13:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2316,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "5265:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5264:15:15"
            },
            "scope": 2323,
            "src": "5205:112:15",
            "stateMutability": "view",
            "virtual": true,
            "visibility": "internal"
          }
        ],
        "scope": 2324,
        "src": "404:4915:15",
        "usedErrors": []
      }
    ],
    "src": "32:5289:15"
  },
  "legacyAST": {
    "absolutePath": "project:/contracts/ClavesAngelicae.sol",
    "exportedSymbols": {
      "Address": [
        1415
      ],
      "ClavesAngelicae": [
        2323
      ],
      "Context": [
        1437
      ],
      "Counters": [
        1511
      ],
      "ERC165": [
        1738
      ],
      "ERC165Storage": [
        1789
      ],
      "ERC721": [
        957
      ],
      "IERC165": [
        1801
      ],
      "IERC2981": [
        126
      ],
      "IERC721": [
        1073
      ],
      "IERC721Metadata": [
        1118
      ],
      "IERC721Receiver": [
        1091
      ],
      "Ownable": [
        104
      ],
      "Strings": [
        1714
      ]
    },
    "id": 2324,
    "license": "MIT",
    "nodeType": "SourceUnit",
    "nodes": [
      {
        "id": 1861,
        "literals": [
          "solidity",
          "^",
          "0.8",
          ".0"
        ],
        "nodeType": "PragmaDirective",
        "src": "32:23:15"
      },
      {
        "absolutePath": "@openzeppelin/contracts/token/ERC721/ERC721.sol",
        "file": "@openzeppelin/contracts/token/ERC721/ERC721.sol",
        "id": 1862,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 958,
        "src": "57:57:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/interfaces/IERC2981.sol",
        "file": "@openzeppelin/contracts/interfaces/IERC2981.sol",
        "id": 1863,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 127,
        "src": "115:57:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/utils/introspection/ERC165Storage.sol",
        "file": "@openzeppelin/contracts/utils/introspection/ERC165Storage.sol",
        "id": 1864,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 1790,
        "src": "173:71:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/utils/Context.sol",
        "file": "@openzeppelin/contracts/utils/Context.sol",
        "id": 1865,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 1438,
        "src": "245:51:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/utils/Counters.sol",
        "file": "@openzeppelin/contracts/utils/Counters.sol",
        "id": 1866,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 1512,
        "src": "297:52:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/access/Ownable.sol",
        "file": "@openzeppelin/contracts/access/Ownable.sol",
        "id": 1867,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2324,
        "sourceUnit": 105,
        "src": "350:52:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "abstract": false,
        "baseContracts": [
          {
            "baseName": {
              "id": 1868,
              "name": "Context",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 1437,
              "src": "432:7:15"
            },
            "id": 1869,
            "nodeType": "InheritanceSpecifier",
            "src": "432:7:15"
          },
          {
            "baseName": {
              "id": 1870,
              "name": "ERC721",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 957,
              "src": "441:6:15"
            },
            "id": 1871,
            "nodeType": "InheritanceSpecifier",
            "src": "441:6:15"
          },
          {
            "baseName": {
              "id": 1872,
              "name": "Ownable",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 104,
              "src": "449:7:15"
            },
            "id": 1873,
            "nodeType": "InheritanceSpecifier",
            "src": "449:7:15"
          },
          {
            "baseName": {
              "id": 1874,
              "name": "IERC2981",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 126,
              "src": "458:8:15"
            },
            "id": 1875,
            "nodeType": "InheritanceSpecifier",
            "src": "458:8:15"
          },
          {
            "baseName": {
              "id": 1876,
              "name": "ERC165Storage",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 1789,
              "src": "468:13:15"
            },
            "id": 1877,
            "nodeType": "InheritanceSpecifier",
            "src": "468:13:15"
          }
        ],
        "canonicalName": "ClavesAngelicae",
        "contractDependencies": [],
        "contractKind": "contract",
        "fullyImplemented": true,
        "id": 2323,
        "linearizedBaseContracts": [
          2323,
          1789,
          126,
          104,
          957,
          1118,
          1073,
          1738,
          1801,
          1437
        ],
        "name": "ClavesAngelicae",
        "nameLocation": "413:15:15",
        "nodeType": "ContractDefinition",
        "nodes": [
          {
            "anonymous": false,
            "id": 1885,
            "name": "Mint",
            "nameLocation": "495:4:15",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 1884,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1879,
                  "indexed": true,
                  "mutability": "mutable",
                  "name": "tokenId",
                  "nameLocation": "525:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 1885,
                  "src": "509:23:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1878,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "509:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1881,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "spell",
                  "nameLocation": "549:5:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 1885,
                  "src": "542:12:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1880,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "542:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1883,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "to",
                  "nameLocation": "572:2:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 1885,
                  "src": "564:10:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 1882,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "564:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "499:81:15"
            },
            "src": "489:92:15"
          },
          {
            "constant": false,
            "functionSelector": "32cb6b0c",
            "id": 1888,
            "mutability": "mutable",
            "name": "MAX_SUPPLY",
            "nameLocation": "602:10:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "587:31:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 1886,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "587:7:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "hexValue": "373737",
              "id": 1887,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "615:3:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_777_by_1",
                "typeString": "int_const 777"
              },
              "value": "777"
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "8d859f3e",
            "id": 1895,
            "mutability": "mutable",
            "name": "PRICE",
            "nameLocation": "639:5:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "624:42:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 1889,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "624:7:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "commonType": {
                "typeIdentifier": "t_rational_777000000000000_by_1",
                "typeString": "int_const 777000000000000"
              },
              "id": 1894,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "lValueRequested": false,
              "leftExpression": {
                "hexValue": "302e303030373737",
                "id": 1890,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "kind": "number",
                "lValueRequested": false,
                "nodeType": "Literal",
                "src": "647:8:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_777_by_1000000",
                  "typeString": "rational_const 777 / 1000000"
                },
                "value": "0.000777"
              },
              "nodeType": "BinaryOperation",
              "operator": "*",
              "rightExpression": {
                "commonType": {
                  "typeIdentifier": "t_rational_1000000000000000000_by_1",
                  "typeString": "int_const 1000000000000000000"
                },
                "id": 1893,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "lValueRequested": false,
                "leftExpression": {
                  "hexValue": "3130",
                  "id": 1891,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "658:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_10_by_1",
                    "typeString": "int_const 10"
                  },
                  "value": "10"
                },
                "nodeType": "BinaryOperation",
                "operator": "**",
                "rightExpression": {
                  "hexValue": "3138",
                  "id": 1892,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "664:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_18_by_1",
                    "typeString": "int_const 18"
                  },
                  "value": "18"
                },
                "src": "658:8:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_1000000000000000000_by_1",
                  "typeString": "int_const 1000000000000000000"
                }
              },
              "src": "647:19:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_777000000000000_by_1",
                "typeString": "int_const 777000000000000"
              }
            },
            "visibility": "public"
          },
          {
            "id": 1899,
            "libraryName": {
              "id": 1896,
              "name": "Counters",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 1511,
              "src": "679:8:15"
            },
            "nodeType": "UsingForDirective",
            "src": "673:36:15",
            "typeName": {
              "id": 1898,
              "nodeType": "UserDefinedTypeName",
              "pathNode": {
                "id": 1897,
                "name": "Counters.Counter",
                "nodeType": "IdentifierPath",
                "referencedDeclaration": 1443,
                "src": "692:16:15"
              },
              "referencedDeclaration": 1443,
              "src": "692:16:15",
              "typeDescriptions": {
                "typeIdentifier": "t_struct$_Counter_$1443_storage_ptr",
                "typeString": "struct Counters.Counter"
              }
            }
          },
          {
            "constant": false,
            "id": 1902,
            "mutability": "mutable",
            "name": "_tokenIds",
            "nameLocation": "739:9:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "714:34:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_struct$_Counter_$1443_storage",
              "typeString": "struct Counters.Counter"
            },
            "typeName": {
              "id": 1901,
              "nodeType": "UserDefinedTypeName",
              "pathNode": {
                "id": 1900,
                "name": "Counters.Counter",
                "nodeType": "IdentifierPath",
                "referencedDeclaration": 1443,
                "src": "714:16:15"
              },
              "referencedDeclaration": 1443,
              "src": "714:16:15",
              "typeDescriptions": {
                "typeIdentifier": "t_struct$_Counter_$1443_storage_ptr",
                "typeString": "struct Counters.Counter"
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "id": 1937,
            "mutability": "mutable",
            "name": "_reservedIds",
            "nameLocation": "774:12:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "754:298:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_array$_t_uint256_$30_storage",
              "typeString": "uint256[30]"
            },
            "typeName": {
              "baseType": {
                "id": 1903,
                "name": "uint256",
                "nodeType": "ElementaryTypeName",
                "src": "754:7:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "id": 1905,
              "length": {
                "hexValue": "3330",
                "id": 1904,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "kind": "number",
                "lValueRequested": false,
                "nodeType": "Literal",
                "src": "762:2:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_30_by_1",
                  "typeString": "int_const 30"
                },
                "value": "30"
              },
              "nodeType": "ArrayTypeName",
              "src": "754:11:15",
              "typeDescriptions": {
                "typeIdentifier": "t_array$_t_uint256_$30_storage_ptr",
                "typeString": "uint256[30]"
              }
            },
            "value": {
              "components": [
                {
                  "hexValue": "31",
                  "id": 1906,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "876:1:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_1_by_1",
                    "typeString": "int_const 1"
                  },
                  "value": "1"
                },
                {
                  "hexValue": "32",
                  "id": 1907,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "881:1:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_2_by_1",
                    "typeString": "int_const 2"
                  },
                  "value": "2"
                },
                {
                  "hexValue": "33",
                  "id": 1908,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "886:1:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_3_by_1",
                    "typeString": "int_const 3"
                  },
                  "value": "3"
                },
                {
                  "hexValue": "37",
                  "id": 1909,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "891:1:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_7_by_1",
                    "typeString": "int_const 7"
                  },
                  "value": "7"
                },
                {
                  "hexValue": "3131",
                  "id": 1910,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "896:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_11_by_1",
                    "typeString": "int_const 11"
                  },
                  "value": "11"
                },
                {
                  "hexValue": "3132",
                  "id": 1911,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "901:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_12_by_1",
                    "typeString": "int_const 12"
                  },
                  "value": "12"
                },
                {
                  "hexValue": "3133",
                  "id": 1912,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "906:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_13_by_1",
                    "typeString": "int_const 13"
                  },
                  "value": "13"
                },
                {
                  "hexValue": "3134",
                  "id": 1913,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "911:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_14_by_1",
                    "typeString": "int_const 14"
                  },
                  "value": "14"
                },
                {
                  "hexValue": "3137",
                  "id": 1914,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "923:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_17_by_1",
                    "typeString": "int_const 17"
                  },
                  "value": "17"
                },
                {
                  "hexValue": "3139",
                  "id": 1915,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "928:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_19_by_1",
                    "typeString": "int_const 19"
                  },
                  "value": "19"
                },
                {
                  "hexValue": "3231",
                  "id": 1916,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "933:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_21_by_1",
                    "typeString": "int_const 21"
                  },
                  "value": "21"
                },
                {
                  "hexValue": "3233",
                  "id": 1917,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "938:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_23_by_1",
                    "typeString": "int_const 23"
                  },
                  "value": "23"
                },
                {
                  "hexValue": "3237",
                  "id": 1918,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "943:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_27_by_1",
                    "typeString": "int_const 27"
                  },
                  "value": "27"
                },
                {
                  "hexValue": "3239",
                  "id": 1919,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "948:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_29_by_1",
                    "typeString": "int_const 29"
                  },
                  "value": "29"
                },
                {
                  "hexValue": "3331",
                  "id": 1920,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "953:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_31_by_1",
                    "typeString": "int_const 31"
                  },
                  "value": "31"
                },
                {
                  "hexValue": "3337",
                  "id": 1921,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "958:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_37_by_1",
                    "typeString": "int_const 37"
                  },
                  "value": "37"
                },
                {
                  "hexValue": "3431",
                  "id": 1922,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "970:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_41_by_1",
                    "typeString": "int_const 41"
                  },
                  "value": "41"
                },
                {
                  "hexValue": "3437",
                  "id": 1923,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "975:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_47_by_1",
                    "typeString": "int_const 47"
                  },
                  "value": "47"
                },
                {
                  "hexValue": "3637",
                  "id": 1924,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "980:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_67_by_1",
                    "typeString": "int_const 67"
                  },
                  "value": "67"
                },
                {
                  "hexValue": "3731",
                  "id": 1925,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "985:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_71_by_1",
                    "typeString": "int_const 71"
                  },
                  "value": "71"
                },
                {
                  "hexValue": "3833",
                  "id": 1926,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "990:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_83_by_1",
                    "typeString": "int_const 83"
                  },
                  "value": "83"
                },
                {
                  "hexValue": "3933",
                  "id": 1927,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "995:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_93_by_1",
                    "typeString": "int_const 93"
                  },
                  "value": "93"
                },
                {
                  "hexValue": "313131",
                  "id": 1928,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1000:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_111_by_1",
                    "typeString": "int_const 111"
                  },
                  "value": "111"
                },
                {
                  "hexValue": "323232",
                  "id": 1929,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1005:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_222_by_1",
                    "typeString": "int_const 222"
                  },
                  "value": "222"
                },
                {
                  "hexValue": "333333",
                  "id": 1930,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1018:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_333_by_1",
                    "typeString": "int_const 333"
                  },
                  "value": "333"
                },
                {
                  "hexValue": "343138",
                  "id": 1931,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1023:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_418_by_1",
                    "typeString": "int_const 418"
                  },
                  "value": "418"
                },
                {
                  "hexValue": "343434",
                  "id": 1932,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1028:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_444_by_1",
                    "typeString": "int_const 444"
                  },
                  "value": "444"
                },
                {
                  "hexValue": "353535",
                  "id": 1933,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1033:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_555_by_1",
                    "typeString": "int_const 555"
                  },
                  "value": "555"
                },
                {
                  "hexValue": "363636",
                  "id": 1934,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1038:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_666_by_1",
                    "typeString": "int_const 666"
                  },
                  "value": "666"
                },
                {
                  "hexValue": "373737",
                  "id": 1935,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "1043:3:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_777_by_1",
                    "typeString": "int_const 777"
                  },
                  "value": "777"
                }
              ],
              "id": 1936,
              "isConstant": false,
              "isInlineArray": true,
              "isLValue": false,
              "isPure": true,
              "lValueRequested": false,
              "nodeType": "TupleExpression",
              "src": "789:263:15",
              "typeDescriptions": {
                "typeIdentifier": "t_array$_t_uint16_$30_memory_ptr",
                "typeString": "uint16[30] memory"
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "id": 1941,
            "mutability": "mutable",
            "name": "_reservedIdsMap",
            "nameLocation": "1092:15:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1059:48:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
              "typeString": "mapping(uint256 => bool)"
            },
            "typeName": {
              "id": 1940,
              "keyType": {
                "id": 1938,
                "name": "uint256",
                "nodeType": "ElementaryTypeName",
                "src": "1067:7:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "1059:24:15",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
                "typeString": "mapping(uint256 => bool)"
              },
              "valueType": {
                "id": 1939,
                "name": "bool",
                "nodeType": "ElementaryTypeName",
                "src": "1078:4:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_bool",
                  "typeString": "bool"
                }
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "functionSelector": "1aae9e03",
            "id": 1945,
            "mutability": "mutable",
            "name": "tokenIdToSpell",
            "nameLocation": "1147:14:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1113:48:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_string_storage_$",
              "typeString": "mapping(uint256 => string)"
            },
            "typeName": {
              "id": 1944,
              "keyType": {
                "id": 1942,
                "name": "uint256",
                "nodeType": "ElementaryTypeName",
                "src": "1121:7:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "1113:26:15",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_string_storage_$",
                "typeString": "mapping(uint256 => string)"
              },
              "valueType": {
                "id": 1943,
                "name": "string",
                "nodeType": "ElementaryTypeName",
                "src": "1132:6:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_storage_ptr",
                  "typeString": "string"
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "id": 1947,
            "mutability": "mutable",
            "name": "_baseTokenURI",
            "nameLocation": "1183:13:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1168:28:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_storage",
              "typeString": "string"
            },
            "typeName": {
              "id": 1946,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "1168:6:15",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "id": 1950,
            "mutability": "mutable",
            "name": "donationAddress",
            "nameLocation": "1253:15:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1237:76:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 1948,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "1237:7:15",
              "stateMutability": "nonpayable",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": {
              "hexValue": "307837634632654262354361353541386264363731413032304638424462414630376636304632364331",
              "id": 1949,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "1271:42:15",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              },
              "value": "0x7cF2eBb5Ca55A8bd671A020F8BDbAF07f60F26C1"
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "id": 1953,
            "mutability": "mutable",
            "name": "donationPercent",
            "nameLocation": "1348:15:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1332:35:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 1951,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "1332:7:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "hexValue": "31",
              "id": 1952,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "1366:1:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_1_by_1",
                "typeString": "int_const 1"
              },
              "value": "1"
            },
            "visibility": "private"
          },
          {
            "constant": true,
            "id": 1956,
            "mutability": "constant",
            "name": "_INTERFACE_ID_ERC2981",
            "nameLocation": "1436:21:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1412:58:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_bytes4",
              "typeString": "bytes4"
            },
            "typeName": {
              "id": 1954,
              "name": "bytes4",
              "nodeType": "ElementaryTypeName",
              "src": "1412:6:15",
              "typeDescriptions": {
                "typeIdentifier": "t_bytes4",
                "typeString": "bytes4"
              }
            },
            "value": {
              "hexValue": "30783261353532303561",
              "id": 1955,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "1460:10:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_710221914_by_1",
                "typeString": "int_const 710221914"
              },
              "value": "0x2a55205a"
            },
            "visibility": "private"
          },
          {
            "constant": true,
            "id": 1959,
            "mutability": "constant",
            "name": "_INTERFACE_ID_ERC721",
            "nameLocation": "1500:20:15",
            "nodeType": "VariableDeclaration",
            "scope": 2323,
            "src": "1476:57:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_bytes4",
              "typeString": "bytes4"
            },
            "typeName": {
              "id": 1957,
              "name": "bytes4",
              "nodeType": "ElementaryTypeName",
              "src": "1476:6:15",
              "typeDescriptions": {
                "typeIdentifier": "t_bytes4",
                "typeString": "bytes4"
              }
            },
            "value": {
              "hexValue": "30783830616335386364",
              "id": 1958,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "1523:10:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_2158778573_by_1",
                "typeString": "int_const 2158778573"
              },
              "value": "0x80ac58cd"
            },
            "visibility": "private"
          },
          {
            "body": {
              "id": 2010,
              "nodeType": "Block",
              "src": "1675:406:15",
              "statements": [
                {
                  "expression": {
                    "id": 1974,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 1972,
                      "name": "_baseTokenURI",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1947,
                      "src": "1685:13:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1973,
                      "name": "baseURI_",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1965,
                      "src": "1701:8:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "1685:24:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1975,
                  "nodeType": "ExpressionStatement",
                  "src": "1685:24:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1977,
                        "name": "_INTERFACE_ID_ERC721",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1959,
                        "src": "1788:20:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      ],
                      "id": 1976,
                      "name": "_registerInterface",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1788,
                      "src": "1769:18:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_bytes4_$returns$__$",
                        "typeString": "function (bytes4)"
                      }
                    },
                    "id": 1978,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1769:40:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1979,
                  "nodeType": "ExpressionStatement",
                  "src": "1769:40:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1981,
                        "name": "_INTERFACE_ID_ERC2981",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1956,
                        "src": "1838:21:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      ],
                      "id": 1980,
                      "name": "_registerInterface",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1788,
                      "src": "1819:18:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_bytes4_$returns$__$",
                        "typeString": "function (bytes4)"
                      }
                    },
                    "id": 1982,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1819:41:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1983,
                  "nodeType": "ExpressionStatement",
                  "src": "1819:41:15"
                },
                {
                  "body": {
                    "id": 2003,
                    "nodeType": "Block",
                    "src": "1949:64:15",
                    "statements": [
                      {
                        "expression": {
                          "id": 2001,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "baseExpression": {
                              "id": 1995,
                              "name": "_reservedIdsMap",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1941,
                              "src": "1963:15:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
                                "typeString": "mapping(uint256 => bool)"
                              }
                            },
                            "id": 1999,
                            "indexExpression": {
                              "baseExpression": {
                                "id": 1996,
                                "name": "_reservedIds",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1937,
                                "src": "1979:12:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_array$_t_uint256_$30_storage",
                                  "typeString": "uint256[30] storage ref"
                                }
                              },
                              "id": 1998,
                              "indexExpression": {
                                "id": 1997,
                                "name": "i",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1985,
                                "src": "1992:1:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "nodeType": "IndexAccess",
                              "src": "1979:15:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": true,
                            "nodeType": "IndexAccess",
                            "src": "1963:32:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "hexValue": "74727565",
                            "id": 2000,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "bool",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "1998:4:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            },
                            "value": "true"
                          },
                          "src": "1963:39:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 2002,
                        "nodeType": "ExpressionStatement",
                        "src": "1963:39:15"
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1991,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1988,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1985,
                      "src": "1919:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "expression": {
                        "id": 1989,
                        "name": "_reservedIds",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1937,
                        "src": "1923:12:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_uint256_$30_storage",
                          "typeString": "uint256[30] storage ref"
                        }
                      },
                      "id": 1990,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "length",
                      "nodeType": "MemberAccess",
                      "src": "1923:19:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1919:23:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 2004,
                  "initializationExpression": {
                    "assignments": [
                      1985
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1985,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "1912:1:15",
                        "nodeType": "VariableDeclaration",
                        "scope": 2004,
                        "src": "1904:9:15",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1984,
                          "name": "uint256",
                          "nodeType": "ElementaryTypeName",
                          "src": "1904:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1987,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1986,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "1916:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "1904:13:15"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1993,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "1944:3:15",
                      "subExpression": {
                        "id": 1992,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1985,
                        "src": "1944:1:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1994,
                    "nodeType": "ExpressionStatement",
                    "src": "1944:3:15"
                  },
                  "nodeType": "ForStatement",
                  "src": "1899:114:15"
                },
                {
                  "expression": {
                    "arguments": [],
                    "expression": {
                      "argumentTypes": [],
                      "expression": {
                        "id": 2005,
                        "name": "_tokenIds",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1902,
                        "src": "2053:9:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_Counter_$1443_storage",
                          "typeString": "struct Counters.Counter storage ref"
                        }
                      },
                      "id": 2007,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "increment",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 1469,
                      "src": "2053:19:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_struct$_Counter_$1443_storage_ptr_$returns$__$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                        "typeString": "function (struct Counters.Counter storage pointer)"
                      }
                    },
                    "id": 2008,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2053:21:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2009,
                  "nodeType": "ExpressionStatement",
                  "src": "2053:21:15"
                }
              ]
            },
            "id": 2011,
            "implemented": true,
            "kind": "constructor",
            "modifiers": [
              {
                "arguments": [
                  {
                    "id": 1968,
                    "name": "name_",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1961,
                    "src": "1659:5:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_memory_ptr",
                      "typeString": "string memory"
                    }
                  },
                  {
                    "id": 1969,
                    "name": "symbol_",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1963,
                    "src": "1666:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_memory_ptr",
                      "typeString": "string memory"
                    }
                  }
                ],
                "id": 1970,
                "kind": "baseConstructorSpecifier",
                "modifierName": {
                  "id": 1967,
                  "name": "ERC721",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 957,
                  "src": "1651:6:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "1651:23:15"
              }
            ],
            "name": "",
            "nameLocation": "-1:-1:-1",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1966,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1961,
                  "mutability": "mutable",
                  "name": "name_",
                  "nameLocation": "1576:5:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2011,
                  "src": "1562:19:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1960,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "1562:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1963,
                  "mutability": "mutable",
                  "name": "symbol_",
                  "nameLocation": "1605:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2011,
                  "src": "1591:21:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1962,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "1591:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1965,
                  "mutability": "mutable",
                  "name": "baseURI_",
                  "nameLocation": "1636:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2011,
                  "src": "1622:22:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1964,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "1622:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1552:98:15"
            },
            "returnParameters": {
              "id": 1971,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1675:0:15"
            },
            "scope": 2323,
            "src": "1541:540:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2043,
              "nodeType": "Block",
              "src": "2180:199:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2026,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "nodeType": "UnaryOperation",
                        "operator": "!",
                        "prefix": true,
                        "src": "2198:18:15",
                        "subExpression": {
                          "arguments": [
                            {
                              "id": 2024,
                              "name": "tokenId_",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2015,
                              "src": "2207:8:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            ],
                            "id": 2023,
                            "name": "_exists",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 565,
                            "src": "2199:7:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_bool_$",
                              "typeString": "function (uint256) view returns (bool)"
                            }
                          },
                          "id": 2025,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2199:17:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4552433732313a20546f6b656e20494420616c7265616479206d696e746564",
                        "id": 2027,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2218:33:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_4a1e787e6c9300109d749bc57a11ac0f4f61a945da0469e79b2b6790785e7589",
                          "typeString": "literal_string \"ERC721: Token ID already minted\""
                        },
                        "value": "ERC721: Token ID already minted"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_4a1e787e6c9300109d749bc57a11ac0f4f61a945da0469e79b2b6790785e7589",
                          "typeString": "literal_string \"ERC721: Token ID already minted\""
                        }
                      ],
                      "id": 2022,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2190:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2028,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2190:62:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2029,
                  "nodeType": "ExpressionStatement",
                  "src": "2190:62:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "baseExpression": {
                          "id": 2031,
                          "name": "_reservedIdsMap",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1941,
                          "src": "2270:15:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
                            "typeString": "mapping(uint256 => bool)"
                          }
                        },
                        "id": 2033,
                        "indexExpression": {
                          "id": 2032,
                          "name": "tokenId_",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2015,
                          "src": "2286:8:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "nodeType": "IndexAccess",
                        "src": "2270:25:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4552433732313a20546f6b656e204944206e6f74207265736572766564",
                        "id": 2034,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2297:31:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_1c2c7d0b3442273531ca7db6f6355720ec7286f878a3a593f7011d0ce5fdeca1",
                          "typeString": "literal_string \"ERC721: Token ID not reserved\""
                        },
                        "value": "ERC721: Token ID not reserved"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_1c2c7d0b3442273531ca7db6f6355720ec7286f878a3a593f7011d0ce5fdeca1",
                          "typeString": "literal_string \"ERC721: Token ID not reserved\""
                        }
                      ],
                      "id": 2030,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2262:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2035,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2262:67:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2036,
                  "nodeType": "ExpressionStatement",
                  "src": "2262:67:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2038,
                        "name": "spell_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2013,
                        "src": "2350:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 2039,
                        "name": "tokenId_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2015,
                        "src": "2358:8:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 2040,
                        "name": "to_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2017,
                        "src": "2368:3:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2037,
                      "name": "_mintSpell",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2313,
                      "src": "2339:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$_t_uint256_$_t_address_$returns$__$",
                        "typeString": "function (string memory,uint256,address)"
                      }
                    },
                    "id": 2041,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2339:33:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2042,
                  "nodeType": "ExpressionStatement",
                  "src": "2339:33:15"
                }
              ]
            },
            "functionSelector": "8e67b39a",
            "id": 2044,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 2020,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 2019,
                  "name": "onlyOwner",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 46,
                  "src": "2170:9:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "2170:9:15"
              }
            ],
            "name": "mintReserved",
            "nameLocation": "2097:12:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2018,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2013,
                  "mutability": "mutable",
                  "name": "spell_",
                  "nameLocation": "2124:6:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2044,
                  "src": "2110:20:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2012,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "2110:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2015,
                  "mutability": "mutable",
                  "name": "tokenId_",
                  "nameLocation": "2140:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2044,
                  "src": "2132:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2014,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "2132:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2017,
                  "mutability": "mutable",
                  "name": "to_",
                  "nameLocation": "2158:3:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2044,
                  "src": "2150:11:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2016,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "2150:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "2109:53:15"
            },
            "returnParameters": {
              "id": 2021,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "2180:0:15"
            },
            "scope": 2323,
            "src": "2088:291:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2117,
              "nodeType": "Block",
              "src": "2437:576:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 2053,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 2050,
                            "name": "msg",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967281,
                            "src": "2455:3:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_message",
                              "typeString": "msg"
                            }
                          },
                          "id": 2051,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "value",
                          "nodeType": "MemberAccess",
                          "src": "2455:9:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">=",
                        "rightExpression": {
                          "id": 2052,
                          "name": "PRICE",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1895,
                          "src": "2468:5:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "2455:18:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4d7573742070617920666f72206d696e74696e67",
                        "id": 2054,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2475:22:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_fccfa08521b2a4f02b9d2ab831967715a908f7cc2cad0af859fbb6558108466d",
                          "typeString": "literal_string \"Must pay for minting\""
                        },
                        "value": "Must pay for minting"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_fccfa08521b2a4f02b9d2ab831967715a908f7cc2cad0af859fbb6558108466d",
                          "typeString": "literal_string \"Must pay for minting\""
                        }
                      ],
                      "id": 2049,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2447:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2055,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2447:51:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2056,
                  "nodeType": "ExpressionStatement",
                  "src": "2447:51:15"
                },
                {
                  "assignments": [
                    2058
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2058,
                      "mutability": "mutable",
                      "name": "tokenId",
                      "nameLocation": "2516:7:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2117,
                      "src": "2508:15:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 2057,
                        "name": "uint256",
                        "nodeType": "ElementaryTypeName",
                        "src": "2508:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2059,
                  "nodeType": "VariableDeclarationStatement",
                  "src": "2508:15:15"
                },
                {
                  "body": {
                    "id": 2092,
                    "nodeType": "Block",
                    "src": "2546:300:15",
                    "statements": [
                      {
                        "expression": {
                          "id": 2065,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "id": 2061,
                            "name": "tokenId",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2058,
                            "src": "2560:7:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "arguments": [],
                            "expression": {
                              "argumentTypes": [],
                              "expression": {
                                "id": 2062,
                                "name": "_tokenIds",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1902,
                                "src": "2570:9:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_struct$_Counter_$1443_storage",
                                  "typeString": "struct Counters.Counter storage ref"
                                }
                              },
                              "id": 2063,
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "current",
                              "nodeType": "MemberAccess",
                              "referencedDeclaration": 1455,
                              "src": "2570:17:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_function_internal_view$_t_struct$_Counter_$1443_storage_ptr_$returns$_t_uint256_$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                                "typeString": "function (struct Counters.Counter storage pointer) view returns (uint256)"
                              }
                            },
                            "id": 2064,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "kind": "functionCall",
                            "lValueRequested": false,
                            "names": [],
                            "nodeType": "FunctionCall",
                            "src": "2570:19:15",
                            "tryCall": false,
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "2560:29:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "id": 2066,
                        "nodeType": "ExpressionStatement",
                        "src": "2560:29:15"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          "id": 2073,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "baseExpression": {
                              "id": 2067,
                              "name": "_reservedIdsMap",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1941,
                              "src": "2607:15:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_mapping$_t_uint256_$_t_bool_$",
                                "typeString": "mapping(uint256 => bool)"
                              }
                            },
                            "id": 2069,
                            "indexExpression": {
                              "id": 2068,
                              "name": "tokenId",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2058,
                              "src": "2623:7:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "IndexAccess",
                            "src": "2607:24:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "||",
                          "rightExpression": {
                            "arguments": [
                              {
                                "id": 2071,
                                "name": "tokenId",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 2058,
                                "src": "2643:7:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              }
                            ],
                            "expression": {
                              "argumentTypes": [
                                {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              ],
                              "id": 2070,
                              "name": "_exists",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 565,
                              "src": "2635:7:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_bool_$",
                                "typeString": "function (uint256) view returns (bool)"
                              }
                            },
                            "id": 2072,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "kind": "functionCall",
                            "lValueRequested": false,
                            "names": [],
                            "nodeType": "FunctionCall",
                            "src": "2635:16:15",
                            "tryCall": false,
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "src": "2607:44:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "falseBody": {
                          "id": 2090,
                          "nodeType": "Block",
                          "src": "2798:38:15",
                          "statements": [
                            {
                              "id": 2089,
                              "nodeType": "Break",
                              "src": "2816:5:15"
                            }
                          ]
                        },
                        "id": 2091,
                        "nodeType": "IfStatement",
                        "src": "2603:233:15",
                        "trueBody": {
                          "id": 2088,
                          "nodeType": "Block",
                          "src": "2653:139:15",
                          "statements": [
                            {
                              "expression": {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2074,
                                    "name": "_tokenIds",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1902,
                                    "src": "2671:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_Counter_$1443_storage",
                                      "typeString": "struct Counters.Counter storage ref"
                                    }
                                  },
                                  "id": 2076,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "increment",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1469,
                                  "src": "2671:19:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_internal_nonpayable$_t_struct$_Counter_$1443_storage_ptr_$returns$__$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                                    "typeString": "function (struct Counters.Counter storage pointer)"
                                  }
                                },
                                "id": 2077,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "2671:21:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_tuple$__$",
                                  "typeString": "tuple()"
                                }
                              },
                              "id": 2078,
                              "nodeType": "ExpressionStatement",
                              "src": "2671:21:15"
                            },
                            {
                              "expression": {
                                "arguments": [
                                  {
                                    "commonType": {
                                      "typeIdentifier": "t_uint256",
                                      "typeString": "uint256"
                                    },
                                    "id": 2084,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "arguments": [],
                                      "expression": {
                                        "argumentTypes": [],
                                        "expression": {
                                          "id": 2080,
                                          "name": "_tokenIds",
                                          "nodeType": "Identifier",
                                          "overloadedDeclarations": [],
                                          "referencedDeclaration": 1902,
                                          "src": "2718:9:15",
                                          "typeDescriptions": {
                                            "typeIdentifier": "t_struct$_Counter_$1443_storage",
                                            "typeString": "struct Counters.Counter storage ref"
                                          }
                                        },
                                        "id": 2081,
                                        "isConstant": false,
                                        "isLValue": true,
                                        "isPure": false,
                                        "lValueRequested": false,
                                        "memberName": "current",
                                        "nodeType": "MemberAccess",
                                        "referencedDeclaration": 1455,
                                        "src": "2718:17:15",
                                        "typeDescriptions": {
                                          "typeIdentifier": "t_function_internal_view$_t_struct$_Counter_$1443_storage_ptr_$returns$_t_uint256_$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                                          "typeString": "function (struct Counters.Counter storage pointer) view returns (uint256)"
                                        }
                                      },
                                      "id": 2082,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": false,
                                      "kind": "functionCall",
                                      "lValueRequested": false,
                                      "names": [],
                                      "nodeType": "FunctionCall",
                                      "src": "2718:19:15",
                                      "tryCall": false,
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_uint256",
                                        "typeString": "uint256"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": "<=",
                                    "rightExpression": {
                                      "id": 2083,
                                      "name": "MAX_SUPPLY",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1888,
                                      "src": "2741:10:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_uint256",
                                        "typeString": "uint256"
                                      }
                                    },
                                    "src": "2718:33:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  {
                                    "hexValue": "546f6b656e20537570706c79204465706c65746564",
                                    "id": 2085,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": true,
                                    "kind": "string",
                                    "lValueRequested": false,
                                    "nodeType": "Literal",
                                    "src": "2753:23:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_stringliteral_87071b775c098f158e75d4151fe00b2f4e6b1c99f64ed70bf38a282a217e04e7",
                                      "typeString": "literal_string \"Token Supply Depleted\""
                                    },
                                    "value": "Token Supply Depleted"
                                  }
                                ],
                                "expression": {
                                  "argumentTypes": [
                                    {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    },
                                    {
                                      "typeIdentifier": "t_stringliteral_87071b775c098f158e75d4151fe00b2f4e6b1c99f64ed70bf38a282a217e04e7",
                                      "typeString": "literal_string \"Token Supply Depleted\""
                                    }
                                  ],
                                  "id": 2079,
                                  "name": "require",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [
                                    4294967278,
                                    4294967278
                                  ],
                                  "referencedDeclaration": 4294967278,
                                  "src": "2710:7:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                                    "typeString": "function (bool,string memory) pure"
                                  }
                                },
                                "id": 2086,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "2710:67:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_tuple$__$",
                                  "typeString": "tuple()"
                                }
                              },
                              "id": 2087,
                              "nodeType": "ExpressionStatement",
                              "src": "2710:67:15"
                            }
                          ]
                        }
                      }
                    ]
                  },
                  "condition": {
                    "hexValue": "74727565",
                    "id": 2060,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "bool",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "2540:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    },
                    "value": "true"
                  },
                  "id": 2093,
                  "nodeType": "WhileStatement",
                  "src": "2533:313:15"
                },
                {
                  "assignments": [
                    2095,
                    null
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2095,
                      "mutability": "mutable",
                      "name": "success",
                      "nameLocation": "2861:7:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2117,
                      "src": "2856:12:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_bool",
                        "typeString": "bool"
                      },
                      "typeName": {
                        "id": 2094,
                        "name": "bool",
                        "nodeType": "ElementaryTypeName",
                        "src": "2856:4:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      "visibility": "internal"
                    },
                    null
                  ],
                  "id": 2104,
                  "initialValue": {
                    "arguments": [
                      {
                        "hexValue": "",
                        "id": 2102,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2907:2:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                          "typeString": "literal_string \"\""
                        },
                        "value": ""
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                          "typeString": "literal_string \"\""
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                            "typeString": "literal_string \"\""
                          }
                        ],
                        "expression": {
                          "arguments": [],
                          "expression": {
                            "argumentTypes": [],
                            "id": 2096,
                            "name": "owner",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 32,
                            "src": "2874:5:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_view$__$returns$_t_address_$",
                              "typeString": "function () view returns (address)"
                            }
                          },
                          "id": 2097,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2874:7:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "id": 2098,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "call",
                        "nodeType": "MemberAccess",
                        "src": "2874:12:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_barecall_payable$_t_bytes_memory_ptr_$returns$_t_bool_$_t_bytes_memory_ptr_$",
                          "typeString": "function (bytes memory) payable returns (bool,bytes memory)"
                        }
                      },
                      "id": 2101,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "names": [
                        "value"
                      ],
                      "nodeType": "FunctionCallOptions",
                      "options": [
                        {
                          "expression": {
                            "id": 2099,
                            "name": "msg",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967281,
                            "src": "2895:3:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_message",
                              "typeString": "msg"
                            }
                          },
                          "id": 2100,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "value",
                          "nodeType": "MemberAccess",
                          "src": "2895:9:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "src": "2874:32:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_barecall_payable$_t_bytes_memory_ptr_$returns$_t_bool_$_t_bytes_memory_ptr_$value",
                        "typeString": "function (bytes memory) payable returns (bool,bytes memory)"
                      }
                    },
                    "id": 2103,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2874:36:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$_t_bool_$_t_bytes_memory_ptr_$",
                      "typeString": "tuple(bool,bytes memory)"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "2855:55:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2106,
                        "name": "success",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2095,
                        "src": "2928:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "5472616e73666572204661696c6564",
                        "id": 2107,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2937:17:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_c5acabcb762867cdbcf367c30c495273eabea012d93b81d74177ab1ef966623f",
                          "typeString": "literal_string \"Transfer Failed\""
                        },
                        "value": "Transfer Failed"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_c5acabcb762867cdbcf367c30c495273eabea012d93b81d74177ab1ef966623f",
                          "typeString": "literal_string \"Transfer Failed\""
                        }
                      ],
                      "id": 2105,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2920:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2108,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2920:35:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2109,
                  "nodeType": "ExpressionStatement",
                  "src": "2920:35:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2111,
                        "name": "spell_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2046,
                        "src": "2976:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 2112,
                        "name": "tokenId",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2058,
                        "src": "2984:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "arguments": [],
                        "expression": {
                          "argumentTypes": [],
                          "id": 2113,
                          "name": "_msgSender",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1427,
                          "src": "2993:10:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_view$__$returns$_t_address_$",
                            "typeString": "function () view returns (address)"
                          }
                        },
                        "id": 2114,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "2993:12:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2110,
                      "name": "_mintSpell",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2313,
                      "src": "2965:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$_t_uint256_$_t_address_$returns$__$",
                        "typeString": "function (string memory,uint256,address)"
                      }
                    },
                    "id": 2115,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2965:41:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2116,
                  "nodeType": "ExpressionStatement",
                  "src": "2965:41:15"
                }
              ]
            },
            "functionSelector": "d85d3d27",
            "id": 2118,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "mint",
            "nameLocation": "2395:4:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2047,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2046,
                  "mutability": "mutable",
                  "name": "spell_",
                  "nameLocation": "2414:6:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2118,
                  "src": "2400:20:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2045,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "2400:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "2399:22:15"
            },
            "returnParameters": {
              "id": 2048,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "2437:0:15"
            },
            "scope": 2323,
            "src": "2386:627:15",
            "stateMutability": "payable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2186,
              "nodeType": "Block",
              "src": "3132:396:15",
              "statements": [
                {
                  "assignments": [
                    2126
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2126,
                      "mutability": "mutable",
                      "name": "b",
                      "nameLocation": "3155:1:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2186,
                      "src": "3142:14:15",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes"
                      },
                      "typeName": {
                        "id": 2125,
                        "name": "bytes",
                        "nodeType": "ElementaryTypeName",
                        "src": "3142:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes_storage_ptr",
                          "typeString": "bytes"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2131,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2129,
                        "name": "str_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2120,
                        "src": "3165:4:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      ],
                      "id": 2128,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "nodeType": "ElementaryTypeNameExpression",
                      "src": "3159:5:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
                        "typeString": "type(bytes storage pointer)"
                      },
                      "typeName": {
                        "id": 2127,
                        "name": "bytes",
                        "nodeType": "ElementaryTypeName",
                        "src": "3159:5:15",
                        "typeDescriptions": {}
                      }
                    },
                    "id": 2130,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "typeConversion",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "3159:11:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_memory_ptr",
                      "typeString": "bytes memory"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "3142:28:15"
                },
                {
                  "assignments": [
                    2133
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2133,
                      "mutability": "mutable",
                      "name": "len",
                      "nameLocation": "3188:3:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2186,
                      "src": "3180:11:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 2132,
                        "name": "uint256",
                        "nodeType": "ElementaryTypeName",
                        "src": "3180:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2136,
                  "initialValue": {
                    "expression": {
                      "id": 2134,
                      "name": "b",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2126,
                      "src": "3194:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "id": 2135,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "length",
                    "nodeType": "MemberAccess",
                    "src": "3194:8:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "3180:22:15"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 2139,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 2137,
                      "name": "len",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2133,
                      "src": "3216:3:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "!=",
                    "rightExpression": {
                      "hexValue": "3130",
                      "id": 2138,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "3223:2:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_10_by_1",
                        "typeString": "int_const 10"
                      },
                      "value": "10"
                    },
                    "src": "3216:9:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 2143,
                  "nodeType": "IfStatement",
                  "src": "3212:60:15",
                  "trueBody": {
                    "id": 2142,
                    "nodeType": "Block",
                    "src": "3227:45:15",
                    "statements": [
                      {
                        "expression": {
                          "hexValue": "66616c7365",
                          "id": 2140,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "bool",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "3256:5:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          "value": "false"
                        },
                        "functionReturnParameters": 2124,
                        "id": 2141,
                        "nodeType": "Return",
                        "src": "3249:12:15"
                      }
                    ]
                  }
                },
                {
                  "body": {
                    "id": 2182,
                    "nodeType": "Block",
                    "src": "3311:190:15",
                    "statements": [
                      {
                        "assignments": [
                          2154
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 2154,
                            "mutability": "mutable",
                            "name": "c",
                            "nameLocation": "3332:1:15",
                            "nodeType": "VariableDeclaration",
                            "scope": 2182,
                            "src": "3325:8:15",
                            "stateVariable": false,
                            "storageLocation": "default",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bytes1",
                              "typeString": "bytes1"
                            },
                            "typeName": {
                              "id": 2153,
                              "name": "bytes1",
                              "nodeType": "ElementaryTypeName",
                              "src": "3325:6:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_bytes1",
                                "typeString": "bytes1"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 2158,
                        "initialValue": {
                          "baseExpression": {
                            "id": 2155,
                            "name": "b",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2126,
                            "src": "3336:1:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bytes_memory_ptr",
                              "typeString": "bytes memory"
                            }
                          },
                          "id": 2157,
                          "indexExpression": {
                            "id": 2156,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2145,
                            "src": "3338:1:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "3336:4:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bytes1",
                            "typeString": "bytes1"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "3325:15:15"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          "id": 2177,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "id": 2167,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "UnaryOperation",
                            "operator": "!",
                            "prefix": true,
                            "src": "3357:25:15",
                            "subExpression": {
                              "components": [
                                {
                                  "commonType": {
                                    "typeIdentifier": "t_bool",
                                    "typeString": "bool"
                                  },
                                  "id": 2165,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "leftExpression": {
                                    "commonType": {
                                      "typeIdentifier": "t_bytes1",
                                      "typeString": "bytes1"
                                    },
                                    "id": 2161,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "id": 2159,
                                      "name": "c",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 2154,
                                      "src": "3359:1:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_bytes1",
                                        "typeString": "bytes1"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": ">=",
                                    "rightExpression": {
                                      "hexValue": "30783631",
                                      "id": 2160,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "number",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "3364:4:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_rational_97_by_1",
                                        "typeString": "int_const 97"
                                      },
                                      "value": "0x61"
                                    },
                                    "src": "3359:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  "nodeType": "BinaryOperation",
                                  "operator": "&&",
                                  "rightExpression": {
                                    "commonType": {
                                      "typeIdentifier": "t_bytes1",
                                      "typeString": "bytes1"
                                    },
                                    "id": 2164,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "id": 2162,
                                      "name": "c",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 2154,
                                      "src": "3372:1:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_bytes1",
                                        "typeString": "bytes1"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": "<=",
                                    "rightExpression": {
                                      "hexValue": "30783741",
                                      "id": 2163,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "number",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "3377:4:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_rational_122_by_1",
                                        "typeString": "int_const 122"
                                      },
                                      "value": "0x7A"
                                    },
                                    "src": "3372:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  "src": "3359:22:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_bool",
                                    "typeString": "bool"
                                  }
                                }
                              ],
                              "id": 2166,
                              "isConstant": false,
                              "isInlineArray": false,
                              "isLValue": false,
                              "isPure": false,
                              "lValueRequested": false,
                              "nodeType": "TupleExpression",
                              "src": "3358:24:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_bool",
                                "typeString": "bool"
                              }
                            },
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "&&",
                          "rightExpression": {
                            "id": 2176,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "UnaryOperation",
                            "operator": "!",
                            "prefix": true,
                            "src": "3410:25:15",
                            "subExpression": {
                              "components": [
                                {
                                  "commonType": {
                                    "typeIdentifier": "t_bool",
                                    "typeString": "bool"
                                  },
                                  "id": 2174,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "leftExpression": {
                                    "commonType": {
                                      "typeIdentifier": "t_bytes1",
                                      "typeString": "bytes1"
                                    },
                                    "id": 2170,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "id": 2168,
                                      "name": "c",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 2154,
                                      "src": "3412:1:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_bytes1",
                                        "typeString": "bytes1"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": ">=",
                                    "rightExpression": {
                                      "hexValue": "30783330",
                                      "id": 2169,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "number",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "3417:4:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_rational_48_by_1",
                                        "typeString": "int_const 48"
                                      },
                                      "value": "0x30"
                                    },
                                    "src": "3412:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  "nodeType": "BinaryOperation",
                                  "operator": "&&",
                                  "rightExpression": {
                                    "commonType": {
                                      "typeIdentifier": "t_bytes1",
                                      "typeString": "bytes1"
                                    },
                                    "id": 2173,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "leftExpression": {
                                      "id": 2171,
                                      "name": "c",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 2154,
                                      "src": "3425:1:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_bytes1",
                                        "typeString": "bytes1"
                                      }
                                    },
                                    "nodeType": "BinaryOperation",
                                    "operator": "<=",
                                    "rightExpression": {
                                      "hexValue": "30783339",
                                      "id": 2172,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "number",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "3430:4:15",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_rational_57_by_1",
                                        "typeString": "int_const 57"
                                      },
                                      "value": "0x39"
                                    },
                                    "src": "3425:9:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_bool",
                                      "typeString": "bool"
                                    }
                                  },
                                  "src": "3412:22:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_bool",
                                    "typeString": "bool"
                                  }
                                }
                              ],
                              "id": 2175,
                              "isConstant": false,
                              "isInlineArray": false,
                              "isLValue": false,
                              "isPure": false,
                              "lValueRequested": false,
                              "nodeType": "TupleExpression",
                              "src": "3411:24:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_bool",
                                "typeString": "bool"
                              }
                            },
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "src": "3357:78:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 2181,
                        "nodeType": "IfStatement",
                        "src": "3354:137:15",
                        "trueBody": {
                          "id": 2180,
                          "nodeType": "Block",
                          "src": "3437:54:15",
                          "statements": [
                            {
                              "expression": {
                                "hexValue": "66616c7365",
                                "id": 2178,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "kind": "bool",
                                "lValueRequested": false,
                                "nodeType": "Literal",
                                "src": "3471:5:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_bool",
                                  "typeString": "bool"
                                },
                                "value": "false"
                              },
                              "functionReturnParameters": 2124,
                              "id": 2179,
                              "nodeType": "Return",
                              "src": "3464:12:15"
                            }
                          ]
                        }
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 2149,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 2147,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2145,
                      "src": "3297:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 2148,
                      "name": "len",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2133,
                      "src": "3301:3:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3297:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 2183,
                  "initializationExpression": {
                    "assignments": [
                      2145
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 2145,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "3294:1:15",
                        "nodeType": "VariableDeclaration",
                        "scope": 2183,
                        "src": "3286:9:15",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 2144,
                          "name": "uint256",
                          "nodeType": "ElementaryTypeName",
                          "src": "3286:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 2146,
                    "nodeType": "VariableDeclarationStatement",
                    "src": "3286:9:15"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 2151,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "3306:3:15",
                      "subExpression": {
                        "id": 2150,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2145,
                        "src": "3306:1:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 2152,
                    "nodeType": "ExpressionStatement",
                    "src": "3306:3:15"
                  },
                  "nodeType": "ForStatement",
                  "src": "3281:220:15"
                },
                {
                  "expression": {
                    "hexValue": "74727565",
                    "id": 2184,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "bool",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "3517:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    },
                    "value": "true"
                  },
                  "functionReturnParameters": 2124,
                  "id": 2185,
                  "nodeType": "Return",
                  "src": "3510:11:15"
                }
              ]
            },
            "functionSelector": "7649d3cb",
            "id": 2187,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "verifySpell",
            "nameLocation": "3073:11:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2121,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2120,
                  "mutability": "mutable",
                  "name": "str_",
                  "nameLocation": "3099:4:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2187,
                  "src": "3085:18:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2119,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "3085:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3084:20:15"
            },
            "returnParameters": {
              "id": 2124,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2123,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2187,
                  "src": "3126:4:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 2122,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "3126:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3125:6:15"
            },
            "scope": 2323,
            "src": "3064:464:15",
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "baseFunctions": [
              125
            ],
            "body": {
              "id": 2220,
              "nodeType": "Block",
              "src": "4131:172:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 2203,
                            "name": "tokenId_",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2190,
                            "src": "4157:8:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          ],
                          "id": 2202,
                          "name": "_exists",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 565,
                          "src": "4149:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_bool_$",
                            "typeString": "function (uint256) view returns (bool)"
                          }
                        },
                        "id": 2204,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "4149:17:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4552433732313a204e6f6e6578697374656e7420546f6b656e204944",
                        "id": 2205,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "4168:30:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_54ec63a34df5f93dcd1e2de2b3cda8a7cad00cf9da902f0e9a30741ff9bcf20d",
                          "typeString": "literal_string \"ERC721: Nonexistent Token ID\""
                        },
                        "value": "ERC721: Nonexistent Token ID"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_54ec63a34df5f93dcd1e2de2b3cda8a7cad00cf9da902f0e9a30741ff9bcf20d",
                          "typeString": "literal_string \"ERC721: Nonexistent Token ID\""
                        }
                      ],
                      "id": 2201,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "4141:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2206,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4141:58:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2207,
                  "nodeType": "ExpressionStatement",
                  "src": "4141:58:15"
                },
                {
                  "expression": {
                    "id": 2210,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2208,
                      "name": "receiver",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2197,
                      "src": "4209:8:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 2209,
                      "name": "donationAddress",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1950,
                      "src": "4220:15:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "src": "4209:26:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "id": 2211,
                  "nodeType": "ExpressionStatement",
                  "src": "4209:26:15"
                },
                {
                  "expression": {
                    "id": 2218,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2212,
                      "name": "donationAmount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2199,
                      "src": "4245:14:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "commonType": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "id": 2217,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "leftExpression": {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 2215,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 2213,
                          "name": "salePrice_",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2192,
                          "src": "4262:10:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "*",
                        "rightExpression": {
                          "id": 2214,
                          "name": "donationPercent",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1953,
                          "src": "4275:15:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "4262:28:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "nodeType": "BinaryOperation",
                      "operator": "/",
                      "rightExpression": {
                        "hexValue": "313030",
                        "id": 2216,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "number",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "4293:3:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_rational_100_by_1",
                          "typeString": "int_const 100"
                        },
                        "value": "100"
                      },
                      "src": "4262:34:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "4245:51:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 2219,
                  "nodeType": "ExpressionStatement",
                  "src": "4245:51:15"
                }
              ]
            },
            "documentation": {
              "id": 2188,
              "nodeType": "StructuredDocumentation",
              "src": "3534:405:15",
              "text": " @dev Called with the sale price to determine how much royalty is owed and to whom.\n @param tokenId_ - the NFT asset queried for royalty information\n @param salePrice_ - the sale price of the NFT asset specified by `tokenId`\n @return receiver - address of who should be sent the royalty payment\n @return donationAmount - the royalty payment amount for `salePrice`"
            },
            "functionSelector": "2a55205a",
            "id": 2221,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "royaltyInfo",
            "nameLocation": "3953:11:15",
            "nodeType": "FunctionDefinition",
            "overrides": {
              "id": 2195,
              "nodeType": "OverrideSpecifier",
              "overrides": [
                {
                  "id": 2194,
                  "name": "IERC2981",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 126,
                  "src": "4048:8:15"
                }
              ],
              "src": "4039:18:15"
            },
            "parameters": {
              "id": 2193,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2190,
                  "mutability": "mutable",
                  "name": "tokenId_",
                  "nameLocation": "3982:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2221,
                  "src": "3974:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2189,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "3974:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2192,
                  "mutability": "mutable",
                  "name": "salePrice_",
                  "nameLocation": "4008:10:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2221,
                  "src": "4000:18:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2191,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4000:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3964:60:15"
            },
            "returnParameters": {
              "id": 2200,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2197,
                  "mutability": "mutable",
                  "name": "receiver",
                  "nameLocation": "4084:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2221,
                  "src": "4076:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2196,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "4076:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2199,
                  "mutability": "mutable",
                  "name": "donationAmount",
                  "nameLocation": "4110:14:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2221,
                  "src": "4102:22:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2198,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4102:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4066:64:15"
            },
            "scope": 2323,
            "src": "3944:359:15",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "baseFunctions": [
              220,
              1768,
              1800
            ],
            "body": {
              "id": 2244,
              "nodeType": "Block",
              "src": "4488:105:15",
              "statements": [
                {
                  "expression": {
                    "commonType": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    },
                    "id": 2242,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "commonType": {
                        "typeIdentifier": "t_bytes4",
                        "typeString": "bytes4"
                      },
                      "id": 2237,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "leftExpression": {
                        "id": 2232,
                        "name": "interfaceId",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2223,
                        "src": "4505:11:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      },
                      "nodeType": "BinaryOperation",
                      "operator": "==",
                      "rightExpression": {
                        "expression": {
                          "arguments": [
                            {
                              "id": 2234,
                              "name": "IERC2981",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 126,
                              "src": "4525:8:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_type$_t_contract$_IERC2981_$126_$",
                                "typeString": "type(contract IERC2981)"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_type$_t_contract$_IERC2981_$126_$",
                                "typeString": "type(contract IERC2981)"
                              }
                            ],
                            "id": 2233,
                            "name": "type",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967269,
                            "src": "4520:4:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_metatype_pure$__$returns$__$",
                              "typeString": "function () pure"
                            }
                          },
                          "id": 2235,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "4520:14:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_meta_type_t_contract$_IERC2981_$126",
                            "typeString": "type(contract IERC2981)"
                          }
                        },
                        "id": 2236,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "interfaceId",
                        "nodeType": "MemberAccess",
                        "src": "4520:26:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes4",
                          "typeString": "bytes4"
                        }
                      },
                      "src": "4505:41:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_bool",
                        "typeString": "bool"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "||",
                    "rightExpression": {
                      "arguments": [
                        {
                          "id": 2240,
                          "name": "interfaceId",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2223,
                          "src": "4574:11:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bytes4",
                            "typeString": "bytes4"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_bytes4",
                            "typeString": "bytes4"
                          }
                        ],
                        "expression": {
                          "id": 2238,
                          "name": "super",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967271,
                          "src": "4550:5:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_super$_ClavesAngelicae_$2323_$",
                            "typeString": "type(contract super ClavesAngelicae)"
                          }
                        },
                        "id": 2239,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "supportsInterface",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 1768,
                        "src": "4550:23:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_internal_view$_t_bytes4_$returns$_t_bool_$",
                          "typeString": "function (bytes4) view returns (bool)"
                        }
                      },
                      "id": 2241,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "4550:36:15",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bool",
                        "typeString": "bool"
                      }
                    },
                    "src": "4505:81:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "functionReturnParameters": 2231,
                  "id": 2243,
                  "nodeType": "Return",
                  "src": "4498:88:15"
                }
              ]
            },
            "functionSelector": "01ffc9a7",
            "id": 2245,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "supportsInterface",
            "nameLocation": "4319:17:15",
            "nodeType": "FunctionDefinition",
            "overrides": {
              "id": 2228,
              "nodeType": "OverrideSpecifier",
              "overrides": [
                {
                  "id": 2225,
                  "name": "ERC721",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 957,
                  "src": "4419:6:15"
                },
                {
                  "id": 2226,
                  "name": "IERC165",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1801,
                  "src": "4427:7:15"
                },
                {
                  "id": 2227,
                  "name": "ERC165Storage",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1789,
                  "src": "4436:13:15"
                }
              ],
              "src": "4409:46:15"
            },
            "parameters": {
              "id": 2224,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2223,
                  "mutability": "mutable",
                  "name": "interfaceId",
                  "nameLocation": "4344:11:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2245,
                  "src": "4337:18:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes4",
                    "typeString": "bytes4"
                  },
                  "typeName": {
                    "id": 2222,
                    "name": "bytes4",
                    "nodeType": "ElementaryTypeName",
                    "src": "4337:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes4",
                      "typeString": "bytes4"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4336:20:15"
            },
            "returnParameters": {
              "id": 2231,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2230,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2245,
                  "src": "4474:4:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 2229,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "4474:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4464:20:15"
            },
            "scope": 2323,
            "src": "4310:283:15",
            "stateMutability": "view",
            "virtual": true,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2256,
              "nodeType": "Block",
              "src": "4658:38:15",
              "statements": [
                {
                  "expression": {
                    "id": 2254,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2252,
                      "name": "donationAddress",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1950,
                      "src": "4668:15:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 2253,
                      "name": "to_",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2247,
                      "src": "4686:3:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "src": "4668:21:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "id": 2255,
                  "nodeType": "ExpressionStatement",
                  "src": "4668:21:15"
                }
              ]
            },
            "functionSelector": "6f48e79b",
            "id": 2257,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 2250,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 2249,
                  "name": "onlyOwner",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 46,
                  "src": "4648:9:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "4648:9:15"
              }
            ],
            "name": "setDonationAddress",
            "nameLocation": "4609:18:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2248,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2247,
                  "mutability": "mutable",
                  "name": "to_",
                  "nameLocation": "4636:3:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2257,
                  "src": "4628:11:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2246,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "4628:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4627:13:15"
            },
            "returnParameters": {
              "id": 2251,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4658:0:15"
            },
            "scope": 2323,
            "src": "4600:96:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2268,
              "nodeType": "Block",
              "src": "4766:43:15",
              "statements": [
                {
                  "expression": {
                    "id": 2266,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2264,
                      "name": "donationPercent",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1953,
                      "src": "4776:15:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 2265,
                      "name": "percent_",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2259,
                      "src": "4794:8:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "4776:26:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 2267,
                  "nodeType": "ExpressionStatement",
                  "src": "4776:26:15"
                }
              ]
            },
            "functionSelector": "87a89091",
            "id": 2269,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 2262,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 2261,
                  "name": "onlyOwner",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 46,
                  "src": "4756:9:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "4756:9:15"
              }
            ],
            "name": "setDonationPercent",
            "nameLocation": "4712:18:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2260,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2259,
                  "mutability": "mutable",
                  "name": "percent_",
                  "nameLocation": "4739:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2269,
                  "src": "4731:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2258,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4731:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4730:18:15"
            },
            "returnParameters": {
              "id": 2263,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4766:0:15"
            },
            "scope": 2323,
            "src": "4703:106:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2278,
              "nodeType": "Block",
              "src": "4871:43:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [],
                    "expression": {
                      "argumentTypes": [],
                      "expression": {
                        "id": 2274,
                        "name": "_tokenIds",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1902,
                        "src": "4888:9:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_Counter_$1443_storage",
                          "typeString": "struct Counters.Counter storage ref"
                        }
                      },
                      "id": 2275,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "current",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 1455,
                      "src": "4888:17:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_view$_t_struct$_Counter_$1443_storage_ptr_$returns$_t_uint256_$bound_to$_t_struct$_Counter_$1443_storage_ptr_$",
                        "typeString": "function (struct Counters.Counter storage pointer) view returns (uint256)"
                      }
                    },
                    "id": 2276,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4888:19:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 2273,
                  "id": 2277,
                  "nodeType": "Return",
                  "src": "4881:26:15"
                }
              ]
            },
            "functionSelector": "18160ddd",
            "id": 2279,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "totalSupply",
            "nameLocation": "4825:11:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2270,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4836:2:15"
            },
            "returnParameters": {
              "id": 2273,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2272,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2279,
                  "src": "4862:7:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2271,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4862:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4861:9:15"
            },
            "scope": 2323,
            "src": "4816:98:15",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 2312,
              "nodeType": "Block",
              "src": "5002:196:15",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 2290,
                            "name": "spell_",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2281,
                            "src": "5032:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_string_memory_ptr",
                              "typeString": "string memory"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_string_memory_ptr",
                              "typeString": "string memory"
                            }
                          ],
                          "id": 2289,
                          "name": "verifySpell",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2187,
                          "src": "5020:11:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_pure$_t_string_memory_ptr_$returns$_t_bool_$",
                            "typeString": "function (string memory) pure returns (bool)"
                          }
                        },
                        "id": 2291,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "5020:19:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "5370656c6c206d757374206265202f5b612d7a302d395d7b31307d2f",
                        "id": 2292,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "5041:30:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_aba60cc965cfe1c7515403b444382e9ca8447d0e21230479a8ddb6f5870b1445",
                          "typeString": "literal_string \"Spell must be /[a-z0-9]{10}/\""
                        },
                        "value": "Spell must be /[a-z0-9]{10}/"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_aba60cc965cfe1c7515403b444382e9ca8447d0e21230479a8ddb6f5870b1445",
                          "typeString": "literal_string \"Spell must be /[a-z0-9]{10}/\""
                        }
                      ],
                      "id": 2288,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "5012:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2293,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5012:60:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2294,
                  "nodeType": "ExpressionStatement",
                  "src": "5012:60:15"
                },
                {
                  "expression": {
                    "id": 2299,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "id": 2295,
                        "name": "tokenIdToSpell",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1945,
                        "src": "5082:14:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_uint256_$_t_string_storage_$",
                          "typeString": "mapping(uint256 => string storage ref)"
                        }
                      },
                      "id": 2297,
                      "indexExpression": {
                        "id": 2296,
                        "name": "tokenId_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2283,
                        "src": "5097:8:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "5082:24:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 2298,
                      "name": "spell_",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2281,
                      "src": "5109:6:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "5082:33:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 2300,
                  "nodeType": "ExpressionStatement",
                  "src": "5082:33:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2302,
                        "name": "to_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2285,
                        "src": "5135:3:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2303,
                        "name": "tokenId_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2283,
                        "src": "5140:8:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 2301,
                      "name": "_safeMint",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        621,
                        650
                      ],
                      "referencedDeclaration": 621,
                      "src": "5125:9:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        "typeString": "function (address,uint256)"
                      }
                    },
                    "id": 2304,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5125:24:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2305,
                  "nodeType": "ExpressionStatement",
                  "src": "5125:24:15"
                },
                {
                  "eventCall": {
                    "arguments": [
                      {
                        "id": 2307,
                        "name": "tokenId_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2283,
                        "src": "5169:8:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 2308,
                        "name": "spell_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2281,
                        "src": "5179:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 2309,
                        "name": "to_",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2285,
                        "src": "5187:3:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2306,
                      "name": "Mint",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1885,
                      "src": "5164:4:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_string_memory_ptr_$_t_address_$returns$__$",
                        "typeString": "function (uint256,string memory,address)"
                      }
                    },
                    "id": 2310,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5164:27:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2311,
                  "nodeType": "EmitStatement",
                  "src": "5159:32:15"
                }
              ]
            },
            "id": 2313,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "_mintSpell",
            "nameLocation": "4930:10:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2286,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2281,
                  "mutability": "mutable",
                  "name": "spell_",
                  "nameLocation": "4955:6:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2313,
                  "src": "4941:20:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2280,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "4941:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2283,
                  "mutability": "mutable",
                  "name": "tokenId_",
                  "nameLocation": "4971:8:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2313,
                  "src": "4963:16:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2282,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4963:7:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2285,
                  "mutability": "mutable",
                  "name": "to_",
                  "nameLocation": "4989:3:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2313,
                  "src": "4981:11:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2284,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "4981:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4940:53:15"
            },
            "returnParameters": {
              "id": 2287,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "5002:0:15"
            },
            "scope": 2323,
            "src": "4921:277:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "private"
          },
          {
            "baseFunctions": [
              343
            ],
            "body": {
              "id": 2321,
              "nodeType": "Block",
              "src": "5280:37:15",
              "statements": [
                {
                  "expression": {
                    "id": 2319,
                    "name": "_baseTokenURI",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1947,
                    "src": "5297:13:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "functionReturnParameters": 2318,
                  "id": 2320,
                  "nodeType": "Return",
                  "src": "5290:20:15"
                }
              ]
            },
            "id": 2322,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "_baseURI",
            "nameLocation": "5214:8:15",
            "nodeType": "FunctionDefinition",
            "overrides": {
              "id": 2315,
              "nodeType": "OverrideSpecifier",
              "overrides": [],
              "src": "5247:8:15"
            },
            "parameters": {
              "id": 2314,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "5222:2:15"
            },
            "returnParameters": {
              "id": 2318,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2317,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2322,
                  "src": "5265:13:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 2316,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "5265:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5264:15:15"
            },
            "scope": 2323,
            "src": "5205:112:15",
            "stateMutability": "view",
            "virtual": true,
            "visibility": "internal"
          }
        ],
        "scope": 2324,
        "src": "404:4915:15",
        "usedErrors": []
      }
    ],
    "src": "32:5289:15"
  },
  "compiler": {
    "name": "solc",
    "version": "0.8.10+commit.fc410830.Emscripten.clang"
  },
  "networks": {
    "4": {
      "events": {},
      "links": {},
      "address": "0x7b1E3A3117d7A1188723699cc5229c972D8d2B6a",
      "transactionHash": "0xf3e1047b25954a3ee16d2df76e976ba2e8dfdd8d028078dec2bc108d80e1eff7"
    },
    "5777": {
      "events": {
        "0x8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925": {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "approved",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "tokenId",
              "type": "uint256"
            }
          ],
          "name": "Approval",
          "type": "event"
        },
        "0x17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31": {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "operator",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "approved",
              "type": "bool"
            }
          ],
          "name": "ApprovalForAll",
          "type": "event"
        },
        "0x983d37d8751fcfa80e95e5fe2c0f46fb7b541b280961dc7ac00aa2670e2edd87": {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "tokenId",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "string",
              "name": "spell",
              "type": "string"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "to",
              "type": "address"
            }
          ],
          "name": "Mint",
          "type": "event"
        },
        "0x8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0": {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousOwner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
        },
        "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef": {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "uint256",
              "name": "tokenId",
              "type": "uint256"
            }
          ],
          "name": "Transfer",
          "type": "event"
        }
      },
      "links": {},
      "address": "0x710c3F093Ad241fe32c5dDcdB0B85cD602C31A42",
      "transactionHash": "0x77e252d098c5fddf630349d08d67a82f2ef3cf19cb21dd6de98bab4b488d81f1"
    },
    "1639174202970": {
      "events": {},
      "links": {},
      "address": "0x49455287eBCC42a875B40724C62519D03e2EDcff",
      "transactionHash": "0x73339a431126b2bcbc3e9137c25797c8040372c5c655411de19d12b8b859f288"
    },
    "1639176304276": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x9c0960f767115e34e4f5a210f09217eddadcf86f1f94bfec16560e6e2e8d91f0"
    },
    "1639176477171": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x9c0960f767115e34e4f5a210f09217eddadcf86f1f94bfec16560e6e2e8d91f0"
    },
    "1639270629958": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x9c0960f767115e34e4f5a210f09217eddadcf86f1f94bfec16560e6e2e8d91f0"
    },
    "1639429126594": {
      "events": {},
      "links": {},
      "address": "0x457f0f599CC62A41B221cC94bC9d5Cf0012D21A8",
      "transactionHash": "0x8e2a682de11bd3ef643f44d7f03f03be8524976e2291dcedecd8a3eec52f2868"
    },
    "1639436090285": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x38499cf42c2a7cc9bdcde89bbd250ff70a1ef6c7644f2eef4cd70f2c78443de0"
    },
    "1639436472607": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x6e9c04e22cb06044867bf31833f0ac456aa57df2dbe84bd131122a6901b3284a"
    },
    "1639443622189": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x001d49e34f23830b7dc467ccb7e74a5159095a595a13ee40c507dc4f140dbe4d"
    },
    "1639445622440": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x001d49e34f23830b7dc467ccb7e74a5159095a595a13ee40c507dc4f140dbe4d"
    },
    "1639446184313": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0xd4388bc263816d0c4b308af68bcb6cc8439e72973c4fbc07ddb88f1b1a373125"
    },
    "1639446654085": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0xc7c69a1431b9c4be277e1d8cd84fc9d6d69da9b0638c7bc2e346f4dec2bc80fd"
    },
    "1639450344386": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x00d5f1d72472ac2e2c5e991dbbe81b5fc7c19dbc6ae782c896edd5871b6511af"
    },
    "1639462973863": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x00d5f1d72472ac2e2c5e991dbbe81b5fc7c19dbc6ae782c896edd5871b6511af"
    },
    "1639463068095": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x4be395c7c6a2b010160fec224d7d6b60acc796bd81cb79c10826d45cc1f47c58"
    },
    "1639463319732": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x185d0a5f517e6fb6026fa57a451ca1a2c59b551ebb713d5fd9fff24a36db8d49"
    },
    "1639463622918": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x5978cd6d275c719dbdc255f939fed69ec9899c62d0a4bdc63ef6d67432414314"
    },
    "1639463676137": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0xb42aa1396475f5183a28a269d595362aa0d1f55f72152b3ac2b68cfcf5a6569e"
    },
    "1639464901525": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x2b0849503ad704e5ecdb0a23007b09f67cc994326c240a51bb10014eb298423c"
    },
    "1639464933084": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x600f1c8f2262184dc10d404292ef8bed1ac2f940cc8cbddb3a28c75ac592e7a3"
    },
    "1639466607484": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x7d4ace119e45622ce3026f80d5b7fcdaf75a9aefc5ed974bbf32f05f0d82eef3"
    },
    "1639468178286": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x58c37c20796c27a673246d3fc6fcb0aa88efa22c48235737d8c57248fc9f72b2"
    },
    "1639468801022": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0xec6d96dd944590aca333f582572a2f1597cb2b78f2c94fe1f48559bf0da57411"
    },
    "1639517560057": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x125137037c217aa02ffc0b063259a0f41e0b6206b7eb885ea9e7f0990849185d"
    },
    "1639518747082": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0xbb15da21282f78ab45777d3d7097e00fc3f71aefdb76ddcf4a632cdff5a11e04"
    },
    "1639520134875": {
      "events": {},
      "links": {},
      "address": "0xe982E462b094850F12AF94d21D470e21bE9D0E9C",
      "transactionHash": "0x6b497a06f3effc2d1277cd08f7475d449100b04171ab9c284e47a35f4fe87512"
    },
    "1639521445894": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0xd3f0708bb5db0ddf5a30e56ab7c77b7c2afdf8a1e1f10114c1a9faaf87eb9822"
    },
    "1639523633136": {
      "events": {},
      "links": {},
      "address": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
      "transactionHash": "0x2ced8d841a006cc7ac602ee2aeee401f830b8a9bf761287c388db4f58e8bd39e"
    }
  },
  "schemaVersion": "3.4.3",
  "updatedAt": "2021-12-14T23:32:57.977Z",
  "networkType": "ethereum",
  "devdoc": {
    "kind": "dev",
    "methods": {
      "approve(address,uint256)": {
        "details": "See {IERC721-approve}."
      },
      "balanceOf(address)": {
        "details": "See {IERC721-balanceOf}."
      },
      "getApproved(uint256)": {
        "details": "See {IERC721-getApproved}."
      },
      "isApprovedForAll(address,address)": {
        "details": "See {IERC721-isApprovedForAll}."
      },
      "name()": {
        "details": "See {IERC721Metadata-name}."
      },
      "owner()": {
        "details": "Returns the address of the current owner."
      },
      "ownerOf(uint256)": {
        "details": "See {IERC721-ownerOf}."
      },
      "renounceOwnership()": {
        "details": "Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner."
      },
      "royaltyInfo(uint256,uint256)": {
        "details": "Called with the sale price to determine how much royalty is owed and to whom.",
        "params": {
          "salePrice_": "- the sale price of the NFT asset specified by `tokenId`",
          "tokenId_": "- the NFT asset queried for royalty information"
        },
        "returns": {
          "donationAmount": "- the royalty payment amount for `salePrice`",
          "receiver": "- address of who should be sent the royalty payment"
        }
      },
      "safeTransferFrom(address,address,uint256)": {
        "details": "See {IERC721-safeTransferFrom}."
      },
      "safeTransferFrom(address,address,uint256,bytes)": {
        "details": "See {IERC721-safeTransferFrom}."
      },
      "setApprovalForAll(address,bool)": {
        "details": "See {IERC721-setApprovalForAll}."
      },
      "symbol()": {
        "details": "See {IERC721Metadata-symbol}."
      },
      "tokenURI(uint256)": {
        "details": "See {IERC721Metadata-tokenURI}."
      },
      "transferFrom(address,address,uint256)": {
        "details": "See {IERC721-transferFrom}."
      },
      "transferOwnership(address)": {
        "details": "Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner."
      }
    },
    "version": 1
  },
  "userdoc": {
    "kind": "user",
    "methods": {},
    "version": 1
  }
}